import * as n from "react";
import { Component as cr, useState as D, useRef as L, useEffect as Z, useLayoutEffect as Be, isValidElement as ln, cloneElement as oa, forwardRef as Vr, useContext as Dn, createContext as An, useMemo as we, useCallback as oe, Fragment as Qr, Children as Yn, createRef as Jr } from "react";
import { a as Zr, t as ir, b as es, f as ts } from "./format-BpCURHRA.js";
import { createPortal as ns } from "react-dom";
const as = "_page_qrul2_5", rs = "_inner_qrul2_18", ss = "_pageScroll_qrul2_31", os = "_innerScroll_qrul2_32", fn = {
  page: as,
  inner: rs,
  pageScroll: ss,
  innerScroll: os
};
function ls({
  gnbHeight: e = 64,
  minWidth: t = 1024,
  scroll: a = "grid",
  className: r = "",
  style: s,
  children: o
}) {
  const l = a === "page";
  return /* @__PURE__ */ n.createElement(
    "main",
    {
      className: [fn.page, l && fn.pageScroll, "axe-page", r].filter(Boolean).join(" "),
      style: { height: `calc(100vh - ${e}px)`, ...s }
    },
    /* @__PURE__ */ n.createElement("div", { className: [fn.inner, l && fn.innerScroll].filter(Boolean).join(" "), style: { minWidth: t } }, o)
  );
}
const cs = "_body_1wgsn_4", is = {
  body: cs
};
function Qg({ className: e = "", style: t, children: a }) {
  return /* @__PURE__ */ n.createElement("div", { className: [is.body, "axe-page-body", e].filter(Boolean).join(" "), style: t }, a);
}
const us = "_orbitPortalRoot_177qv_2", ms = {
  orbitPortalRoot: us
};
class Gt extends cr {
  constructor() {
    super(...arguments), this.getPortalRoot = () => {
      const t = this.props.portalClassName || ms.orbitPortalRoot, a = Array.from(document.body.childNodes).find((r) => r.className === t);
      if (!a) {
        const r = document.createElement("div");
        return r.className = t, document.body.appendChild(r), r;
      }
      return a;
    };
  }
  render() {
    return ns(this.props.children, this.getPortalRoot());
  }
}
const ds = "_anchor_7h2m7_2", fs = "_tip_7h2m7_5", ya = {
  anchor: ds,
  tip: fs
};
let _s = 0;
function jt({
  content: e,
  children: t,
  placement: a = "bottom",
  delay: r = 250,
  focusable: s,
  describe: o = !0,
  className: l = "",
  keepWrapper: c
}) {
  const [i, m] = D(!1), [u, f] = D({ top: 0, left: 0 }), y = L(null), _ = L(null), p = L(null), d = L("");
  d.current || (d.current = `axe-tip-${++_s}`);
  const b = () => {
    p.current && (clearTimeout(p.current), p.current = null);
  }, N = (E) => {
    b(), E <= 0 ? m(!0) : p.current = setTimeout(() => m(!0), E);
  }, w = () => {
    b(), m(!1);
  };
  Z(() => b, []), Be(() => {
    if (!i) return;
    const E = () => {
      const h = y.current, g = _.current;
      if (!h || !g) return;
      const $ = h.getBoundingClientRect(), A = g.offsetHeight, M = g.offsetWidth;
      let T = a === "top" ? $.top - A - 6 : $.bottom + 6;
      a === "bottom" && T + A > window.innerHeight - 4 && $.top - A - 6 > 4 && (T = $.top - A - 6), a === "top" && T < 4 && $.bottom + 6 + A < window.innerHeight - 4 && (T = $.bottom + 6);
      const I = Math.max(4, Math.min($.left + $.width / 2 - M / 2, window.innerWidth - M - 4));
      f((q) => q.top === T && q.left === I ? q : { top: T, left: I });
    };
    return E(), window.addEventListener("resize", E), window.addEventListener("scroll", E, !0), () => {
      window.removeEventListener("resize", E), window.removeEventListener("scroll", E, !0);
    };
  }, [i, a, e]), Z(() => {
    if (!i) return;
    const E = (h) => {
      h.key !== "Escape" || h.isComposing || (h.preventDefault(), h.stopPropagation(), w());
    };
    return document.addEventListener("keydown", E, !0), () => document.removeEventListener("keydown", E, !0);
  }, [i]);
  const k = e != null && e !== !1 && e !== "";
  if (!k && !c) return t;
  const x = k && ln(t) ? oa(t, i && o ? { "aria-describedby": d.current } : {}) : t;
  return /* @__PURE__ */ n.createElement(
    "span",
    {
      ref: y,
      className: [ya.anchor, l].filter(Boolean).join(" "),
      tabIndex: s ? 0 : void 0,
      onMouseEnter: () => {
        k && N(r);
      },
      onMouseLeave: w,
      onFocus: () => {
        k && N(0);
      },
      onBlur: w
    },
    x,
    k && i && /* @__PURE__ */ n.createElement(Gt, null, /* @__PURE__ */ n.createElement(
      "div",
      {
        ref: _,
        id: d.current,
        role: "tooltip",
        className: ya.tip,
        style: { top: u.top, left: u.left },
        onMouseEnter: b,
        onMouseLeave: w
      },
      e
    ))
  );
}
const ps = "_bar_gkpv7_1", ys = "_menu_gkpv7_17", bs = "_title_gkpv7_27", Es = "_info_gkpv7_29", hs = "_badge_gkpv7_37", gs = "_badge_muted_gkpv7_38", vs = "_badge_ok_gkpv7_39", ks = "_badge_warn_gkpv7_40", ws = "_meta_gkpv7_42", Ns = "_actions_gkpv7_26", $s = "_notice_gkpv7_59", xs = "_notice_info_gkpv7_65", Ds = "_notice_ok_gkpv7_66", As = "_notice_err_gkpv7_67", Ge = {
  bar: ps,
  menu: ys,
  title: bs,
  info: Es,
  badge: hs,
  badge_muted: gs,
  badge_ok: vs,
  badge_warn: ks,
  meta: ws,
  actions: Ns,
  notice: $s,
  notice_info: xs,
  notice_ok: Ds,
  notice_err: As
};
function Cs({
  title: e,
  onMenu: t,
  info: a,
  badge: r,
  meta: s,
  notice: o,
  children: l
}) {
  var c;
  return /* @__PURE__ */ n.createElement("header", { className: Ge.bar }, t && /* @__PURE__ */ n.createElement("button", { type: "button", className: Ge.menu, "aria-label": "메뉴", onClick: t }, "☰"), /* @__PURE__ */ n.createElement("h1", { className: Ge.title }, e), a && /* @__PURE__ */ n.createElement(jt, { content: a, focusable: !0, describe: !1 }, /* @__PURE__ */ n.createElement("span", { className: Ge.info, role: "img", "aria-label": `안내: ${typeof a == "string" ? a : "자세히"}` }, "i")), (Array.isArray(r) ? r : [r]).filter(Boolean).map((i, m) => {
    var u;
    return /* @__PURE__ */ n.createElement("span", { key: m, className: [Ge.badge, Ge[`badge_${(u = i.tone) != null ? u : "muted"}`]].join(" ") }, i.label);
  }), s && /* @__PURE__ */ n.createElement("span", { className: Ge.meta }, s), /* @__PURE__ */ n.createElement("span", { className: Ge.actions }, o && o.text && /* @__PURE__ */ n.createElement("span", { className: [Ge.notice, Ge[`notice_${(c = o.tone) != null ? c : "info"}`]].join(" "), role: o.tone === "err" ? "alert" : "status" }, o.text), l));
}
const Ss = "_btn_a0orf_1", Ms = "_sm_a0orf_18", Ts = "_primary_a0orf_21", qs = "_dark_a0orf_23", Bs = "_danger_a0orf_25", Ls = "_soon_a0orf_29", js = "_soonTag_a0orf_30", Rs = "_blocked_a0orf_39", Is = "_kbd_a0orf_51", Os = "_iconBtn_a0orf_54", Ps = "_link_a0orf_70", it = {
  btn: Ss,
  sm: Ms,
  primary: Ts,
  dark: qs,
  danger: Bs,
  soon: Ls,
  soonTag: js,
  blocked: Rs,
  kbd: Is,
  iconBtn: Os,
  link: Ps
}, mt = Vr(function(t, a) {
  const {
    variant: r = "default",
    size: s = "md",
    kbd: o,
    soon: l,
    blockedReason: c,
    children: i,
    className: m = "",
    type: u = "button",
    onClick: f,
    title: y,
    disabled: _,
    ...p
  } = t, d = l || c || "", b = d !== "", N = "blockedReason" in t, w = /* @__PURE__ */ n.createElement(
    "button",
    {
      ref: a,
      type: u,
      className: [it.btn, it[r], s === "sm" ? it.sm : "", l ? it.soon : b ? it.blocked : "", m].filter(Boolean).join(" "),
      "aria-disabled": b ? !0 : void 0,
      disabled: b ? void 0 : _,
      title: b ? void 0 : y,
      onClick: b ? (k) => k.preventDefault() : f,
      ...p
    },
    i,
    o && /* @__PURE__ */ n.createElement("kbd", { className: it.kbd }, o),
    l && /* @__PURE__ */ n.createElement("em", { className: it.soonTag }, "준비 중")
  );
  return b || N ? /* @__PURE__ */ n.createElement(jt, { content: d, keepWrapper: N }, w) : w;
});
function Vn({ label: e, children: t, className: a = "", type: r = "button", ...s }) {
  return /* @__PURE__ */ n.createElement(jt, { content: e, describe: !1 }, /* @__PURE__ */ n.createElement(
    "button",
    {
      type: r,
      className: [it.iconBtn, a].filter(Boolean).join(" "),
      "aria-label": e,
      ...s
    },
    t
  ));
}
function la({ children: e, className: t = "", type: a = "button", ...r }) {
  return /* @__PURE__ */ n.createElement("button", { type: a, className: [it.link, t].filter(Boolean).join(" "), ...r }, e);
}
const Xs = "_wrap_10shm_1", zs = "_btn_10shm_2", Fs = "_on_10shm_6", Ws = "_caret_10shm_8", Hs = "_pop_10shm_9", Ks = "_sec_10shm_14", Us = "_item_10shm_17", Gs = "_danger_10shm_24", _t = {
  wrap: Xs,
  btn: zs,
  on: Fs,
  caret: Ws,
  pop: Hs,
  sec: Ks,
  item: Us,
  danger: Gs
}, Ys = (e, t, a, r = {}) => ({ kind: "item", key: e, label: t, onClick: a, ...r }), Jg = (e, t, a) => ({ kind: "section", key: e, label: t, note: a });
function Vs({ label: e, entries: t, disabled: a, title: r }) {
  const [s, o] = D(!1), l = L(null), c = L(null), i = L(null), m = () => {
    var f, y;
    return Array.from((y = (f = i.current) == null ? void 0 : f.querySelectorAll("[role=menuitem]:not(:disabled)")) != null ? y : []);
  };
  Z(() => {
    var f;
    s && ((f = m()[0]) == null || f.focus());
  }, [s]), Z(() => {
    if (!s) return;
    const f = (_) => {
      l.current && !l.current.contains(_.target) && o(!1);
    }, y = (_) => {
      var p;
      _.key !== "Escape" || _.isComposing || (_.preventDefault(), _.stopPropagation(), o(!1), (p = c.current) == null || p.focus());
    };
    return document.addEventListener("mousedown", f), document.addEventListener("keydown", y, !0), () => {
      document.removeEventListener("mousedown", f), document.removeEventListener("keydown", y, !0);
    };
  }, [s]);
  const u = (f) => {
    const y = m();
    if (y.length === 0) return;
    const _ = y.indexOf(document.activeElement);
    let p = -1;
    if (f.key === "ArrowDown") p = (_ + 1) % y.length;
    else if (f.key === "ArrowUp") p = (_ <= 0 ? y.length : _) - 1;
    else if (f.key === "Home") p = 0;
    else if (f.key === "End") p = y.length - 1;
    else if (f.key === "Tab") {
      o(!1);
      return;
    } else return;
    f.preventDefault(), y[p].focus();
  };
  return /* @__PURE__ */ n.createElement("span", { className: _t.wrap, ref: l }, /* @__PURE__ */ n.createElement(jt, { content: s ? void 0 : r, keepWrapper: !0 }, /* @__PURE__ */ n.createElement(
    "button",
    {
      ref: c,
      type: "button",
      className: [_t.btn, s ? _t.on : ""].join(" "),
      disabled: a,
      "aria-haspopup": "menu",
      "aria-expanded": s,
      onClick: () => o((f) => !f),
      onKeyDown: (f) => {
        f.key === "ArrowDown" && !s && (f.preventDefault(), o(!0));
      }
    },
    e,
    /* @__PURE__ */ n.createElement("span", { className: _t.caret, "aria-hidden": "true" }, "▾")
  )), s && /* @__PURE__ */ n.createElement("div", { ref: i, className: _t.pop, role: "menu", onKeyDown: u }, t.map((f) => f.kind === "section" ? /* @__PURE__ */ n.createElement("div", { key: f.key, className: _t.sec }, f.label, f.note && /* @__PURE__ */ n.createElement("small", null, f.note)) : /* @__PURE__ */ n.createElement(
    "button",
    {
      key: f.key,
      type: "button",
      role: "menuitem",
      disabled: f.disabled,
      className: [_t.item, f.danger ? _t.danger : ""].join(" "),
      onClick: () => {
        var y;
        o(!1), (y = c.current) == null || y.focus(), f.onClick();
      }
    },
    /* @__PURE__ */ n.createElement("span", null, f.label),
    f.disabled && f.reason && /* @__PURE__ */ n.createElement("small", null, f.reason)
  ))));
}
function Zg(e, t, a = !0) {
  const r = L(t);
  r.current = t, Z(() => {
    if (!a) return;
    const s = (o) => {
      if (o.key !== "Enter" || !(o.ctrlKey || o.metaKey) || o.isComposing || o.repeat || o.defaultPrevented) return;
      const l = e.current, c = document.activeElement;
      !l || !c || !l.contains(c) || (o.preventDefault(), r.current());
    };
    return document.addEventListener("keydown", s), () => document.removeEventListener("keydown", s);
  }, [e, a]);
}
function Qs() {
  const e = typeof navigator != "undefined" && (navigator.platform || navigator.userAgent) || "";
  return /Mac|iPhone|iPad/i.test(e) ? "⌘+Enter" : "Ctrl+Enter";
}
const Js = "_bar_1g564_2", Zs = "_sticky_1g564_12", eo = "_start_1g564_19", to = "_end_1g564_20", no = "_status_1g564_22", ao = "_dirty_1g564_23", ro = "_kbd_1g564_25", Nt = {
  bar: Js,
  sticky: Zs,
  start: eo,
  end: to,
  status: no,
  dirty: ao,
  kbd: ro
};
function ev({ start: e, children: t, status: a, dirty: r, inline: s, shortcutHint: o, className: l = "" }) {
  return /* @__PURE__ */ n.createElement("div", { className: ["axe-save-bar", Nt.bar, s ? "" : Nt.sticky, l].filter(Boolean).join(" "), role: "group", "aria-label": "저장" }, /* @__PURE__ */ n.createElement("span", { className: Nt.start }, e), /* @__PURE__ */ n.createElement("span", { className: Nt.end }, a && /* @__PURE__ */ n.createElement("span", { className: [Nt.status, r ? Nt.dirty : ""].filter(Boolean).join(" "), "aria-live": "polite" }, a), t, o && /* @__PURE__ */ n.createElement("kbd", { className: Nt.kbd }, Qs())));
}
const so = {
  print: /* @__PURE__ */ n.createElement(n.Fragment, null, /* @__PURE__ */ n.createElement("path", { d: "M7 8V4h10v4" }), /* @__PURE__ */ n.createElement("path", { d: "M7 16H5.5A2.5 2.5 0 0 1 3 13.5v-3A2.5 2.5 0 0 1 5.5 8h13A2.5 2.5 0 0 1 21 10.5v3a2.5 2.5 0 0 1-2.5 2.5H17" }), /* @__PURE__ */ n.createElement("rect", { x: "7", y: "13", width: "10", height: "7", rx: "1" })),
  download: /* @__PURE__ */ n.createElement(n.Fragment, null, /* @__PURE__ */ n.createElement("path", { d: "M12 4v11" }), /* @__PURE__ */ n.createElement("path", { d: "M7.5 11l4.5 4.5 4.5-4.5" }), /* @__PURE__ */ n.createElement("path", { d: "M5 20h14" })),
  edit: /* @__PURE__ */ n.createElement(n.Fragment, null, /* @__PURE__ */ n.createElement("path", { d: "M4 20h4L19 9a2.1 2.1 0 0 0-3-3L5 17v3z" }), /* @__PURE__ */ n.createElement("path", { d: "M14.5 7.5l3 3" })),
  /* 코드도움·찾기 — 돋보기. 글꼴마다 모양이 다른 문자(⌕ ▦)를 쓰지 않는다 */
  search: /* @__PURE__ */ n.createElement(n.Fragment, null, /* @__PURE__ */ n.createElement("circle", { cx: "10.5", cy: "10.5", r: "6" }), /* @__PURE__ */ n.createElement("path", { d: "M15 15l5.5 5.5" })),
  /* 날짜 선택 — 달력. 윗변 고리 두 개 + 머리줄 */
  calendar: /* @__PURE__ */ n.createElement(n.Fragment, null, /* @__PURE__ */ n.createElement("rect", { x: "4", y: "5.5", width: "16", height: "14.5", rx: "2" }), /* @__PURE__ */ n.createElement("path", { d: "M4 10h16" }), /* @__PURE__ */ n.createElement("path", { d: "M8.5 3.5v4M15.5 3.5v4" })),
  trash: /* @__PURE__ */ n.createElement(n.Fragment, null, /* @__PURE__ */ n.createElement("path", { d: "M4 7h16" }), /* @__PURE__ */ n.createElement("path", { d: "M9 7V5a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v2" }), /* @__PURE__ */ n.createElement("path", { d: "M6.2 7l.9 12.1A2 2 0 0 0 9.1 21h5.8a2 2 0 0 0 2-1.9L17.8 7" }), /* @__PURE__ */ n.createElement("path", { d: "M10 11v6M14 11v6" }))
}, oo = {
  panel: "▣",
  "chevron-open": "∨",
  "chevron-closed": "＞",
  collapse: "◀",
  expand: "▶",
  mail: "✉",
  chat: "💬",
  save: "💾",
  close: "✕"
};
function lo({ name: e, className: t }) {
  return /* @__PURE__ */ n.createElement("span", { className: t, "aria-hidden": "true" }, oo[e]);
}
function gn({ name: e, size: t = 15, className: a }) {
  return /* @__PURE__ */ n.createElement(
    "svg",
    {
      className: a,
      width: t,
      height: t,
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: "currentColor",
      strokeWidth: "1.8",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      style: { verticalAlign: "-2px" },
      "aria-hidden": "true"
    },
    so[e]
  );
}
const co = "_root_j67qt_2", io = "_closed_j67qt_3", uo = "_tab_j67qt_6", mo = "_collapse_j67qt_7", fo = "_body_j67qt_16", _o = "_card_j67qt_32", po = "_head_j67qt_37", yo = "_cardOpen_j67qt_44", bo = "_headBtn_j67qt_47", Eo = "_icon_j67qt_56", ho = "_badge_j67qt_57", go = "_trailing_j67qt_58", vo = "_chev_j67qt_59", ko = "_panelWrap_j67qt_63", wo = "_panelOpen_j67qt_67", No = "_panelBody_j67qt_68", $o = "_panelInner_j67qt_69", xo = "_panelSettled_j67qt_70", ve = {
  root: co,
  closed: io,
  tab: uo,
  collapse: mo,
  body: fo,
  card: _o,
  head: po,
  cardOpen: yo,
  headBtn: bo,
  icon: Eo,
  badge: ho,
  trailing: go,
  chev: vo,
  panelWrap: ko,
  panelOpen: wo,
  panelBody: No,
  panelInner: $o,
  panelSettled: xo
}, Do = 1280, Ao = 8, ur = "axe-side-bar:";
function Co(e) {
  if (!e) return null;
  try {
    const t = window.localStorage.getItem(ur + e);
    return t === "1" ? !0 : t === "0" ? !1 : null;
  } catch {
    return null;
  }
}
function So(e, t) {
  if (e)
    try {
      window.localStorage.setItem(ur + e, t ? "1" : "0");
    } catch {
    }
}
function tv({
  enabled: e = !0,
  defaultOpen: t = !0,
  width: a = 260,
  collapseBelow: r = Do,
  storageKey: s,
  className: o = "",
  children: l
}) {
  var y;
  const c = L(Co(s)), [i, m] = D((y = c.current) != null ? y : t), u = L(c.current !== null);
  if (Z(() => {
    if (!e || !r || typeof window.matchMedia != "function") return;
    const _ = window.matchMedia(`(max-width: ${r - 1}px)`), p = () => {
      u.current || m(!_.matches && t);
    };
    return p(), _.addEventListener ? _.addEventListener("change", p) : _.addListener(p), () => {
      _.removeEventListener ? _.removeEventListener("change", p) : _.removeListener(p);
    };
  }, [e, r, t]), !e) return null;
  const f = () => {
    u.current = !0, So(s, !i), m(!i);
  };
  return /* @__PURE__ */ n.createElement(
    "aside",
    {
      className: ["axe-side-bar", ve.root, i ? "" : ve.closed, o].filter(Boolean).join(" "),
      style: { width: i ? a : Ao }
    },
    /* @__PURE__ */ n.createElement("div", { className: ve.tab }, /* @__PURE__ */ n.createElement(jt, { content: i ? "정보 패널 접기" : "정보 패널 펼치기", describe: !1 }, /* @__PURE__ */ n.createElement(
      "button",
      {
        type: "button",
        className: ve.collapse,
        onClick: f,
        "aria-label": i ? "정보 패널 접기" : "정보 패널 펼치기",
        "aria-expanded": i
      },
      /* @__PURE__ */ n.createElement(lo, { name: i ? "collapse" : "expand" })
    ))),
    /* @__PURE__ */ n.createElement("div", { className: ve.body }, l)
  );
}
const mr = An(null);
function nv({ children: e, defaultOpenId: t = null, exclusive: a = !0 }) {
  const [r, s] = D(t);
  return a ? /* @__PURE__ */ n.createElement(mr.Provider, { value: { openId: r, setOpenId: s } }, e) : /* @__PURE__ */ n.createElement(n.Fragment, null, e);
}
const dr = "axe-side-panel:";
function Mo(e) {
  if (!e) return null;
  try {
    const t = window.localStorage.getItem(dr + e);
    return t === "1" ? !0 : t === "0" ? !1 : null;
  } catch {
    return null;
  }
}
function To(e, t) {
  if (e)
    try {
      window.localStorage.setItem(dr + e, t ? "1" : "0");
    } catch {
    }
}
function av({
  title: e,
  enabled: t = !0,
  defaultOpen: a = !0,
  icon: r,
  badge: s,
  trailing: o,
  storageKey: l,
  panelId: c,
  className: i = "",
  children: m
}) {
  var E;
  const u = Dn(mr), f = !!u && c != null, y = L(Mo(l)), [_, p] = D((E = y.current) != null ? E : a), d = f ? u.openId === c : _, [b, N] = D(d), [w, k] = D(d);
  if (!t) return null;
  d && !b && N(!0);
  const x = () => {
    const h = !d;
    To(l, h), N(!0), k(!1), f ? u.setOpenId(h ? c : null) : p(h);
  };
  return /* @__PURE__ */ n.createElement("section", { className: ["axe-side-card", ve.card, d ? ve.cardOpen : "", i].filter(Boolean).join(" ") }, /* @__PURE__ */ n.createElement("header", { className: ve.head, onClick: x }, /* @__PURE__ */ n.createElement("button", { type: "button", className: ve.headBtn, "aria-expanded": d }, r && /* @__PURE__ */ n.createElement("span", { className: ve.icon, "aria-hidden": "true" }, r), /* @__PURE__ */ n.createElement("strong", null, e)), s && /* @__PURE__ */ n.createElement("span", { className: ve.badge }, s), o && /* @__PURE__ */ n.createElement("span", { className: ve.trailing, onClick: (h) => h.stopPropagation() }, o), /* @__PURE__ */ n.createElement(
    "svg",
    {
      className: ve.chev,
      width: "14",
      height: "14",
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: "currentColor",
      strokeWidth: "2.2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      "aria-hidden": "true"
    },
    /* @__PURE__ */ n.createElement("path", { d: "M6 9l6 6 6-6" })
  )), b && /* @__PURE__ */ n.createElement(
    "div",
    {
      className: [ve.panelWrap, d ? ve.panelOpen : ""].filter(Boolean).join(" "),
      onTransitionEnd: (h) => {
        h.target === h.currentTarget && h.propertyName === "grid-template-rows" && k(!0);
      }
    },
    /* @__PURE__ */ n.createElement("div", { className: [ve.panelBody, d && w ? ve.panelSettled : ""].filter(Boolean).join(" ") }, /* @__PURE__ */ n.createElement("div", { className: ve.panelInner }, m))
  ));
}
const qo = "_guide_qnh7l_1", Bo = "_title_qnh7l_5", Lo = "_desc_qnh7l_6", jo = "_act_qnh7l_7", Ro = "_why_qnh7l_13", Io = "_steps_qnh7l_14", Oo = "_no_qnh7l_20", Po = "_cur_qnh7l_24", Xo = "_link_qnh7l_26", at = {
  guide: qo,
  title: Bo,
  desc: Lo,
  act: jo,
  why: Ro,
  steps: Io,
  no: Oo,
  cur: Po,
  link: Xo
};
function rv({ title: e, desc: t, action: a, steps: r }) {
  return /* @__PURE__ */ n.createElement("section", { className: at.guide, "aria-label": e }, /* @__PURE__ */ n.createElement("h2", { className: at.title }, e), t && /* @__PURE__ */ n.createElement("p", { className: at.desc }, t), a && /* @__PURE__ */ n.createElement(n.Fragment, null, /* @__PURE__ */ n.createElement("button", { type: "button", className: at.act, disabled: a.disabled, onClick: a.onClick }, a.label), a.disabled && a.reason && /* @__PURE__ */ n.createElement("p", { className: at.why }, a.reason)), r && r.length > 0 && /* @__PURE__ */ n.createElement("ol", { className: at.steps }, r.map((s, o) => /* @__PURE__ */ n.createElement("li", { key: s.label, className: s.current ? at.cur : void 0 }, /* @__PURE__ */ n.createElement("span", { className: at.no }, o + 1), s.onClick && !s.current ? /* @__PURE__ */ n.createElement("button", { type: "button", className: at.link, onClick: s.onClick }, s.label) : /* @__PURE__ */ n.createElement("span", null, s.label), s.hint && /* @__PURE__ */ n.createElement("small", null, s.hint)))));
}
const zo = "_list_1w2rs_1", Fo = "_row_1w2rs_2", Wo = "_label_1w2rs_6", Ho = "_value_1w2rs_7", Ko = "_emphasis_1w2rs_8", Uo = "_changed_1w2rs_10", It = {
  list: zo,
  row: Fo,
  label: Wo,
  value: Ho,
  emphasis: Ko,
  changed: Uo
};
function sv({ items: e, className: t }) {
  return /* @__PURE__ */ n.createElement("dl", { className: [It.list, t != null ? t : ""].join(" ") }, e.map((a, r) => /* @__PURE__ */ n.createElement("div", { key: r, className: [It.row, a.emphasis ? It.emphasis : ""].join(" ") }, /* @__PURE__ */ n.createElement("dt", { className: It.label }, a.label), /* @__PURE__ */ n.createElement("dd", { className: [It.value, a.changed ? It.changed : ""].join(" ") }, a.value))));
}
const Go = "_underline_xl221_2", Yo = "_active_xl221_24", Vo = "_segmented_xl221_33", Rn = {
  underline: Go,
  active: Yo,
  segmented: Vo
};
function fr({
  items: e,
  value: t,
  onChange: a,
  variant: r = "underline",
  className: s = "",
  "aria-label": o
}) {
  return /* @__PURE__ */ n.createElement(
    "nav",
    {
      className: [r === "segmented" ? Rn.segmented : Rn.underline, s].filter(Boolean).join(" "),
      role: "tablist",
      "aria-label": o
    },
    e.map((l) => /* @__PURE__ */ n.createElement(
      "button",
      {
        key: l.key,
        type: "button",
        role: "tab",
        "aria-selected": l.key === t,
        className: l.key === t ? Rn.active : "",
        onClick: () => a(l.key)
      },
      l.label
    ))
  );
}
const Qo = "_bar_1e999_1", Jo = "_actions_1e999_17", Zo = "_field_1e999_24", el = "_fieldLabel_1e999_25", tl = "_readout_1e999_33", nl = "_search_1e999_44", al = "_detail_1e999_58", rl = "_pill_1e999_70", sl = "_hint_1e999_81", ut = {
  bar: Qo,
  actions: Jo,
  field: Zo,
  fieldLabel: el,
  readout: tl,
  search: nl,
  detail: al,
  pill: rl,
  hint: sl
}, ol = /* @__PURE__ */ new Set(["text", "search", "number", "tel", "email", "url", "password", ""]);
function ll(e) {
  if (e.key !== "Enter" || e.defaultPrevented || e.nativeEvent.isComposing || e.ctrlKey || e.metaKey || e.altKey || e.shiftKey) return !1;
  const t = e.target;
  return !(!(t instanceof HTMLInputElement) || !e.currentTarget.contains(t) || !ol.has(t.type) || t.readOnly || t.disabled || t.getAttribute("role") === "combobox" || t.getAttribute("aria-expanded") === "true");
}
function ov({
  children: e,
  onSearch: t,
  searchLabel: a = "조회",
  searchDisabled: r,
  searchTitle: s,
  detailSearch: o = !1,
  onDetailSearch: l,
  detailLabel: c = "상세검색",
  trailing: i,
  enterSearch: m = !0
}) {
  const u = (f) => {
    !m || !t || r || !ll(f) || (f.preventDefault(), t());
  };
  return /* @__PURE__ */ n.createElement("section", { className: ut.bar, onKeyDown: u }, e, /* @__PURE__ */ n.createElement("span", { className: ut.actions }, i, o && /* @__PURE__ */ n.createElement("button", { type: "button", className: ut.detail, onClick: l }, "⌕ ", c), t && /* @__PURE__ */ n.createElement(jt, { content: s, keepWrapper: !0 }, /* @__PURE__ */ n.createElement("button", { type: "button", className: ut.search, onClick: t, disabled: r }, "⌕ ", a))));
}
function cl({ label: e, children: t }) {
  return /* @__PURE__ */ n.createElement("label", { className: ut.field }, /* @__PURE__ */ n.createElement("span", { className: ut.fieldLabel }, e), t);
}
function lv({ children: e }) {
  return /* @__PURE__ */ n.createElement("span", { className: ut.readout }, e);
}
function cv({ children: e }) {
  return /* @__PURE__ */ n.createElement("span", { className: ut.pill, role: "status" }, e);
}
function iv({ children: e }) {
  return /* @__PURE__ */ n.createElement("span", { className: ut.hint }, e);
}
function il(e) {
  return `${e.gisu}기 (${e.startDa} ~ ${e.endDa})${e.closeYn ? " · 마감" : ""}`;
}
function uv({ rows: e, value: t, onChange: a, disabled: r, label: s = "기수" }) {
  return /* @__PURE__ */ n.createElement(cl, { label: s }, /* @__PURE__ */ n.createElement(
    "select",
    {
      value: t != null ? t : "",
      "aria-label": s,
      disabled: r,
      style: { width: "var(--axe-field-w-lg, 240px)" },
      onChange: (o) => a(Number(o.target.value))
    },
    e.map((o) => /* @__PURE__ */ n.createElement("option", { key: o.gisu, value: o.gisu }, il(o)))
  ));
}
class _r {
  constructor(t, a) {
    this._resizeObserver = null, this.initializeResizeObserver = () => {
      this._resizeObserver = new ResizeObserver((r) => {
        try {
          for (const s of r) {
            const o = s.borderBoxSize[0];
            this._callback({ width: o.inlineSize, height: o.blockSize }, s);
          }
        } catch (s) {
          console.error(s);
        }
      }), this._resizeObserver.observe(this._element);
    }, this.refresh = () => {
    }, this.detach = () => {
      this._resizeObserver && this._resizeObserver.disconnect();
    }, this.reset = () => {
    }, this._element = t, this._callback = a, this.initializeResizeObserver();
  }
}
function pr(e, t) {
  return !e || e.key !== t ? { key: t, dir: "asc" } : e.dir === "asc" ? { key: t, dir: "desc" } : null;
}
function yr(e, t) {
  return !e || e.key !== t ? "none" : e.dir === "asc" ? "ascending" : "descending";
}
function br(e, t) {
  return e ? `${t(e.key)} ${e.dir === "asc" ? "오름차순" : "내림차순"} 정렬` : "정렬을 해제했습니다";
}
function ul(e) {
  const t = e.replace(/\s+/g, " ").trim();
  if (!t || t === "-") return null;
  const a = /^([-+]?)\(?[₩$]?\s*([\d,]*\.?\d+)\)?\s*(%|원|개|건)?$/.exec(t);
  if (a && /^\d{1,3}(,\d{3})*(\.\d+)?$|^\d*\.?\d+$/.test(a[2])) {
    const r = parseFloat(a[2].replace(/,/g, ""));
    return a[1] === "-" || /^[-+]?\(/.test(t) ? -r : r;
  }
  return t;
}
function Er(e, t, a) {
  if (e === null || t === null) return e === t ? 0 : e === null ? 1 : -1;
  let r;
  return typeof e == "number" && typeof t == "number" ? r = e - t : typeof e == "number" ? r = -1 : typeof t == "number" ? r = 1 : r = e.localeCompare(t, "ko", { numeric: !0, sensitivity: "base" }), a === "asc" ? r : -r;
}
function ml(e, t) {
  const a = [], r = (l) => {
    l.sort((c, i) => Er(e[c.i].value, e[i.i].value, t) || c.i - i.i), l.forEach((c) => {
      a.push(c.i), r(c.kids);
    });
  };
  let s = [], o = [];
  return e.forEach((l, c) => {
    if (l.level === null) {
      r(s), s = [], o = [], a.push(c);
      return;
    }
    for (; o.length && o[o.length - 1].level >= l.level; ) o.pop();
    const i = { i: c, kids: [] };
    (o.length ? o[o.length - 1].node.kids : s).push(i), o.push({ level: l.level, node: i });
  }), r(s), a;
}
function dl(e, t) {
  const a = new Set(t), r = e.filter((o) => a.has(o)), s = new Set(r);
  for (let o = t.length - 1; o >= 0; o -= 1) {
    const l = t[o];
    if (s.has(l)) continue;
    const c = o + 1 < t.length ? r.indexOf(t[o + 1]) : -1;
    c < 0 ? r.push(l) : r.splice(c, 0, l), s.add(l);
  }
  return r;
}
function fl(e, t) {
  const a = /* @__PURE__ */ new Map();
  t.forEach((c, i) => a.set(c, i));
  const r = e.map((c) => {
    var i;
    return (i = a.get(c)) != null ? i : -1;
  }), s = [], o = new Array(r.length).fill(-1);
  r.forEach((c, i) => {
    if (c < 0) return;
    let m = 0, u = s.length;
    for (; m < u; ) {
      const f = m + u >> 1;
      r[s[f]] < c ? m = f + 1 : u = f;
    }
    m > 0 && (o[i] = s[m - 1]), s[m] = i;
  });
  const l = /* @__PURE__ */ new Set();
  for (let c = s.length ? s[s.length - 1] : -1; c >= 0; c = o[c]) l.add(e[c]);
  return l;
}
const _l = 'input, select, textarea, button, a[href], [role="checkbox"], [role="button"]', pl = ".axe-group-row, .axe-input-row, .axe-total-row, [data-sort-fixed]";
function yl(e) {
  const t = /* @__PURE__ */ new Map(), a = /* @__PURE__ */ new Map();
  for (const r of e) {
    a.forEach((o, l) => {
      o <= 1 ? a.delete(l) : a.set(l, o - 1);
    });
    let s = 0;
    for (const o of Array.from(r.cells)) {
      for (; a.has(s); ) s += 1;
      const l = o.colSpan || 1;
      if (t.set(o, s), o.rowSpan > 1) for (let c = s; c < s + l; c += 1) a.set(c, o.rowSpan);
      s += l;
    }
  }
  return t;
}
function bl(e) {
  const t = e.tHead;
  if (!t) return [];
  const a = yl(Array.from(t.rows)), r = [];
  return a.forEach((s, o) => {
    var c, i;
    if (o.tagName !== "TH" || (o.colSpan || 1) !== 1 || o.dataset.sortable === "false" || o.hasAttribute("aria-sort") && o.dataset.axeSort === void 0 || o.querySelector(_l)) return;
    const l = ((c = o.textContent) != null ? c : "").replace(/\s+/g, " ").trim();
    l && r.push({ th: o, col: s, key: (i = o.dataset.sortKey) != null ? i : String(s), label: l });
  }), r;
}
function ba(e, t) {
  var r;
  let a = 0;
  for (const s of Array.from(e.cells)) {
    const o = s.colSpan || 1;
    if (t < a + o) {
      const l = s.dataset.sortValue;
      if (l !== void 0) {
        const i = Number(l);
        return l === "" ? null : Number.isFinite(i) ? i : l;
      }
      const c = s.querySelector('input:not([type="checkbox"]):not([type="radio"]), select');
      return ul(c ? c.value : (r = s.textContent) != null ? r : "");
    }
    a += o;
  }
  return null;
}
function El(e) {
  if (e.matches(pl) || e.cells.length === 1 && (e.cells[0].colSpan || 1) > 1) return null;
  const t = Number(e.getAttribute("aria-level"));
  return Number.isFinite(t) && t >= 1 ? t : 1;
}
function hl() {
  return { parent: null, base: [], shown: [], sig: "" };
}
function gl(e) {
  const t = Array.from(e.tBodies);
  if (t.length > 1) return { parent: e, items: t, bodies: !0 };
  const a = t[0];
  if (!a) return null;
  const r = Array.from(a.rows);
  return r.some((s) => Array.from(s.cells).some((o) => o.rowSpan > 1)) ? null : { parent: a, items: r, bodies: !1 };
}
const hr = (e, t) => e.length === t.length && e.every((a, r) => a === t[r]);
function vl(e, t, a) {
  if (hr(t, a)) return;
  const r = fl(t, a);
  let s = a.length ? a[a.length - 1].nextElementSibling : null;
  for (let o = t.length - 1; o >= 0; o -= 1) {
    const l = t[o];
    r.has(l) || e.insertBefore(l, s), s = l;
  }
}
function kl(e, t, a, r) {
  if (t) {
    const l = e.map((c, i) => ({ b: c, i, v: c.rows[0] ? ba(c.rows[0], a) : null }));
    return l.sort((c, i) => Er(c.v, i.v, r) || c.i - i.i), l.map((c) => c.b);
  }
  const s = e, o = s.map((l) => {
    const c = El(l);
    return { level: c, value: c === null ? null : ba(l, a) };
  });
  return ml(o, r).map((l) => s[l]);
}
function wl(e, t, a) {
  const r = gl(e);
  if ((!r || r.parent !== a.parent) && (a.parent = r ? r.parent : null, a.base = r ? r.items : [], a.shown = a.base, a.sig = "", !r))
    return;
  const s = r.items, o = t ? `${t.col}:${t.dir}` : "";
  if (o === a.sig && hr(s, a.shown)) return;
  a.base = a.sig ? dl(a.base, s) : s;
  let l = t ? kl(a.base, r.bodies, t.col, t.dir) : a.base;
  if (t && o === a.sig) {
    const c = new Set(a.shown), i = a.shown.filter((u) => u.parentElement === r.parent);
    let m = 0;
    l = l.map((u) => c.has(u) ? i[m++] : u);
  }
  vl(r.parent, l, s), a.shown = l, a.sig = o;
}
const Nl = "input, select, textarea, button";
function $l(e) {
  const t = e == null ? void 0 : e.tHead;
  if (!t) return [];
  const a = [];
  return t.querySelectorAll("th").forEach((r) => {
    var c;
    const s = ((c = r.textContent) != null ? c : "").replace(/\s+/g, " ").trim(), o = r.dataset.axeTitle !== void 0 && r.dataset.axeTitle === r.getAttribute("title");
    s !== "" && !r.querySelector(Nl) && r.scrollWidth > r.clientWidth + 1 ? (a.push({ label: s, short: r.scrollWidth - r.clientWidth, sortMark: r.dataset.axeSort !== void 0 }), (!r.hasAttribute("title") || o) && (r.getAttribute("title") !== s && r.setAttribute("title", s), r.dataset.axeTitle !== s && (r.dataset.axeTitle = s))) : o && (r.removeAttribute("title"), delete r.dataset.axeTitle);
  }), a;
}
const gr = An(null), xl = "_card_1j6er_2", Dl = "_grow_1j6er_24", Al = "_head_1j6er_26", Cl = "_title_1j6er_35", Sl = "_trailing_1j6er_36", Ml = "_scroll_1j6er_6", Tl = "_foot_1j6er_54", ql = "_strip_1j6er_56", Bl = "_pager_1j6er_58", Ll = "_spacer_1j6er_60", jl = "_table_1j6er_62", Rl = "_fixed_1j6er_63", Il = "_fz_1j6er_81", Ol = "_fzEdge_1j6er_93", Pl = "_frozen_1j6er_100", Xl = "_sr_1j6er_162", zl = "_statusCell_1j6er_43", Fl = "_status_1j6er_43", Wl = "_st_error_1j6er_244", Hl = "_stIcon_1j6er_245", Kl = "_spin_1j6er_251", Ul = "_axeSpin_1j6er_1", Gl = "_busy_1j6er_261", Yl = "_statusRow_1j6er_263", Vl = "_busyBar_1j6er_264", Ql = "_axeBusy_1j6er_1", ue = {
  card: xl,
  grow: Dl,
  head: Al,
  title: Cl,
  trailing: Sl,
  scroll: Ml,
  foot: Tl,
  strip: ql,
  pager: Bl,
  spacer: Ll,
  table: jl,
  fixed: Rl,
  fz: Il,
  fzEdge: Ol,
  frozen: Pl,
  sr: Xl,
  statusCell: zl,
  status: Fl,
  st_error: Wl,
  stIcon: Hl,
  spin: Kl,
  axeSpin: Ul,
  busy: Gl,
  statusRow: Yl,
  busyBar: Vl,
  axeBusy: Ql
}, Jl = 120;
function Zl(e) {
  if (!e || !e.length) return;
  let t = 0, a = 0;
  for (const r of e)
    if (r == null) a += 1;
    else if (typeof r == "number") t += r;
    else if (/^\d+(\.\d+)?px$/.test(r)) t += parseFloat(r);
    else return;
  return a > 0 ? t + a * Jl : void 0;
}
function Ea({ cols: e }) {
  return !e || !e.length ? null : /* @__PURE__ */ n.createElement("colgroup", null, e.map((t, a) => /* @__PURE__ */ n.createElement("col", { key: a, style: t == null ? void 0 : { width: t } })));
}
const Ht = /* @__PURE__ */ new Set();
function ca() {
  var e;
  return typeof process != "undefined" && ((e = process.env) != null && e.NODE_ENV) ? process.env.NODE_ENV !== "production" : typeof location != "undefined" && /^(localhost|127.0.0.1|[::1])$/.test(location.hostname);
}
function ec(e) {
  if (!ca() || !e || e.getAttribute("aria-label") || e.getAttribute("aria-labelledby")) return;
  const t = Array.from(e.querySelectorAll("thead th")).slice(0, 4).map((r) => {
    var s;
    return (s = r.textContent) == null ? void 0 : s.trim();
  }).filter(Boolean), a = `unnamed|${t.join("|")}`;
  Ht.has(a) || (Ht.add(a), console.warn(`[AXErpGrid] 표 이름이 없습니다 — aria-label(예 「전표 목록」)을 주세요. 머리글: ${t.join(" · ")}`));
}
function tc(e) {
  if (!ca()) return;
  const t = [];
  if (e.querySelectorAll("td.axe-money").forEach((r) => {
    var s, o;
    r.scrollWidth > r.clientWidth + 1 && t.push((o = (s = r.textContent) == null ? void 0 : s.trim()) != null ? o : "");
  }), !t.length) return;
  const a = t.slice(0, 5).join("|");
  Ht.has(a) || (Ht.add(a), console.warn(
    `[AXErpGrid] 금액 셀 ${t.length}개가 컬럼 폭을 넘어 말줄임됩니다 — cols 를 moneyColWidth() 로 계산하세요.`,
    t.slice(0, 5)
  ));
}
function nc(e) {
  if (!ca() || !e.length) return;
  const t = `head|${e.map((r) => r.label).join("|")}`;
  if (Ht.has(t)) return;
  Ht.add(t);
  const a = e.some((r) => r.sortMark) ? " (정렬 표시 ↕ 약 15px 포함)" : "";
  console.warn(
    `[AXErpGrid] 머리글 ${e.length}개가 열 폭보다 길어 잘립니다 — cols 를 넓히세요${a}:`,
    e.map((r) => `${r.label} +${Math.ceil(r.short)}px`).join(", ")
  );
}
function ha(e, t, a) {
  if (!e) return;
  const r = /* @__PURE__ */ new Map();
  for (const s of Array.from(e.rows)) {
    r.forEach((l, c) => {
      l <= 1 ? r.delete(c) : r.set(c, l - 1);
    });
    let o = 0;
    for (const l of Array.from(s.cells)) {
      for (; r.has(o); ) o += 1;
      const c = l.colSpan || 1, i = t > 0 && o + c <= t;
      if (l.classList.toggle(ue.fz, i), l.classList.toggle(ue.fzEdge, i && o + c === t), l.style.left = i ? `${a[o]}px` : "", l.rowSpan > 1) for (let m = o; m < o + c; m += 1) r.set(m, l.rowSpan);
      o += c;
    }
  }
}
function ac({
  cols: e,
  footer: t,
  pagination: a,
  title: r,
  trailing: s,
  grow: o,
  fixed: l,
  stickyCols: c = 0,
  busy: i,
  tableRole: m,
  "aria-label": u,
  sortable: f = !0,
  sort: y,
  onSort: _,
  manualSort: p,
  className: d = "",
  children: b
}) {
  const N = l || e !== void 0 && e.length > 0, w = N ? Zl(e) : void 0, { stick: k, offsets: x } = we(() => {
    const R = Math.max(Math.trunc(c), 0), z = [];
    if (R === 0 || !e) return { stick: 0, offsets: z };
    let Y = 0, X = 0;
    for (let H = 0; H < R; H += 1) {
      const ce = e[H];
      if (typeof ce != "number") break;
      z.push(Y), Y += ce, X += 1;
    }
    return { stick: X, offsets: z };
  }, [e, c]), E = [ue.table, N ? ue.fixed : "", k > 0 ? ue.frozen : ""].filter(Boolean).join(" "), h = L(null), g = L(null), $ = L(null), A = L(null), M = L(0), T = L(0), I = we(() => ({
    scrollRef: h,
    colCount: e == null ? void 0 : e.length,
    registerVirtual: () => (T.current += 1, () => {
      T.current -= 1;
    })
  }), [e == null ? void 0 : e.length]), [q, P] = D(null), G = y !== void 0 ? y : q, [K, j] = D(""), te = L(hl()), ne = () => {
    const R = h.current, z = $.current, Y = A.current;
    if (!R || !z || !Y) return;
    const X = R.scrollWidth;
    Y.style.width = X + "px", z.style.display = X > R.clientWidth + 1 ? "" : "none";
    const H = R.offsetWidth - R.clientWidth;
    z.style.paddingRight = H + "px", g.current && (g.current.style.paddingRight = H + "px"), tc(R), nc($l(R.querySelector("table")));
  };
  Z(() => {
    const R = h.current;
    if (!R) return;
    const z = new _r(R, ne);
    return ec(R.querySelector("table")), () => z.detach();
  }, []), Be(() => {
    var R, z, Y, X, H;
    (k > 0 || M.current > 0) && (ha((z = (R = h.current) == null ? void 0 : R.querySelector("table")) != null ? z : null, k, x), ha((X = (Y = g.current) == null ? void 0 : Y.querySelector("table")) != null ? X : null, k, x)), M.current = k, (H = h.current) == null || H.querySelectorAll("thead th:not([scope])").forEach((ce) => ce.setAttribute("scope", "col")), v(), ne();
  });
  function v() {
    var X;
    const R = (X = h.current) == null ? void 0 : X.querySelector("table");
    if (!R) return;
    const z = f ? bl(R) : [];
    R.querySelectorAll("thead th[data-axe-sort]").forEach((H) => {
      z.some((ce) => ce.th === H) || (H.removeAttribute("data-axe-sort"), H.removeAttribute("aria-sort"), H.removeAttribute("tabindex"));
    }), z.forEach(({ th: H, key: ce }) => {
      H.dataset.axeSort !== ce && (H.dataset.axeSort = ce);
      const Ue = yr(G, ce);
      H.getAttribute("aria-sort") !== Ue && H.setAttribute("aria-sort", Ue), H.hasAttribute("tabindex") || H.setAttribute("tabindex", "0");
    });
    const Y = G && z.find((H) => H.key === G.key);
    wl(R, G && Y && !p && T.current === 0 ? { col: Y.col, dir: G.dir } : null, te.current);
  }
  const O = (R) => {
    var H;
    const z = R.dataset.axeSort;
    if (z === void 0) return;
    const Y = pr(G, z), X = ((H = R.textContent) != null ? H : "").replace(/\s+/g, " ").trim();
    j(br(Y, () => X)), y === void 0 && P(Y), _ == null || _(Y);
  }, V = (R) => {
    var X, H;
    const z = R, Y = (X = z.closest) == null ? void 0 : X.call(z, "thead th[data-axe-sort]");
    return !Y || !((H = h.current) != null && H.contains(Y)) || z !== Y && z.closest('input, select, textarea, button, a[href], [role="button"]') ? null : Y;
  }, Q = (R) => {
    const z = V(R.target);
    z && O(z);
  }, se = (R) => {
    if (R.key !== "Enter" && R.key !== " ") return;
    const z = V(R.target);
    !z || R.target !== z || (R.preventDefault(), O(z));
  }, B = (R) => {
    const z = R.target.scrollLeft;
    h.current && (h.current.scrollLeft = z), g.current && (g.current.scrollLeft = z);
  }, J = (R) => {
    const z = R.target.scrollLeft;
    g.current && (g.current.scrollLeft = z), $.current && ($.current.scrollLeft = z);
  };
  return /* @__PURE__ */ n.createElement("div", { className: [ue.card, o ? ue.grow : "", i ? ue.busy : "", d].filter(Boolean).join(" ") }, i && /* @__PURE__ */ n.createElement("div", { className: ue.busyBar, "aria-hidden": "true" }), (r !== void 0 || s !== void 0) && /* @__PURE__ */ n.createElement("header", { className: ue.head }, /* @__PURE__ */ n.createElement("span", { className: ue.title }, r), s && /* @__PURE__ */ n.createElement("span", { className: ue.trailing }, s)), /* @__PURE__ */ n.createElement("div", { className: ue.scroll, ref: h, onScroll: J }, /* @__PURE__ */ n.createElement(
    "table",
    {
      className: E,
      role: m && m !== "table" ? m : void 0,
      "aria-busy": i || void 0,
      "aria-label": u != null ? u : typeof r == "string" && r ? r : void 0,
      style: w ? { minWidth: w } : void 0,
      onClick: f ? Q : void 0,
      onKeyDown: f ? se : void 0
    },
    /* @__PURE__ */ n.createElement(Ea, { cols: e }),
    /* @__PURE__ */ n.createElement(gr.Provider, { value: I }, b)
  )), t && /* @__PURE__ */ n.createElement("div", { className: ue.foot, ref: g }, /* @__PURE__ */ n.createElement("table", { className: E, style: w ? { minWidth: w } : void 0 }, /* @__PURE__ */ n.createElement(Ea, { cols: e }), /* @__PURE__ */ n.createElement("tbody", null, t))), /* @__PURE__ */ n.createElement("div", { className: ue.strip, ref: $, onScroll: B }, /* @__PURE__ */ n.createElement("div", { ref: A, className: ue.spacer })), a && /* @__PURE__ */ n.createElement("div", { className: ue.pager }, a), f && /* @__PURE__ */ n.createElement("span", { className: ue.sr, role: "status", "aria-live": "polite" }, K));
}
const rc = 600;
function ga(e) {
  const { count: t, rowHeight: a, scrollTop: r, bodyTop: s } = e;
  if (!(t > 0) || !(a > 0)) return { start: 0, end: 0 };
  const o = e.viewport > 0 ? e.viewport : rc, l = Math.max(0, Math.trunc(e.overscan)), c = Math.min(t - 1, Math.max(0, Math.floor((r - s) / a))), i = Math.ceil(o / a) + 1;
  return {
    start: Math.max(0, c - l),
    end: Math.min(t, c + i + l)
  };
}
function sc(e, t, a) {
  return {
    top: a.start * t,
    bottom: Math.max(0, e - a.end) * t
  };
}
function oc(e, t) {
  return e.start === t.start && e.end === t.end;
}
const va = /* @__PURE__ */ new Set();
function ka({ height: e, colSpan: t }) {
  return e <= 0 ? null : /* @__PURE__ */ n.createElement("tr", { "aria-hidden": "true", "data-sort-fixed": "", "data-virtual-spacer": "", style: { height: e } }, /* @__PURE__ */ n.createElement("td", { colSpan: t, style: { height: e, padding: 0, border: 0 } }));
}
function mv({
  rows: e,
  rowHeight: t,
  renderRow: a,
  getKey: r,
  overscan: s = 6,
  colSpan: o,
  headerRows: l = 1,
  className: c
}) {
  var E;
  const i = Dn(gr), m = L(null), [u, f] = D(() => ga({
    count: e.length,
    rowHeight: t,
    scrollTop: 0,
    viewport: 0,
    bodyTop: 0,
    overscan: s
  })), y = e.length, [_, p] = D(null), d = _ && _.of === t ? _.px : t;
  Be(() => i ? i.registerVirtual() : void 0, [i]), Be(() => {
    var g;
    const h = (g = m.current) == null ? void 0 : g.closest("table");
    if (h)
      return h.setAttribute("aria-rowcount", String(y + l)), () => h.removeAttribute("aria-rowcount");
  }, [y, l]), Z(() => {
    const h = i == null ? void 0 : i.scrollRef.current, g = m.current;
    if (!h || !g) return;
    const $ = () => {
      const M = g.getBoundingClientRect().top - h.getBoundingClientRect().top + h.scrollTop, T = ga({ count: y, rowHeight: d, scrollTop: h.scrollTop, viewport: h.clientHeight, bodyTop: M, overscan: s });
      f((I) => oc(I, T) ? I : T);
    };
    $(), h.addEventListener("scroll", $, { passive: !0 });
    const A = typeof ResizeObserver == "function" ? new ResizeObserver($) : null;
    return A ? A.observe(h) : window.addEventListener("resize", $), () => {
      h.removeEventListener("scroll", $), A ? A.disconnect() : window.removeEventListener("resize", $);
    };
  }, [i, y, d, s]), Be(() => {
    var $, A, M;
    const h = ($ = m.current) == null ? void 0 : $.querySelector("tr:not([data-virtual-spacer])"), g = (A = h == null ? void 0 : h.getBoundingClientRect().height) != null ? A : 0;
    !(g > 0) || Math.abs(g - d) <= 0.25 || (p({ of: t, px: g }), typeof process != "undefined" && ((M = process.env) == null ? void 0 : M.NODE_ENV) !== "production" && Math.abs(g - t) > 2 && !va.has(t) && (va.add(t), console.warn(`[AXErpVirtualBody] 실제 행 높이(${Math.round(g)}px)가 rowHeight(${t}px)와 많이 다릅니다 — 행마다 높이가 다르면 스크롤 위치가 어긋납니다. 셀 CSS 로 높이를 고정하세요.`)));
  }, [d, t, y]);
  const b = Math.min(u.end, y), N = Math.min(u.start, b), w = sc(y, d, { start: N, end: b }), k = (E = o != null ? o : i == null ? void 0 : i.colCount) != null ? E : 1, x = [];
  for (let h = N; h < b; h += 1) {
    const g = a(e[h], h), $ = r ? r(e[h], h) : h;
    x.push(ln(g) ? oa(g, { key: $, "aria-rowindex": h + 1 + l }) : g);
  }
  return /* @__PURE__ */ n.createElement("tbody", { ref: m, className: c, "data-virtual": "" }, /* @__PURE__ */ n.createElement(ka, { height: w.top, colSpan: k }), x, /* @__PURE__ */ n.createElement(ka, { height: w.bottom, colSpan: k }));
}
const lc = 7.09, cc = 3.88, ic = 4.46, uc = 16, mc = 2;
function dc(e, t = {}) {
  var o;
  const a = Math.max(1, e), r = Math.floor((a - 1) / 3), s = a * lc + r * cc + (t.negative ? ic : 0) + uc + mc;
  return Math.max(Math.ceil(s), (o = t.min) != null ? o : 0);
}
function dv(e, t = {}) {
  var s, o;
  let a = 0, r = (s = t.negative) != null ? s : !1;
  for (const l of e) {
    if (l == null || l === "") continue;
    const c = typeof l == "number" ? l : Number(String(l).replace(/[^\d.-]/g, ""));
    if (!Number.isFinite(c)) continue;
    c < 0 && (r = !0);
    const i = Math.floor(Math.abs(c)).toString().length;
    i > a && (a = i);
  }
  return a === 0 ? Math.max((o = t.min) != null ? o : 96, 96) : dc(a, { ...t, negative: r });
}
function fv(e) {
  const t = document.createElement("span");
  t.style.cssText = "position:absolute;visibility:hidden;white-space:nowrap", e.appendChild(t);
  const a = (l) => (t.textContent = l, t.getBoundingClientRect().width), r = a("000000000000"), s = a("000,000,000,000"), o = a("-000,000,000,000");
  return t.remove(), { digit: r / 12, comma: (s - r) / 3, minus: o - s };
}
const $t = 12, fc = 1.06, _c = 16, pc = 4;
function yc(e) {
  var a;
  const t = (a = e.codePointAt(0)) != null ? a : 0;
  return t >= 4352 && (t <= 4607 || t >= 11904 && t <= 55295 || t >= 63744 && t <= 64255 || t >= 65280 && t <= 65519) ? $t : e === " " ? $t * 0.3 : /[0-9]/.test(e) ? $t * 0.56 : /[A-Z]/.test(e) ? $t * 0.68 : /[a-z]/.test(e) ? $t * 0.56 : /[.,:;'|!]/.test(e) ? $t * 0.3 : $t * 0.6;
}
function bc(e, t = !1) {
  let a = 0;
  for (const r of e) a += yc(r);
  return t ? a * fc : a;
}
function _v(e, t = {}) {
  var o, l, c;
  let a = 0;
  for (const i of e) {
    if (!i) continue;
    const m = bc(i, t.bold);
    m > a && (a = m);
  }
  const r = (o = t.min) != null ? o : 64;
  if (a === 0) return r;
  const s = Math.ceil(a + _c + ((l = t.extra) != null ? l : 0) + pc);
  return Math.min(Math.max(s, r), (c = t.max) != null ? c : 1 / 0);
}
function Ec({
  colSpan: e,
  loading: t,
  error: a,
  count: r,
  empty: s = "조회 결과가 없습니다",
  idle: o = "조회조건을 정하고 조회하세요",
  loadingText: l = "조회 중…",
  className: c = ""
}) {
  const i = a != null && a !== !1 && a !== "", m = r == null || r === 0, u = a === !0 ? "조회하지 못했습니다 — 위 오류 안내를 확인한 뒤 다시 조회하세요" : a;
  let f;
  if (i) f = "error";
  else if (t && m) f = "loading";
  else if (r == null) {
    if (o === null) return null;
    f = "idle";
  } else if (r === 0) f = "empty";
  else return null;
  const y = /* @__PURE__ */ n.createElement(n.Fragment, null, f === "loading" && /* @__PURE__ */ n.createElement("span", { className: ue.spin, "aria-hidden": "true" }), f === "error" && /* @__PURE__ */ n.createElement("span", { className: ue.stIcon, "aria-hidden": "true" }, "!"), /* @__PURE__ */ n.createElement("span", null, f === "error" ? u : f === "loading" ? l : f === "idle" ? o : s)), _ = /* @__PURE__ */ n.createElement("div", { className: [ue.status, ue[`st_${f}`]].join(" "), role: "status" }, y);
  return e === void 0 ? /* @__PURE__ */ n.createElement("div", { className: c || void 0, "data-state": f }, _) : /* @__PURE__ */ n.createElement("tr", { className: [ue.statusRow, c].filter(Boolean).join(" "), "data-state": f }, /* @__PURE__ */ n.createElement("td", { colSpan: e, className: ue.statusCell }, _));
}
function hc(e, t) {
  return {
    tabIndex: 0,
    "aria-current": t ? "true" : void 0,
    onKeyDown: (a) => {
      a.target === a.currentTarget && (a.key === "Enter" || a.key === " ") && (a.preventDefault(), e());
    }
  };
}
const gc = "_cell_n9rrj_1", vc = "_toggle_n9rrj_2", kc = "_spacer_n9rrj_8", wc = "_label_n9rrj_9", Nc = "_dim_n9rrj_10", Qt = {
  cell: gc,
  toggle: vc,
  spacer: kc,
  label: wc,
  dim: Nc
};
function pv(e, { id: t, parentId: a, defaultOpen: r = !0 }) {
  const [s, o] = D(() => /* @__PURE__ */ new Set()), [l, c] = D(() => /* @__PURE__ */ new Set()), { parents: i, kids: m } = we(() => {
    const _ = /* @__PURE__ */ new Map(), p = /* @__PURE__ */ new Set(), d = new Set(e.map((b) => String(t(b))));
    for (const b of e) {
      const N = a(b), w = N == null || !d.has(String(N)) ? null : String(N);
      _.set(String(t(b)), w), w && p.add(w);
    }
    return { parents: _, kids: p };
  }, [e, t, a]), u = oe((_) => r ? !s.has(_) : l.has(_), [r, s, l]), f = we(() => e.filter((_) => {
    var b, N;
    let p = (b = i.get(String(t(_)))) != null ? b : null;
    const d = /* @__PURE__ */ new Set();
    for (; p && !d.has(p); ) {
      if (!u(p)) return !1;
      d.add(p), p = (N = i.get(p)) != null ? N : null;
    }
    return !0;
  }), [e, i, t, u]), y = oe((_, p) => {
    const d = (b, N) => {
      const w = new Set(b);
      return N ? w.add(_) : w.delete(_), w;
    };
    r ? o((b) => d(b, !p)) : c((b) => d(b, p));
  }, [r]);
  return {
    visible: f,
    hasChildren: (_) => m.has(String(t(_))),
    isOpen: (_) => u(String(t(_))),
    toggle: (_) => {
      const p = String(t(_));
      y(p, !u(p));
    },
    expandAll: () => {
      o(/* @__PURE__ */ new Set()), c(new Set(m));
    },
    collapseAll: () => {
      o(new Set(m)), c(/* @__PURE__ */ new Set());
    },
    expandAllTemporarily: () => {
      const _ = s, p = l;
      return o(/* @__PURE__ */ new Set()), c(new Set(m)), () => {
        o(_), c(p);
      };
    },
    reveal: (_) => {
      var b, N;
      let p = (b = i.get(String(_))) != null ? b : null;
      const d = /* @__PURE__ */ new Set();
      for (; p && !d.has(p); )
        y(p, !0), d.add(p), p = (N = i.get(p)) != null ? N : null;
    }
  };
}
function yv({ depth: e, hasChildren: t, open: a, onToggle: r, dim: s, toggleOutOfTabOrder: o, title: l, csvPath: c, children: i }) {
  const m = (f) => {
    f.stopPropagation(), r();
  }, u = l != null ? l : typeof i == "string" ? i : void 0;
  return /* @__PURE__ */ n.createElement(
    "span",
    {
      className: [Qt.cell, s ? Qt.dim : ""].filter(Boolean).join(" "),
      style: { paddingLeft: e * 16 },
      "data-tree-depth": e,
      "data-csv-path": c
    },
    t ? /* @__PURE__ */ n.createElement(
      "button",
      {
        type: "button",
        className: Qt.toggle,
        "aria-expanded": a,
        "aria-label": `${u ? `${u} ` : ""}${a ? "하위 접기" : "하위 펼치기"}`,
        onClick: m,
        tabIndex: o ? -1 : void 0,
        "data-csv-skip": ""
      },
      a ? "▾" : "▸"
    ) : /* @__PURE__ */ n.createElement("span", { className: Qt.spacer, "aria-hidden": "true" }),
    /* @__PURE__ */ n.createElement("span", { className: Qt.label, title: u }, i)
  );
}
function $c(e, t, a, r = !1) {
  const s = e[t.r];
  if (!s || t.i < 0 || t.i >= s.length) return null;
  const o = s[t.i], l = e.findIndex((i) => i.length > 0);
  let c = -1;
  for (let i = e.length - 1; i >= 0; i--) if (e[i].length > 0) {
    c = i;
    break;
  }
  switch (a) {
    case "ArrowLeft":
      return t.i > 0 ? { r: t.r, i: t.i - 1 } : null;
    case "ArrowRight":
      return t.i < s.length - 1 ? { r: t.r, i: t.i + 1 } : null;
    case "Home":
      return r ? { r: l, i: 0 } : { r: t.r, i: 0 };
    case "End":
      return r ? { r: c, i: e[c].length - 1 } : { r: t.r, i: s.length - 1 };
    case "ArrowUp":
    case "ArrowDown": {
      const i = a === "ArrowUp" ? -1 : 1;
      for (let m = t.r + i; m >= 0 && m < e.length; m += i)
        if (e[m].length > 0) return { r: m, i: xc(e[m], o) };
      return null;
    }
    default:
      return null;
  }
}
function xc(e, t) {
  let a = 0;
  for (let r = 1; r < e.length; r++)
    Math.abs(e[r] - t) < Math.abs(e[a] - t) && (a = r);
  return a;
}
function bv(e, t = {}) {
  var c;
  const a = (c = t.cellSelector) != null ? c : "[data-roving]", r = t.initialSelector, s = L(null), [o, l] = D(null);
  Z(() => {
    e.current !== o && l(e.current);
  }), Z(() => {
    if (!o) return;
    const i = () => Array.from(o.querySelectorAll(a)), m = () => {
      const p = i();
      if (!p.length) {
        s.current = null;
        return;
      }
      (!s.current || !p.includes(s.current)) && (s.current = r && p.find((d) => d.matches(r)) || p[0]), p.forEach((d) => {
        const b = d === s.current ? "0" : "-1";
        d.getAttribute("tabindex") !== b && d.setAttribute("tabindex", b);
      });
    }, u = () => {
      const p = i(), d = [], b = [], N = /* @__PURE__ */ new Map(), w = [];
      return p.forEach((k) => {
        var M;
        const x = k.tagName === "TR", E = x ? null : k.closest("td, th"), h = E && o.contains(E) ? E.parentElement : null, g = x ? k : (M = h != null ? h : k.parentElement) != null ? M : o;
        let $ = d.indexOf(g);
        $ < 0 && ($ = d.length, d.push(g), b.push([]), w.push([]));
        let A;
        if (x)
          A = 0;
        else if (E && h) {
          A = 0;
          for (const T of Array.from(h.cells)) {
            if (T === E) break;
            A += Math.max(1, T.colSpan || 1);
          }
        } else
          A = b[$].length;
        N.set(k, { r: $, i: b[$].length }), b[$].push(A), w[$].push(k);
      }), { rows: b, where: N, byPos: w };
    }, f = (p) => {
      var h;
      const d = p.target;
      if (!d || !d.matches(a) || !o.contains(d) || p.altKey || p.metaKey || d.tagName === "TR" && (p.key === "ArrowLeft" || p.key === "ArrowRight")) return;
      const { rows: b, where: N, byPos: w } = u(), k = N.get(d);
      if (!k) return;
      const x = $c(b, k, p.key, p.ctrlKey);
      if (x === null) {
        ["ArrowUp", "ArrowDown", "ArrowLeft", "ArrowRight", "Home", "End"].includes(p.key) && p.preventDefault();
        return;
      }
      p.preventDefault();
      const E = (h = w[x.r]) == null ? void 0 : h[x.i];
      E && (s.current = E, m(), E.focus());
    }, y = (p) => {
      const d = p.target;
      !d || !d.matches(a) || d === s.current || (s.current = d, m());
    };
    m(), o.addEventListener("keydown", f), o.addEventListener("focusin", y);
    const _ = typeof MutationObserver != "undefined" ? new MutationObserver(m) : null;
    return _ == null || _.observe(o, { childList: !0, subtree: !0 }), () => {
      o.removeEventListener("keydown", f), o.removeEventListener("focusin", y), _ == null || _.disconnect();
    };
  }, [o, a, r]);
}
const Dc = "_btn_r1trx_1", Ac = "_mark_r1trx_7", Cc = "_sr_r1trx_9", Qn = {
  btn: Dc,
  mark: Ac,
  sr: Cc
};
function Ev({ sortKey: e, sort: t, onSort: a, children: r, className: s = "", colSpan: o, style: l, title: c }) {
  const i = yr(t, e);
  return /* @__PURE__ */ n.createElement("th", { scope: "col", "aria-sort": i, colSpan: o, style: l, title: c, className: s }, /* @__PURE__ */ n.createElement("button", { type: "button", className: Qn.btn, onClick: () => a(pr(t, e)) }, /* @__PURE__ */ n.createElement("span", null, r), /* @__PURE__ */ n.createElement("span", { className: Qn.mark, "aria-hidden": "true" }, i === "ascending" ? "▲" : i === "descending" ? "▼" : "↕")));
}
function hv({ sort: e, labelOf: t }) {
  return /* @__PURE__ */ n.createElement("span", { className: Qn.sr, role: "status", "aria-live": "polite" }, br(e, t));
}
const Sc = "_card_14vt3_1", Mc = "_accent_14vt3_8", Tc = "_grow_14vt3_9", qc = "_head_14vt3_11", Bc = "_body_14vt3_20", Lc = "_title_14vt3_28", jc = "_trailing_14vt3_29", Rc = "_summary_14vt3_32", Ic = "_sumHead_14vt3_33", Oc = "_sumTotal_14vt3_42", Pc = "_tone_warn_14vt3_43", Xc = "_tone_ok_14vt3_44", zc = "_sumList_14vt3_46", Fc = "_sumEm_14vt3_55", Wc = "_sumFoot_14vt3_57", Hc = "_sumNote_14vt3_66", $e = {
  card: Sc,
  accent: Mc,
  grow: Tc,
  head: qc,
  body: Bc,
  title: Lc,
  trailing: jc,
  summary: Rc,
  sumHead: Ic,
  sumTotal: Oc,
  tone_warn: Pc,
  tone_ok: Xc,
  sumList: zc,
  sumEm: Fc,
  sumFoot: Wc,
  sumNote: Hc
};
function vr({
  title: e,
  trailing: t,
  accent: a,
  grow: r,
  flush: s,
  className: o = "",
  children: l
}) {
  return /* @__PURE__ */ n.createElement(
    "section",
    {
      className: [$e.card, a ? $e.accent : "", r ? $e.grow : "", o].filter(Boolean).join(" "),
      "data-csv-title": typeof e == "string" && e ? e : void 0
    },
    e !== void 0 && /* @__PURE__ */ n.createElement("header", { className: $e.head }, /* @__PURE__ */ n.createElement("span", { className: $e.title, role: "heading", "aria-level": 2 }, e), t && /* @__PURE__ */ n.createElement("span", { className: $e.trailing }, t)),
    s ? l : /* @__PURE__ */ n.createElement("div", { className: ["axe-card-body", $e.body].join(" ") }, l)
  );
}
function gv({
  title: e,
  total: t,
  items: a,
  footerLabel: r,
  footerValue: s,
  note: o,
  tone: l = "default",
  children: c
}) {
  return /* @__PURE__ */ n.createElement("section", { className: [$e.card, $e.accent, $e.summary, $e[`tone_${l}`]].join(" ") }, /* @__PURE__ */ n.createElement("header", { className: $e.sumHead }, /* @__PURE__ */ n.createElement("span", null, e), t !== void 0 && /* @__PURE__ */ n.createElement("strong", { className: $e.sumTotal }, t)), /* @__PURE__ */ n.createElement("ul", { className: $e.sumList }, a.map((i, m) => {
    var u;
    return /* @__PURE__ */ n.createElement("li", { key: (u = i.key) != null ? u : m, className: i.em ? $e.sumEm : "" }, /* @__PURE__ */ n.createElement("span", null, i.label), /* @__PURE__ */ n.createElement("strong", null, i.value));
  })), c, r !== void 0 && /* @__PURE__ */ n.createElement("footer", { className: $e.sumFoot }, /* @__PURE__ */ n.createElement("span", null, r), /* @__PURE__ */ n.createElement("strong", null, s)), o && /* @__PURE__ */ n.createElement("div", { className: $e.sumNote }, o));
}
let Kc = 0;
function Yt(e = "axe") {
  const t = L(null);
  return t.current || (t.current = `${e}-${++Kc}`), t.current;
}
const Uc = "_sr_1y2mv_2", Gc = "_skip_1y2mv_8", Yc = "_crit_1y2mv_16", Vc = "_c_danger_1y2mv_21", Qc = "_c_warn_1y2mv_22", Jc = "_critI_1y2mv_23", Zc = "_critBody_1y2mv_24", ei = "_critX_1y2mv_25", ti = "_ch_1y2mv_32", ni = "_chBtn_1y2mv_33", ai = "_chBox_1y2mv_43", Je = {
  sr: Uc,
  skip: Gc,
  crit: Yc,
  c_danger: Vc,
  c_warn: Qc,
  critI: Jc,
  critBody: Zc,
  critX: ei,
  ch: ti,
  chBtn: ni,
  chBox: ai
};
function kr({ as: e = "span", children: t, id: a }) {
  return /* @__PURE__ */ n.createElement(e, { className: Je.sr, id: a }, t);
}
function vv({ targets: e = [{ label: "본문 바로가기", targetId: "axe-main" }], className: t = "" }) {
  const a = (r, s) => {
    const o = document.getElementById(s);
    o && (r.preventDefault(), o.hasAttribute("tabindex") || o.setAttribute("tabindex", "-1"), o.focus(), o.scrollIntoView({ block: "start" }));
  };
  return /* @__PURE__ */ n.createElement("nav", { className: [Je.skip, t].filter(Boolean).join(" "), "aria-label": "건너뛰기" }, e.slice(0, 3).map((r) => /* @__PURE__ */ n.createElement("a", { key: r.targetId, href: `#${r.targetId}`, onClick: (s) => a(s, r.targetId) }, r.label)));
}
function kv({ title: e, children: t, tone: a = "danger", onClose: r, className: s = "" }) {
  return /* @__PURE__ */ n.createElement("div", { className: [Je.crit, Je[`c_${a}`], s].filter(Boolean).join(" "), role: "alert" }, /* @__PURE__ */ n.createElement("span", { className: Je.critI, "aria-hidden": "true" }, "▲"), /* @__PURE__ */ n.createElement("div", { className: Je.critBody }, /* @__PURE__ */ n.createElement("b", null, e), t ? /* @__PURE__ */ n.createElement("span", null, " ", t) : null), r && /* @__PURE__ */ n.createElement("button", { type: "button", className: Je.critX, onClick: r, "aria-label": "알림 닫기" }, "✕"));
}
function wv({ label: e, children: t, className: a = "" }) {
  const [r, s] = D(!1), o = Yt("axe-ch"), l = L(null), c = L(null);
  return Z(() => {
    if (!r) return;
    const i = (u) => {
      l.current && !l.current.contains(u.target) && s(!1);
    }, m = (u) => {
      var f;
      u.key !== "Escape" || u.isComposing || (u.preventDefault(), u.stopPropagation(), s(!1), (f = c.current) == null || f.focus());
    };
    return document.addEventListener("mousedown", i), document.addEventListener("keydown", m, !0), () => {
      document.removeEventListener("mousedown", i), document.removeEventListener("keydown", m, !0);
    };
  }, [r]), /* @__PURE__ */ n.createElement("span", { className: [Je.ch, a].filter(Boolean).join(" "), ref: l }, /* @__PURE__ */ n.createElement(
    "button",
    {
      ref: c,
      type: "button",
      className: Je.chBtn,
      "aria-label": e,
      "aria-expanded": r,
      "aria-controls": o,
      onClick: () => s((i) => !i)
    },
    "?"
  ), r && /* @__PURE__ */ n.createElement("span", { id: o, role: "region", "aria-label": e, className: Je.chBox }, t));
}
function Jn(e, t, a = "codeName") {
  const r = (e != null ? e : "").trim();
  if (!r) return "";
  const s = (t != null ? t : "").trim();
  return !s || a === "code" ? r : a === "name" ? s : `${r}. ${s}`;
}
function ri(e, t = "전체", a = "codeName") {
  if (e.length === 0) return t;
  const r = Jn(e[0].cd, e[0].nm, a);
  return e.length === 1 ? r : `${r} 외 ${e.length - 1}건`;
}
function si(e, t, a, r) {
  const s = (e != null ? e : "").trim();
  if (!s) return null;
  if (t && t.name && t.code === s) return t.name;
  if (a && a.code === s && a.name) return a.name;
  const o = r == null ? void 0 : r.find((l) => l.code === s);
  return o && o.name ? o.name : null;
}
const oi = "_root_umk7w_1", li = "_rootNone_umk7w_5", ci = "_field_umk7w_12", ii = "_codeInput_umk7w_13", ui = "_pickBtn_umk7w_17", mi = "_suggest_umk7w_34", di = "_suggestList_umk7w_40", fi = "_suggestRow_umk7w_41", _i = "_suggestOn_umk7w_42", pi = "_suggestEmpty_umk7w_47", yi = "_suggestMore_umk7w_47", bi = "_popup_umk7w_51", Ei = "_popupHead_umk7w_65", hi = "_searchRow_umk7w_75", gi = "_list_umk7w_79", vi = "_current_umk7w_88", ki = "_empty_umk7w_92", wi = "_summaryBtn_umk7w_100", Ni = "_ov_umk7w_121", $i = "_modal_umk7w_132", xi = "_modalWide_umk7w_132", Di = "_head_umk7w_144", Ai = "_sub_umk7w_152", Ci = "_x_umk7w_154", Si = "_body_umk7w_171", Mi = "_chips_umk7w_179", Ti = "_chip_umk7w_179", qi = "_chipOn_umk7w_193", Bi = "_search_umk7w_75", Li = "_tbl_umk7w_212", ji = "_row_umk7w_242", Ri = "_rowCursor_umk7w_244", Ii = "_rowPicked_umk7w_245", Oi = "_rowCurrent_umk7w_246", Pi = "_curTag_umk7w_247", Xi = "_busy_umk7w_248", zi = "_count_umk7w_249", Fi = "_chk_umk7w_251", Wi = "_tdLeft_umk7w_252", Hi = "_tdCenter_umk7w_253", Ki = "_emptyCell_umk7w_255", Ui = "_stop_umk7w_257", Gi = "_more_umk7w_268", Yi = "_pager_umk7w_280", Vi = "_note_umk7w_293", Qi = "_foot_umk7w_296", Ji = "_ghost_umk7w_305", Zi = "_primary_umk7w_317", U = {
  root: oi,
  rootNone: li,
  field: ci,
  codeInput: ii,
  pickBtn: ui,
  suggest: mi,
  suggestList: di,
  suggestRow: fi,
  suggestOn: _i,
  suggestEmpty: pi,
  suggestMore: yi,
  popup: bi,
  popupHead: Ei,
  searchRow: hi,
  list: gi,
  current: vi,
  empty: ki,
  summaryBtn: wi,
  ov: Ni,
  modal: $i,
  modalWide: xi,
  head: Di,
  sub: Ai,
  x: Ci,
  body: Si,
  chips: Mi,
  chip: Ti,
  chipOn: qi,
  search: Bi,
  tbl: Li,
  row: ji,
  rowCursor: Ri,
  rowPicked: Ii,
  rowCurrent: Oi,
  curTag: Pi,
  busy: Xi,
  count: zi,
  chk: Fi,
  tdLeft: Wi,
  tdCenter: Hi,
  emptyCell: Ki,
  stop: Ui,
  more: Gi,
  pager: Yi,
  note: Vi,
  foot: Qi,
  ghost: Ji,
  primary: Zi
};
function eu({
  items: e,
  value: t,
  title: a,
  popupRef: r,
  anchorRef: s,
  pos: o,
  onPick: l,
  onClose: c
}) {
  const [i, m] = D(""), u = we(() => {
    const f = i.trim().toLowerCase();
    return f ? e.filter(
      (y) => {
        var _;
        return y.code.toLowerCase().includes(f) || y.name.toLowerCase().includes(f) || ((_ = y.sub) != null ? _ : "").toLowerCase().includes(f);
      }
    ) : e;
  }, [e, i]);
  return Z(() => {
    const f = (_) => {
      const p = _.target;
      r.current && !r.current.contains(p) && s.current && !s.current.contains(p) && c();
    }, y = (_) => {
      _.key === "Escape" && c();
    };
    return document.addEventListener("mousedown", f), document.addEventListener("keydown", y), () => {
      document.removeEventListener("mousedown", f), document.removeEventListener("keydown", y);
    };
  }, [r, s, c]), /* @__PURE__ */ n.createElement(Gt, null, /* @__PURE__ */ n.createElement(
    "div",
    {
      ref: r,
      className: U.popup,
      style: { left: o.left, top: o.top },
      role: "dialog",
      "aria-label": "코드 선택"
    },
    /* @__PURE__ */ n.createElement("header", { className: U.popupHead }, /* @__PURE__ */ n.createElement("strong", null, a), /* @__PURE__ */ n.createElement("button", { type: "button", "aria-label": "닫기", onClick: c }, "✕")),
    /* @__PURE__ */ n.createElement("div", { className: U.searchRow }, /* @__PURE__ */ n.createElement(
      "input",
      {
        autoFocus: !0,
        value: i,
        "aria-label": "코드·명칭 검색",
        placeholder: "코드·명칭 검색",
        onChange: (f) => m(f.target.value),
        onKeyDown: (f) => {
          f.key === "Enter" && u.length && l(u[0]), f.key === "Escape" && c();
        }
      }
    )),
    /* @__PURE__ */ n.createElement("ul", { className: U.list }, u.map((f) => /* @__PURE__ */ n.createElement("li", { key: f.code }, /* @__PURE__ */ n.createElement("button", { type: "button", onClick: () => l(f), className: f.code === t ? U.current : "" }, /* @__PURE__ */ n.createElement("code", null, f.code), /* @__PURE__ */ n.createElement("span", null, f.name), f.sub && /* @__PURE__ */ n.createElement("small", null, f.sub)))), u.length === 0 && /* @__PURE__ */ n.createElement("li", { className: U.empty }, "검색 결과가 없습니다"))
  ));
}
const wr = 250, _n = 7;
function wa(e, t) {
  const a = t.trim().toLowerCase();
  if (!a) return e;
  const r = e.toLowerCase().indexOf(a);
  return r < 0 ? e : /* @__PURE__ */ n.createElement(n.Fragment, null, e.slice(0, r), /* @__PURE__ */ n.createElement("b", null, e.slice(r, r + a.length)), e.slice(r + a.length));
}
function tu(e, t) {
  const a = e.map((r) => ({ cd: r.code, nm: r.name, sub: r.sub }));
  return {
    key: "static",
    title: typeof t == "string" ? t : "코드 선택",
    nameLabel: "명칭",
    fetch: ({ q: r }) => {
      const s = r.trim().toLowerCase();
      return s ? Promise.resolve({
        rows: a.filter(
          (o) => {
            var l;
            return o.cd.toLowerCase().includes(s) || o.nm.toLowerCase().includes(s) || String((l = o.sub) != null ? l : "").toLowerCase().includes(s);
          }
        )
      }) : Promise.resolve({ rows: a });
    }
  };
}
function nu({
  source: e,
  items: t,
  title: a,
  multiple: r,
  selected: s,
  current: o,
  searchRef: l,
  onConfirm: c,
  onClose: i
}) {
  var se;
  const m = we(() => tu(t != null ? t : [], a), [t, a]), u = e != null ? e : m, [f, y] = D(""), [_, p] = D((se = e == null ? void 0 : e.defaultFilter) != null ? se : null), [d, b] = D(0), [N, w] = D([]), [k, x] = D(!1), [E, h] = D(!1), [g, $] = D(null), [A, M] = D(0), [T, I] = D(/* @__PURE__ */ new Map()), q = L(u);
  q.current = u, Z(() => {
    var J;
    y(""), p((J = q.current.defaultFilter) != null ? J : null), b(0), M(0), $(null), I(new Map((s != null ? s : []).map((R) => [R.cd, R])));
    const B = window.setTimeout(() => {
      l.current && l.current.focus();
    }, 30);
    return () => window.clearTimeout(B);
  }, [u.key]), Z(() => {
    let B = !0;
    h(!0);
    const J = () => {
      q.current.fetch({ q: f.trim(), ty: _, page: d }).then((z) => {
        var X, H;
        if (!B) return;
        w((X = z.rows) != null ? X : []), x(!!z.hasMore), $(null);
        const Y = o ? ((H = z.rows) != null ? H : []).findIndex((ce) => ce.cd === o) : -1;
        M(Y > 0 ? Y : 0);
      }).catch((z) => {
        B && (w([]), x(!1), $("코드를 불러오지 못했습니다. 잠시 후 다시 조회하세요."));
      }).finally(() => {
        B && h(!1);
      });
    }, R = window.setTimeout(J, f.trim() ? wr : 0);
    return () => {
      B = !1, window.clearTimeout(R);
    };
  }, [u.key, f, _, d]);
  const P = L(null);
  Z(() => {
    const B = P.current && P.current.children[A];
    B && "scrollIntoView" in B && B.scrollIntoView({ block: "nearest" });
  }, [A, N]);
  const G = we(() => {
    var J, R;
    const B = [
      { key: "cd", label: "코드", width: (J = u.codeWidth) != null ? J : "96px", align: "center" },
      {
        key: "nm",
        label: u.nameLabel,
        align: "left",
        render: (z) => /* @__PURE__ */ n.createElement(n.Fragment, null, z.nm, z.useYn === !1 && /* @__PURE__ */ n.createElement("span", { className: U.stop }, "사용중단"))
      }
    ];
    return u.typeLabel && B.push({
      key: "__ty",
      label: "구분",
      width: "110px",
      align: "center",
      render: (z) => u.typeLabel ? u.typeLabel(z) : ""
    }), B.concat((R = u.extraColumns) != null ? R : []);
  }, [u]), K = oe((B) => {
    I((J) => {
      const R = new Map(J);
      return R.has(B.cd) ? R.delete(B.cd) : R.set(B.cd, B), R;
    });
  }, []), j = oe((B) => c([B]), [c]), te = oe(() => c(Array.from(T.values())), [T, c]), ne = N.length > 0 && N.every((B) => T.has(B.cd)), v = () => {
    I((B) => {
      const J = new Map(B);
      return ne ? N.forEach((R) => J.delete(R.cd)) : N.forEach((R) => J.set(R.cd, R)), J;
    });
  }, O = L(null);
  Z(() => {
    const B = document.activeElement;
    return () => {
      window.setTimeout(() => {
        B && B.isConnected && typeof B.focus == "function" && (!document.activeElement || document.activeElement === document.body) && B.focus();
      }, 0);
    };
  }, []);
  const V = L(i);
  V.current = i, Z(() => {
    const B = (J) => {
      J.key !== "Escape" || J.isComposing || (J.stopPropagation(), J.preventDefault(), V.current());
    };
    return document.addEventListener("keydown", B, !0), () => document.removeEventListener("keydown", B, !0);
  }, []);
  const Q = (B) => {
    var z;
    if (B.nativeEvent.isComposing || B.keyCode === 229) return;
    if (B.key === "Tab" && O.current) {
      const Y = Array.from(O.current.querySelectorAll("input:not([disabled]), button:not([disabled])"));
      if (Y.length) {
        const X = Y[0], H = Y[Y.length - 1], ce = document.activeElement;
        B.shiftKey && ce === X ? (B.preventDefault(), H.focus()) : !B.shiftKey && ce === H && (B.preventDefault(), X.focus());
      }
      return;
    }
    if (B.key === "Escape") {
      B.stopPropagation(), i();
      return;
    }
    const J = B.target, R = J === l.current;
    if (!(!R && J !== O.current)) {
      if (B.key === "ArrowDown" || B.key === "ArrowUp") {
        B.preventDefault(), M((Y) => Math.max(0, Math.min(N.length - 1, Y + (B.key === "ArrowDown" ? 1 : -1))));
        return;
      }
      if (B.key === " " && r && N[A] && !(R && ((z = l.current) != null && z.value))) {
        B.preventDefault(), K(N[A]);
        return;
      }
      if (B.key === "Enter") {
        if (B.preventDefault(), E) return;
        r ? te() : N[A] && j(N[A]);
      }
    }
  };
  return /* @__PURE__ */ n.createElement(Gt, null, /* @__PURE__ */ n.createElement("div", { className: U.ov, onClick: i }, /* @__PURE__ */ n.createElement(
    "div",
    {
      className: u.wide ? `${U.modal} ${U.modalWide}` : U.modal,
      role: "dialog",
      "aria-modal": "true",
      "aria-label": u.title,
      ref: O,
      onClick: (B) => B.stopPropagation(),
      onKeyDown: Q
    },
    /* @__PURE__ */ n.createElement("div", { className: U.head }, /* @__PURE__ */ n.createElement("h2", null, u.title), r && /* @__PURE__ */ n.createElement("span", { className: U.sub }, "복수 선택 가능"), /* @__PURE__ */ n.createElement("button", { type: "button", className: U.x, onClick: i, "aria-label": "닫기" }, "×")),
    /* @__PURE__ */ n.createElement("div", { className: U.body }, u.filters && u.filters.length > 0 && /* @__PURE__ */ n.createElement("div", { className: U.chips }, /* @__PURE__ */ n.createElement(
      "button",
      {
        type: "button",
        className: _ === null ? `${U.chip} ${U.chipOn}` : U.chip,
        onClick: () => {
          p(null), b(0);
        }
      },
      "전체"
    ), u.filters.map((B) => /* @__PURE__ */ n.createElement(
      "button",
      {
        key: B.value,
        type: "button",
        className: _ === B.value ? `${U.chip} ${U.chipOn}` : U.chip,
        onClick: () => {
          p(B.value), b(0);
        }
      },
      B.label
    ))), /* @__PURE__ */ n.createElement(
      "input",
      {
        ref: l,
        className: U.search,
        value: f,
        placeholder: "코드, 명칭 검색",
        autoComplete: "off",
        "aria-label": "코드·명칭 검색",
        onChange: (B) => {
          y(B.target.value), b(0);
        }
      }
    ), /* @__PURE__ */ n.createElement("div", { className: U.tbl }, /* @__PURE__ */ n.createElement("table", null, /* @__PURE__ */ n.createElement("thead", null, /* @__PURE__ */ n.createElement("tr", null, r && /* @__PURE__ */ n.createElement("th", { className: U.chk }, /* @__PURE__ */ n.createElement(
      "input",
      {
        type: "checkbox",
        checked: ne,
        onChange: v,
        "aria-label": "표시된 행 전체 선택"
      }
    )), G.map((B) => /* @__PURE__ */ n.createElement("th", { key: B.key, style: B.width ? { width: B.width } : void 0 }, B.label)))), /* @__PURE__ */ n.createElement("tbody", { ref: P, className: E && N.length > 0 ? U.busy : void 0, "aria-busy": E }, N.length === 0 ? /* @__PURE__ */ n.createElement("tr", null, /* @__PURE__ */ n.createElement("td", { className: U.emptyCell, colSpan: G.length + (r ? 1 : 0) }, E ? "검색 중…" : g || u.emptyText || "검색 결과가 없습니다")) : N.map((B, J) => /* @__PURE__ */ n.createElement(
      "tr",
      {
        key: B.cd,
        className: [
          U.row,
          J === A ? U.rowCursor : "",
          T.has(B.cd) ? U.rowPicked : "",
          !r && o && B.cd === o ? U.rowCurrent : ""
        ].filter(Boolean).join(" "),
        "aria-selected": J === A,
        onClick: () => {
          M(J), r ? K(B) : j(B);
        }
      },
      r && /* @__PURE__ */ n.createElement("td", { className: U.chk }, /* @__PURE__ */ n.createElement(
        "input",
        {
          type: "checkbox",
          checked: T.has(B.cd),
          onChange: () => K(B),
          onClick: (R) => R.stopPropagation(),
          "aria-label": `${B.cd} 선택`
        }
      )),
      G.map((R) => {
        var z, Y;
        return /* @__PURE__ */ n.createElement(
          "td",
          {
            key: R.key,
            className: R.align === "left" ? U.tdLeft : U.tdCenter,
            title: R.render ? void 0 : String((z = B[R.key]) != null ? z : "")
          },
          R.render ? R.render(B) : String((Y = B[R.key]) != null ? Y : ""),
          R.key === "cd" && !r && o && B.cd === o && /* @__PURE__ */ n.createElement("em", { className: U.curTag }, "현재")
        );
      })
    ))))), /* @__PURE__ */ n.createElement("p", { className: U.count, role: "status", "aria-live": "polite" }, E ? "검색 중…" : g ? "" : `${N.length}건`, !r && !E && !g && N.length > 0 && " — ↑↓ 로 고르고 Enter, 또는 줄을 누르세요"), (k || d > 0) && /* @__PURE__ */ n.createElement("div", { className: U.more }, /* @__PURE__ */ n.createElement("span", null, k ? "표시 상한까지만 보여 주고 있습니다 — 검색어를 좁히거나 다음 쪽으로 넘기세요" : "마지막 쪽입니다"), /* @__PURE__ */ n.createElement("span", { className: U.pager }, /* @__PURE__ */ n.createElement("button", { type: "button", disabled: d === 0, onClick: () => b((B) => Math.max(0, B - 1)) }, "이전"), /* @__PURE__ */ n.createElement("b", null, d + 1), k && /* @__PURE__ */ n.createElement("button", { type: "button", onClick: () => b((B) => B + 1) }, "다음"))), r && /* @__PURE__ */ n.createElement("p", { className: U.note }, "선택 ", /* @__PURE__ */ n.createElement("b", null, T.size), "건 — 선택이 없으면 ", /* @__PURE__ */ n.createElement("b", null, "전체"), "로 조회됩니다")),
    /* @__PURE__ */ n.createElement("div", { className: U.foot }, r && /* @__PURE__ */ n.createElement("button", { type: "button", className: U.ghost, onClick: () => I(/* @__PURE__ */ new Map()) }, "초기화"), /* @__PURE__ */ n.createElement("button", { type: "button", className: U.ghost, onClick: i }, "취소"), r && /* @__PURE__ */ n.createElement("button", { type: "button", className: U.primary, onClick: te }, "확인"))
  )));
}
let au = 0;
function ru({ source: e, items: t, anchorRef: a }) {
  const [r, s] = D(null), [o, l] = D(-1), [c, i] = D(null), m = L(null), u = L(0), f = L(`axe-cp-${++au}`), y = L(e);
  y.current = e;
  const _ = L(t);
  _.current = t;
  const p = oe(() => {
    m.current != null && (window.clearTimeout(m.current), m.current = null), u.current += 1, s(null), l(-1);
  }, []);
  Z(() => p, [p]);
  const d = (b) => {
    m.current != null && window.clearTimeout(m.current), u.current += 1;
    const N = u.current;
    if (!b.trim()) {
      s(null), l(-1);
      return;
    }
    m.current = window.setTimeout(async () => {
      var x;
      let w = [], k = !1;
      try {
        const E = y.current;
        if (E) {
          const h = await E.fetch({ q: b, ty: null, page: 0 });
          w = h.rows, k = !!h.hasMore || w.length > _n;
        } else {
          const h = b.trim().toLowerCase();
          w = ((x = _.current) != null ? x : []).filter((g) => {
            var $;
            return g.code.toLowerCase().includes(h) || g.name.toLowerCase().includes(h) || (($ = g.sub) != null ? $ : "").toLowerCase().includes(h);
          }).map((g) => ({ cd: g.code, nm: g.name, sub: g.sub })), k = w.length > _n;
        }
      } catch {
        return;
      }
      N === u.current && (s({ rows: w.slice(0, _n), more: k, q: b }), l(-1));
    }, wr);
  };
  return Z(() => {
    if (!r) {
      i(null);
      return;
    }
    const b = () => {
      const N = a.current;
      if (!N) return;
      const w = N.getBoundingClientRect(), k = Math.min(r.rows.length, _n) * 28 + 34, x = w.bottom + k > window.innerHeight - 8 && w.top - k - 2 > 8 ? w.top - k - 2 : w.bottom + 2, E = Math.max(w.width, 260);
      i({ left: Math.max(8, Math.min(w.left, window.innerWidth - E - 8)), top: x, width: E });
    };
    return b(), window.addEventListener("resize", b), window.addEventListener("scroll", b, !0), () => {
      window.removeEventListener("resize", b), window.removeEventListener("scroll", b, !0);
    };
  }, [r, a]), { sugg: r, active: o, setActive: l, suggPos: c, suggId: f, runSuggest: d, cancelSuggest: p };
}
function Nv({
  value: e = "",
  name: t,
  show: a = "codeName",
  onChange: r,
  items: s,
  source: o,
  multiple: l = !1,
  selected: c,
  onConfirm: i,
  current: m,
  trigger: u,
  emptyLabel: f = "전체",
  open: y,
  onOpenChange: _,
  placeholder: p,
  title: d = "코드 선택",
  variant: b,
  disabled: N,
  className: w = "",
  maxLength: k,
  numeric: x = !1,
  ariaLabel: E,
  autoFocus: h,
  onEnter: g,
  onEscape: $,
  onBlur: A,
  invalid: M,
  selectOnFocus: T = !1
}) {
  const I = o ? "source" : "static", q = E != null ? E : (o == null ? void 0 : o.title) || (typeof d == "string" && d !== "코드 선택" ? d : "") || "코드", P = b != null ? b : I === "source" ? "modal" : "anchor", G = u != null ? u : l ? "summary" : "input", [K, j] = D(!1), te = y != null ? y : K, ne = oe(
    (W) => {
      y === void 0 && j(W), _ && _(W);
    },
    [y, _]
  ), v = L(null), O = L(!1), V = L(null), Q = L(null), [se, B] = D(null), J = () => {
    if (!N) {
      if (P === "anchor") {
        const W = v.current;
        if (!W) return;
        const fe = W.getBoundingClientRect(), C = 320, F = fe.bottom + C > window.innerHeight ? Math.max(8, fe.top - C - 4) : fe.bottom + 4;
        B({ left: Math.min(fe.left, window.innerWidth - 320), top: F });
      }
      ne(!0);
    }
  }, R = oe(() => ne(!1), [ne]), [z, Y] = D(!1), [X, H] = D(null), ce = L(null);
  (!ce.current || ce.current.name !== t) && (ce.current = { name: t, code: e });
  const Ue = si(e, ce.current, X, s), Re = Jn(e, Ue, a), Ie = Jn(e, Ue), vt = (W) => {
    !l && W[0] && H({ code: W[0].cd, name: W[0].nm }), i ? i(W) : W[0] && r && r(W[0].cd, { code: W[0].cd, name: W[0].nm });
  }, { sugg: xe, active: Xe, setActive: nt, suggPos: Rt, suggId: Oe, runSuggest: Ln, cancelSuggest: kt } = ru({ source: o, items: s, anchorRef: v }), wt = (W) => {
    kt(), vt([W]);
  };
  return /* @__PURE__ */ n.createElement("span", { ref: v, className: [G === "none" ? U.rootNone : U.root, w].filter(Boolean).join(" ") }, G === "input" && /* @__PURE__ */ n.createElement("span", { className: U.field }, /* @__PURE__ */ n.createElement(
    "input",
    {
      className: U.codeInput,
      style: { paddingRight: 24 },
      value: z ? e : Re,
      placeholder: p,
      disabled: N,
      maxLength: k,
      inputMode: x ? "numeric" : void 0,
      autoComplete: "off",
      autoFocus: h,
      "aria-label": q,
      "aria-invalid": M ? !0 : void 0,
      onChange: (W) => {
        const fe = W.target.value.trim(), C = x ? fe.replace(/[^0-9]/g, "") : fe, F = k ? C.slice(0, k) : C;
        r && r(F), !N && (o || s) && Ln(F);
      },
      onKeyDown: (W) => {
        if (W.key === "F2") {
          W.preventDefault(), kt(), J();
          return;
        }
        if (!xe) {
          W.key === "Enter" && g && !W.nativeEvent.isComposing ? (W.preventDefault(), g()) : W.key === "Escape" && $ && (W.preventDefault(), $());
          return;
        }
        const fe = xe.rows.length;
        W.key === "ArrowDown" && fe ? (W.preventDefault(), nt((C) => (C + 1) % fe)) : W.key === "ArrowUp" && fe ? (W.preventDefault(), nt((C) => (C <= 0 ? fe : C) - 1)) : W.key === "Enter" && Xe >= 0 && xe.rows[Xe] ? (W.preventDefault(), wt(xe.rows[Xe])) : W.key === "Enter" && g && !W.nativeEvent.isComposing ? (W.preventDefault(), kt(), g()) : W.key === "Escape" && (W.preventDefault(), W.stopPropagation(), W.nativeEvent.stopImmediatePropagation(), kt());
      },
      onFocus: (W) => {
        if (Y(!0), !T) return;
        const fe = W.currentTarget;
        window.requestAnimationFrame(() => fe.select());
      },
      onMouseDown: (W) => {
        T && document.activeElement !== W.currentTarget && (O.current = !0);
      },
      onMouseUp: (W) => {
        O.current && (W.preventDefault(), O.current = !1);
      },
      onBlur: () => {
        Y(!1), kt(), A && A();
      },
      title: typeof M == "string" && M ? M : Ie && Ie !== e ? `${Ie} (F2: 코드 선택)` : "F2: 코드 선택",
      role: "combobox",
      "aria-autocomplete": "list",
      "aria-expanded": !!xe,
      "aria-controls": xe ? Oe.current : void 0,
      "aria-activedescendant": xe && Xe >= 0 ? `${Oe.current}-${Xe}` : void 0,
      "aria-describedby": typeof M == "string" && M ? `${Oe.current}-inv` : void 0
    }
  ), typeof M == "string" && M && /* @__PURE__ */ n.createElement(kr, { id: `${Oe.current}-inv` }, M), /* @__PURE__ */ n.createElement(
    "button",
    {
      type: "button",
      className: U.pickBtn,
      "aria-label": "코드 선택 열기",
      disabled: N,
      onClick: J,
      onMouseDown: (W) => W.preventDefault(),
      tabIndex: -1
    },
    /* @__PURE__ */ n.createElement(gn, { name: "search", size: 13 })
  )), G === "summary" && /* @__PURE__ */ n.createElement("button", { type: "button", className: U.summaryBtn, disabled: N, onClick: J }, /* @__PURE__ */ n.createElement("span", null, ri(c != null ? c : [], f, a)), /* @__PURE__ */ n.createElement("i", { "aria-hidden": "true" }, /* @__PURE__ */ n.createElement(gn, { name: "search", size: 13 }))), xe && Rt && G === "input" && !te && /* @__PURE__ */ n.createElement(Gt, null, /* @__PURE__ */ n.createElement(
    "div",
    {
      className: U.suggest,
      style: { left: Rt.left, top: Rt.top, width: Rt.width },
      onMouseDown: (W) => W.preventDefault()
    },
    xe.rows.length === 0 ? /* @__PURE__ */ n.createElement("div", { className: U.suggestEmpty }, "일치하는 코드가 없습니다 · F2 로 전체 검색") : /* @__PURE__ */ n.createElement("ul", { id: Oe.current, role: "listbox", className: U.suggestList }, xe.rows.map((W, fe) => /* @__PURE__ */ n.createElement(
      "li",
      {
        key: W.cd,
        id: `${Oe.current}-${fe}`,
        role: "option",
        "aria-selected": fe === Xe,
        className: [U.suggestRow, fe === Xe ? U.suggestOn : ""].filter(Boolean).join(" "),
        onMouseEnter: () => nt(fe),
        onClick: () => wt(W)
      },
      /* @__PURE__ */ n.createElement("code", null, wa(W.cd, xe.q)),
      /* @__PURE__ */ n.createElement("span", null, wa(W.nm, xe.q)),
      W.useYn === !1 && /* @__PURE__ */ n.createElement("em", null, "사용중단")
    ))),
    xe.more && /* @__PURE__ */ n.createElement("div", { className: U.suggestMore }, "더 있습니다 · F2 로 전체 보기")
  )), te && I === "static" && P === "anchor" && se && /* @__PURE__ */ n.createElement(
    eu,
    {
      items: s != null ? s : [],
      value: e,
      title: d,
      popupRef: V,
      anchorRef: v,
      pos: se,
      onPick: (W) => {
        H({ code: W.code, name: W.name }), r && r(W.code, W), R();
      },
      onClose: R
    }
  ), te && (I === "source" || P === "modal") && /* @__PURE__ */ n.createElement(
    nu,
    {
      source: o,
      items: s,
      title: d,
      multiple: l,
      selected: c,
      current: m,
      searchRef: Q,
      onConfirm: (W) => {
        vt(W), R();
      },
      onClose: R
    }
  ));
}
const ia = 864e5;
function su(e) {
  return e % 4 === 0 && e % 100 !== 0 || e % 400 === 0;
}
function Le(e, t) {
  return t === 2 ? su(e) ? 29 : 28 : t === 4 || t === 6 || t === 9 || t === 11 ? 30 : 31;
}
function ht(e) {
  return Math.round(Date.UTC(+e.slice(0, 4), +e.slice(5, 7) - 1, +e.slice(8, 10)) / ia);
}
function ou(e) {
  const t = new Date(e * ia);
  return `${t.getUTCFullYear()}-${String(t.getUTCMonth() + 1).padStart(2, "0")}-${String(t.getUTCDate()).padStart(2, "0")}`;
}
function Cn(e, t) {
  return ou(ht(e) + t);
}
function ua(e) {
  return new Date(ht(e) * ia).getUTCDay();
}
const Na = "1900-01-01", $a = "2099-12-31", In = ["일", "월", "화", "수", "목", "금", "토"], vn = (e) => String(e).padStart(2, "0");
function tt(e, t, a) {
  return `${String(e).padStart(4, "0")}-${vn(t)}-${vn(a)}`;
}
function de(e) {
  const t = /^(\d{4})-(\d{2})-(\d{2})$/.exec(e != null ? e : "");
  if (!t) return null;
  const a = +t[1], r = +t[2], s = +t[3];
  return r < 1 || r > 12 || s < 1 || s > Le(a, r) ? null : { y: a, m: r, d: s };
}
function lu(e) {
  const t = /^(\d{4})-(\d{2})$/.exec(e != null ? e : "");
  if (!t) return null;
  const a = +t[1], r = +t[2];
  return r < 1 || r > 12 ? null : { y: a, m: r, d: 1 };
}
function Jt(e, t) {
  return t === "month" ? lu(e) : de(e);
}
function qe(e, t) {
  return t === "month" ? `${String(e.y).padStart(4, "0")}-${vn(e.m)}` : tt(e.y, e.m, e.d);
}
function je(e) {
  return new Date(Date.UTC(e.y, e.m - 1, e.d)).getUTCDay();
}
function cn(e, t) {
  const a = new Date(Date.UTC(e.y, e.m - 1, e.d + t));
  return { y: a.getUTCFullYear(), m: a.getUTCMonth() + 1, d: a.getUTCDate() };
}
function gt(e, t) {
  const a = e.y * 12 + (e.m - 1) + t, r = Math.floor(a / 12), s = (a % 12 + 12) % 12 + 1;
  return { y: r, m: s, d: Math.min(e.d, Le(r, s)) };
}
function cu(e, t, a) {
  return e >= t && e <= a;
}
function Ot(e, t) {
  return e.replace(/\D/g, "").slice(0, t === "month" ? 6 : 8);
}
function On(e, t) {
  const a = e.slice(0, 4), r = e.slice(4, 6), s = e.slice(6, 8);
  let o = a;
  return e.length > 4 && (o += "-" + r), t === "date" && e.length > 6 && (o += "-" + s), o;
}
function xa(e, t) {
  if (t <= 0) return 0;
  let a = 0;
  for (let r = 0; r < e.length; r++)
    if (/\d/.test(e[r]) && (a++, a === t))
      return r + 1;
  return e.length;
}
function En(e, t, a) {
  let r, s, o = 1;
  if (t === "month")
    if (e.length === 6)
      r = +e.slice(0, 4), s = +e.slice(4, 6);
    else if (e.length === 4)
      r = 2e3 + +e.slice(0, 2), s = +e.slice(2, 4);
    else return null;
  else if (e.length === 8)
    r = +e.slice(0, 4), s = +e.slice(4, 6), o = +e.slice(6, 8);
  else if (e.length === 6)
    r = 2e3 + +e.slice(0, 2), s = +e.slice(2, 4), o = +e.slice(4, 6);
  else if (e.length === 4)
    r = a.y, s = +e.slice(0, 2), o = +e.slice(2, 4);
  else return null;
  return s < 1 || s > 12 || o < 1 || o > Le(r, s) ? null : { y: r, m: s, d: o };
}
function iu(e, t, a) {
  const r = e.trim(), s = t === "month" ? /^(\d{4})\D+(\d{1,2})$/.exec(r) : /^(\d{4})\D+(\d{1,2})\D+(\d{1,2})$/.exec(r);
  if (s) {
    const o = { y: +s[1], m: +s[2], d: t === "month" ? 1 : +s[3] };
    return o.m >= 1 && o.m <= 12 && o.d >= 1 && o.d <= Le(o.y, o.m) ? o : null;
  }
  return En(r.replace(/\D/g, ""), t, a);
}
function uu(e, t) {
  const a = { y: e, m: t, d: 1 }, r = cn(a, -je(a));
  return Array.from({ length: 42 }, (s, o) => cn(r, o));
}
function mu(e, t) {
  const a = e.y, r = [], s = (m, u) => `${String(m).padStart(4, "0")}-${vn(u)}`, o = (m, u, f) => tt(m, u, f);
  if (t === "month") {
    r.push({ label: "이번 달", from: s(a, e.m), to: s(a, e.m) });
    const m = gt(e, -1);
    r.push({ label: "지난달", from: s(m.y, m.m), to: s(m.y, m.m) }), r.push({ label: "올해", from: s(a, 1), to: s(a, 12) }), r.push({ label: "올해 누계", from: s(a, 1), to: s(a, e.m) }), r.push({ label: "전년도", from: s(a - 1, 1), to: s(a - 1, 12) });
    for (let u = 1; u <= 4; u++) r.push({ label: `${u}분기`, from: s(a, u * 3 - 2), to: s(a, u * 3) });
    return r.push({ label: "상반기", from: s(a, 1), to: s(a, 6) }), r.push({ label: "하반기", from: s(a, 7), to: s(a, 12) }), r;
  }
  const l = tt(e.y, e.m, e.d);
  r.push({ label: "오늘", from: l, to: l });
  const c = cn(e, -je(e));
  r.push({ label: "이번 주", from: qe(c, "date"), to: qe(cn(c, 6), "date") }), r.push({ label: "이번 달", from: o(a, e.m, 1), to: o(a, e.m, Le(a, e.m)) });
  const i = gt({ ...e, d: 1 }, -1);
  r.push({ label: "지난달", from: o(i.y, i.m, 1), to: o(i.y, i.m, Le(i.y, i.m)) }), r.push({ label: "올해", from: o(a, 1, 1), to: o(a, 12, 31) }), r.push({ label: "올해 오늘까지", from: o(a, 1, 1), to: l }), r.push({ label: "전년도", from: o(a - 1, 1, 1), to: o(a - 1, 12, 31) });
  for (let m = 1; m <= 4; m++)
    r.push({ label: `${m}분기`, from: o(a, m * 3 - 2, 1), to: o(a, m * 3, Le(a, m * 3)) });
  return r;
}
const du = "_wrap_uxy72_1", fu = "_disabled_uxy72_18", _u = "_input_uxy72_22", pu = "_month_uxy72_36", yu = "_weekday_uxy72_39", bu = "_sun_uxy72_40", Eu = "_sat_uxy72_41", hu = "_icon_uxy72_43", gu = "_readOnly_uxy72_57", vu = "_required_uxy72_62", ku = "_invalid_uxy72_63", wu = "_pop_uxy72_66", Nu = "_calHead_uxy72_79", $u = "_calTitleStatic_uxy72_80", xu = "_calTitle_uxy72_80", Du = "_grid_uxy72_90", Au = "_wd_uxy72_91", Cu = "_day_uxy72_95", Su = "_mon_uxy72_36", Mu = "_out_uxy72_104", Tu = "_sel_uxy72_105", qu = "_today_uxy72_108", Bu = "_months_uxy72_111", Lu = "_foot_uxy72_114", ju = "_clear_uxy72_127", Ru = "_range_uxy72_130", Iu = "_tilde_uxy72_131", Ou = "_rangeErr_uxy72_132", ae = {
  wrap: du,
  disabled: fu,
  input: _u,
  month: pu,
  weekday: yu,
  sun: bu,
  sat: Eu,
  icon: hu,
  readOnly: gu,
  required: vu,
  invalid: ku,
  pop: wu,
  calHead: Nu,
  calTitleStatic: $u,
  calTitle: xu,
  grid: Du,
  wd: Au,
  day: Cu,
  mon: Su,
  out: Mu,
  sel: Tu,
  today: qu,
  months: Bu,
  foot: Lu,
  clear: ju,
  range: Ru,
  tilde: Iu,
  rangeErr: Ou
}, pt = () => {
  const e = /* @__PURE__ */ new Date();
  return { y: e.getFullYear(), m: e.getMonth() + 1, d: e.getDate() };
};
function Da({
  value: e,
  onChange: t,
  mode: a = "date",
  min: r,
  max: s,
  disabled: o,
  readOnly: l,
  required: c,
  invalid: i,
  showWeekday: m,
  onReject: u,
  placeholder: f,
  id: y,
  name: _,
  onBlur: p,
  "aria-label": d,
  "aria-describedby": b,
  className: N = "",
  style: w
}) {
  const k = a === "month", x = Yt("axe-dp"), E = r || (k ? Na.slice(0, 7) : Na), h = s || (k ? $a.slice(0, 7) : $a), g = (C) => cu(C, E, h), $ = !!o || !!l, [A, M] = D(e || ""), [T, I] = D(!1), [q, P] = D(!1), [G, K] = D(k ? "month" : "day"), [j, te] = D(() => {
    var F;
    const C = (F = Jt(e, a)) != null ? F : pt();
    return { y: C.y, m: C.m };
  }), [ne, v] = D({ top: 0, left: 0 }), O = L(null), V = L(null), Q = L(null), se = L(null);
  Z(() => {
    M(e || ""), I(!1);
  }, [e]), Z(() => {
    const C = Jt(e, a);
    C && te({ y: C.y, m: C.m });
  }, [e, a]), Be(() => {
    const C = V.current;
    se.current != null && C && document.activeElement === C && C.setSelectionRange(se.current, se.current), se.current = null;
  }, [A]), Be(() => {
    if (!q) return;
    const C = () => {
      const F = O.current, re = Q.current;
      if (!F || !re) return;
      const ie = F.getBoundingClientRect(), me = re.offsetHeight, he = re.offsetWidth;
      let De = ie.bottom + 4;
      De + me > window.innerHeight - 8 && ie.top - me - 4 > 8 && (De = ie.top - me - 4);
      const Vt = Math.max(8, Math.min(ie.left, window.innerWidth - he - 8));
      v((jn) => jn.top === De && jn.left === Vt ? jn : { top: De, left: Vt });
    };
    return C(), window.addEventListener("resize", C), window.addEventListener("scroll", C, !0), () => {
      window.removeEventListener("resize", C), window.removeEventListener("scroll", C, !0);
    };
  }, [q, G, j.y, j.m]), Z(() => {
    if (!q) return;
    const C = (F) => {
      var ie, me;
      const re = F.target;
      (ie = O.current) != null && ie.contains(re) || (me = Q.current) != null && me.contains(re) || P(!1);
    };
    return document.addEventListener("mousedown", C), () => document.removeEventListener("mousedown", C);
  }, [q]);
  const B = (C) => {
    C !== (e || "") && t(C);
  }, J = (C) => {
    M(C), I(!1), B(C);
  }, R = () => {
    const C = Ot(A, a);
    if (!C) return;
    const F = En(C, a, pt()), re = F ? qe(F, a) : null;
    if (re && g(re)) {
      J(re);
      return;
    }
    u == null || u(A, re ? "range" : "format"), M(e || ""), I(!1);
  }, z = (C, F) => {
    const re = Ot(C.slice(0, F), a).length, ie = Ot(C, a), me = On(ie, a);
    if (se.current = xa(me, Math.min(re, ie.length)), M(me), !ie) {
      I(!1), B("");
      return;
    }
    if (ie.length === (k ? 6 : 8)) {
      const he = En(ie, a, pt()), De = he ? qe(he, a) : null;
      De && g(De) ? (I(!1), B(De)) : I(!0);
    } else I(!1);
  }, Y = (C, F) => {
    var Vt;
    const re = pt(), ie = Ot(A, a), me = (Vt = En(ie, a, re)) != null ? Vt : Jt(e, a);
    let he;
    me ? k ? he = gt(me, C === "year" ? 12 * F : F) : C === "day" ? he = cn(me, F) : he = gt(me, C === "month" ? F : 12 * F) : he = re;
    const De = qe(he, a);
    g(De) && J(De);
  }, X = (C) => {
    var F;
    J(C), P(!1), (F = V.current) == null || F.focus();
  }, H = () => {
    var F;
    if ($) return;
    const C = (F = Jt(e, a)) != null ? F : pt();
    te({ y: C.y, m: C.m }), K(k ? "month" : "day"), P(!0);
  }, ce = (C) => {
    var re, ie;
    if ($) return;
    const F = C.currentTarget;
    switch (C.key) {
      case "Escape":
        q ? (P(!1), C.preventDefault(), C.stopPropagation(), C.nativeEvent.stopImmediatePropagation()) : A !== (e || "") && (M(e || ""), I(!1), C.preventDefault(), C.stopPropagation(), C.nativeEvent.stopImmediatePropagation(), requestAnimationFrame(() => F.select()));
        break;
      case "ArrowDown":
        C.preventDefault(), C.altKey ? q ? P(!1) : H() : Y("day", 1);
        break;
      case "ArrowUp":
        C.preventDefault(), Y("day", -1);
        break;
      case "PageDown":
        C.preventDefault(), Y("month", 1);
        break;
      case "PageUp":
        C.preventDefault(), Y("month", -1);
        break;
      case "F2":
      case "F4":
        C.preventDefault(), q ? P(!1) : H();
        break;
      case "Enter":
        R(), q && P(!1);
        break;
      case "t":
      case "T":
        if (C.ctrlKey || C.metaKey || C.altKey) break;
        C.preventDefault(), J(qe(pt(), a));
        break;
      case "Backspace": {
        const me = (re = F.selectionStart) != null ? re : 0;
        if (me === ((ie = F.selectionEnd) != null ? ie : 0) && me > 0 && A[me - 1] === "-") {
          C.preventDefault();
          const he = Ot(A.slice(0, me), a).length, De = Ot(A, a);
          z(On(De.slice(0, he - 1) + De.slice(he), a), 0), se.current = xa(On(De.slice(0, he - 1) + De.slice(he), a), he - 1);
        }
        break;
      }
    }
  }, Ue = (C) => {
    if ($) return;
    C.preventDefault();
    const F = iu(C.clipboardData.getData("text"), a, pt()), re = F ? qe(F, a) : null;
    re && g(re) ? J(re) : I(!0);
  }, Re = (C) => {
    var re, ie;
    const F = C.relatedTarget;
    F && ((re = O.current) != null && re.contains(F) || (ie = Q.current) != null && ie.contains(F)) || (R(), P(!1), p && p());
  }, Ie = Jt(e, a), vt = pt(), xe = T || !!i, Xe = m && !k && Ie ? je(Ie) : null, nt = (C) => qe(C, a), Rt = (C, F) => {
    const re = qe({ y: C, m: F, d: 1 }, "date"), ie = qe({ y: C, m: F, d: Le(C, F) }, "date"), me = k ? E + "-01" : E, he = k ? h + "-31" : h;
    return ie >= me && re <= he;
  }, Oe = (C) => {
    const F = gt({ y: j.y, m: j.m, d: 1 }, C);
    te({ y: F.y, m: F.m });
  }, Ln = () => /* @__PURE__ */ n.createElement(n.Fragment, null, /* @__PURE__ */ n.createElement("div", { className: ae.calHead }, /* @__PURE__ */ n.createElement("button", { type: "button", tabIndex: -1, "aria-label": "이전 해", onClick: () => Oe(-12) }, "«"), /* @__PURE__ */ n.createElement("button", { type: "button", tabIndex: -1, "aria-label": "이전 달", onClick: () => Oe(-1) }, "‹"), /* @__PURE__ */ n.createElement("button", { type: "button", tabIndex: -1, className: ae.calTitle, "aria-label": "연·월 선택", onClick: () => K("month") }, j.y, "년 ", j.m, "월"), /* @__PURE__ */ n.createElement("button", { type: "button", tabIndex: -1, "aria-label": "다음 달", onClick: () => Oe(1) }, "›"), /* @__PURE__ */ n.createElement("button", { type: "button", tabIndex: -1, "aria-label": "다음 해", onClick: () => Oe(12) }, "»")), /* @__PURE__ */ n.createElement("div", { className: ae.grid }, In.map((C, F) => /* @__PURE__ */ n.createElement("span", { key: C, className: [ae.wd, F === 0 ? ae.sun : "", F === 6 ? ae.sat : ""].join(" ") }, C)), uu(j.y, j.m).map((C) => {
    const F = qe(C, "date"), re = je(C), ie = [
      ae.day,
      C.m !== j.m ? ae.out : "",
      re === 0 ? ae.sun : "",
      re === 6 ? ae.sat : "",
      F === qe(vt, "date") ? ae.today : "",
      Ie && F === qe(Ie, "date") ? ae.sel : ""
    ].join(" "), me = !g(F);
    return /* @__PURE__ */ n.createElement(
      "button",
      {
        key: F,
        type: "button",
        tabIndex: -1,
        className: ie,
        disabled: me,
        "aria-label": `${C.y}년 ${C.m}월 ${C.d}일 ${In[re]}요일`,
        "aria-pressed": !!Ie && F === qe(Ie, "date"),
        onClick: () => X(F)
      },
      C.d
    );
  }))), kt = () => /* @__PURE__ */ n.createElement(n.Fragment, null, /* @__PURE__ */ n.createElement("div", { className: ae.calHead }, /* @__PURE__ */ n.createElement("button", { type: "button", tabIndex: -1, "aria-label": "이전 해", onClick: () => Oe(-12) }, "«"), /* @__PURE__ */ n.createElement("span", { className: ae.calTitleStatic }, j.y, "년"), /* @__PURE__ */ n.createElement("button", { type: "button", tabIndex: -1, "aria-label": "다음 해", onClick: () => Oe(12) }, "»")), /* @__PURE__ */ n.createElement("div", { className: ae.months }, Array.from({ length: 12 }, (C, F) => F + 1).map((C) => {
    const F = !!Ie && Ie.y === j.y && Ie.m === C, re = [ae.mon, F ? ae.sel : "", vt.y === j.y && vt.m === C ? ae.today : ""].join(" ");
    return /* @__PURE__ */ n.createElement(
      "button",
      {
        key: C,
        type: "button",
        tabIndex: -1,
        className: re,
        disabled: !Rt(j.y, C),
        "aria-pressed": F,
        onClick: () => {
          k ? X(nt({ y: j.y, m: C, d: 1 })) : (te({ y: j.y, m: C }), K("day"));
        }
      },
      C,
      "월"
    );
  }))), wt = qe(vt, a), W = k ? /* @__PURE__ */ n.createElement(n.Fragment, null, /* @__PURE__ */ n.createElement("button", { type: "button", tabIndex: -1, disabled: !g(wt), onClick: () => X(wt) }, "이번 달")) : /* @__PURE__ */ n.createElement(n.Fragment, null, /* @__PURE__ */ n.createElement("button", { type: "button", tabIndex: -1, disabled: !g(wt), onClick: () => X(wt) }, "오늘"), /* @__PURE__ */ n.createElement(
    "button",
    {
      type: "button",
      tabIndex: -1,
      disabled: !g(nt({ y: j.y, m: j.m, d: 1 })),
      onClick: () => X(nt({ y: j.y, m: j.m, d: 1 }))
    },
    "월초"
  ), /* @__PURE__ */ n.createElement(
    "button",
    {
      type: "button",
      tabIndex: -1,
      disabled: !g(nt({ y: j.y, m: j.m, d: Le(j.y, j.m) })),
      onClick: () => X(nt({ y: j.y, m: j.m, d: Le(j.y, j.m) }))
    },
    "월말"
  )), fe = [
    ae.wrap,
    o ? ae.disabled : "",
    l ? ae.readOnly : "",
    c && !e && !A ? ae.required : "",
    xe ? ae.invalid : "",
    k ? ae.month : "",
    N
  ].filter(Boolean).join(" ");
  return /* @__PURE__ */ n.createElement("span", { ref: O, className: fe, style: w, onBlur: Re }, /* @__PURE__ */ n.createElement(
    "input",
    {
      ref: V,
      id: y,
      name: _,
      className: ae.input,
      inputMode: "numeric",
      autoComplete: "off",
      spellCheck: !1,
      value: A,
      placeholder: f != null ? f : k ? "YYYY-MM" : "YYYY-MM-DD",
      disabled: o,
      readOnly: l,
      role: "combobox",
      "aria-haspopup": "dialog",
      "aria-expanded": q,
      "aria-controls": x,
      "aria-label": d,
      "aria-describedby": b,
      "aria-invalid": xe || void 0,
      "aria-required": c || void 0,
      onChange: (C) => {
        var F;
        return z(C.target.value, (F = C.target.selectionStart) != null ? F : C.target.value.length);
      },
      onKeyDown: ce,
      onPaste: Ue
    }
  ), Xe != null && /* @__PURE__ */ n.createElement("span", { className: [ae.weekday, Xe === 0 ? ae.sun : "", Xe === 6 ? ae.sat : ""].join(" "), "aria-hidden": "true" }, "(", In[Xe], ")"), /* @__PURE__ */ n.createElement(
    "button",
    {
      type: "button",
      tabIndex: -1,
      className: ae.icon,
      disabled: $,
      "aria-label": k ? "월 선택 열기" : "달력 열기",
      onMouseDown: (C) => C.preventDefault(),
      onClick: () => {
        var C;
        (C = V.current) == null || C.focus(), q ? P(!1) : H();
      }
    },
    /* @__PURE__ */ n.createElement(gn, { name: "calendar", size: 15 })
  ), q && /* @__PURE__ */ n.createElement(Gt, null, /* @__PURE__ */ n.createElement(
    "div",
    {
      ref: Q,
      id: x,
      className: ae.pop,
      style: { top: ne.top, left: ne.left },
      role: "dialog",
      "aria-label": k ? "월 선택" : "날짜 선택",
      onMouseDown: (C) => C.preventDefault()
    },
    G === "day" && !k ? Ln() : kt(),
    /* @__PURE__ */ n.createElement("div", { className: ae.foot }, W, !c && /* @__PURE__ */ n.createElement("button", { type: "button", tabIndex: -1, className: ae.clear, onClick: () => X("") }, "비우기"))
  )));
}
const Mt = (e) => String(e).padStart(2, "0");
function Nr() {
  const e = /* @__PURE__ */ new Date();
  return `${e.getFullYear()}-${Mt(e.getMonth() + 1)}-${Mt(e.getDate())}`;
}
function $v(e) {
  if (!e) return "";
  const t = new Date(e);
  return Number.isNaN(t.getTime()) ? String(e) : `${t.getFullYear()}-${Mt(t.getMonth() + 1)}-${Mt(t.getDate())} ${Mt(t.getHours())}:${Mt(t.getMinutes())}:${Mt(t.getSeconds())}`;
}
function xv(e, t) {
  return !!e && !!t && e <= t;
}
function Dv({
  from: e,
  to: t,
  onChange: a,
  mode: r = "date",
  min: s,
  max: o,
  disabled: l,
  label: c = "기간",
  presets: i = !0,
  showWeekday: m,
  onReject: u
}) {
  const f = !!e && !!t && e > t, y = /* @__PURE__ */ new Date(), _ = i === !1 ? [] : Array.isArray(i) ? i : mu({ y: y.getFullYear(), m: y.getMonth() + 1, d: y.getDate() }, r), p = (d) => (!s || d.from >= s) && (!o || d.to <= o);
  return /* @__PURE__ */ n.createElement("span", { className: ae.range }, /* @__PURE__ */ n.createElement(
    Da,
    {
      value: e,
      mode: r,
      min: s,
      max: o,
      disabled: l,
      showWeekday: m,
      "aria-label": `${c} 시작일`,
      onChange: (d) => a(d, t),
      onReject: u && ((d, b) => u(d, b, "from"))
    }
  ), /* @__PURE__ */ n.createElement("span", { className: ae.tilde, "aria-hidden": "true" }, "~"), /* @__PURE__ */ n.createElement(
    Da,
    {
      value: t,
      mode: r,
      min: s,
      max: o,
      disabled: l,
      showWeekday: m,
      "aria-label": `${c} 종료일`,
      onChange: (d) => a(e, d),
      onReject: u && ((d, b) => u(d, b, "to"))
    }
  ), _.length > 0 && /* @__PURE__ */ n.createElement(
    Vs,
    {
      label: "기간",
      title: `${c} 빠른 선택`,
      disabled: l,
      entries: _.map((d) => Ys(
        d.label,
        d.label,
        () => a(d.from, d.to),
        p(d) ? {} : { disabled: !0, reason: "허용 범위 밖" }
      ))
    }
  ), f && /* @__PURE__ */ n.createElement("span", { className: ae.rangeErr, role: "alert" }, "시작일이 종료일보다 늦습니다"));
}
const $r = [
  { name: "明治", short: "M", start: "1868-09-08" },
  { name: "大正", short: "T", start: "1912-07-30" },
  { name: "昭和", short: "S", start: "1926-12-25" },
  { name: "平成", short: "H", start: "1989-01-08" },
  { name: "令和", short: "R", start: "2019-05-01" }
];
function xr(e, t = $r) {
  const a = /^(\d{4})-\d{2}-\d{2}/.exec(e != null ? e : "");
  if (!a) return null;
  let r = null;
  for (const s of t) s.start <= e.slice(0, 10) && (!r || s.start > r.start) && (r = s);
  return r ? { era: r, year: +a[1] - +r.start.slice(0, 4) + 1 } : null;
}
function Pu(e, t = {}) {
  const a = xr(e, t.eras);
  return a ? `${a.era.name}${a.year === 1 && t.gannen !== !1 ? "元" : a.year}年` : null;
}
function Av(e, t) {
  const a = xr(e, t);
  return a ? `${a.era.short}${a.year}.${e.slice(5, 7)}.${e.slice(8, 10)}` : null;
}
const Se = 1440, kn = (e) => String(e).padStart(2, "0");
function ye(e) {
  const t = /^(\d{4})-(\d{2})-(\d{2})(?:[T ](\d{2}):(\d{2}))?/.exec(e != null ? e : "");
  return t ? Date.UTC(+t[1], +t[2] - 1, +t[3], t[4] ? +t[4] : 0, t[5] ? +t[5] : 0) / 6e4 : NaN;
}
function qt(e) {
  const t = new Date(e * 6e4);
  return tt(t.getUTCFullYear(), t.getUTCMonth() + 1, t.getUTCDate());
}
function an(e) {
  const t = new Date(e * 6e4);
  return `${qt(e)}T${kn(t.getUTCHours())}:${kn(t.getUTCMinutes())}`;
}
function Ze(e) {
  const t = (e % Se + Se) % Se;
  return `${kn(Math.floor(t / 60))}:${kn(t % 60)}`;
}
function ke(e, t) {
  return de(e) ? Cn(e, t) : e;
}
function Kt(e, t) {
  return Math.round((ye(t) - ye(e)) / Se);
}
function un(e) {
  if (!de(e)) return !1;
  const t = ua(e);
  return t === 0 || t === 6;
}
function Xu(e) {
  var s;
  const t = ye(e.start);
  if (Number.isNaN(t)) return null;
  const a = (s = e.allDay) != null ? s : !/[T ]\d{2}:\d{2}/.test(e.start);
  if (a) {
    const o = qt(t), l = e.end ? qt(ye(e.end)) : o, c = l < o ? o : l;
    return { ev: e, s: ye(o), e: ye(c) + Se, allDay: a, sDay: o, eDay: c };
  }
  let r = e.end ? ye(e.end) : t + 60;
  return (Number.isNaN(r) || r <= t) && (r = t + 30), { ev: e, s: t, e: r, allDay: a, sDay: qt(t), eDay: qt(r - 1) };
}
function Sn(e, t, a, r) {
  const s = [];
  for (const o of e) {
    const l = r && o.id === r.id ? { ...o, start: r.start, end: r.end } : o, c = Xu(l);
    c && c.eDay >= t && c.sDay <= a && s.push(c);
  }
  return s.sort(zu);
}
function zu(e, t) {
  if (e.sDay !== t.sDay) return e.sDay < t.sDay ? -1 : 1;
  const a = Kt(t.sDay, t.eDay) - Kt(e.sDay, e.eDay);
  return a || (e.allDay !== t.allDay ? e.allDay ? -1 : 1 : e.s !== t.s ? e.s - t.s : e.ev.title.localeCompare(t.ev.title));
}
function Fu(e) {
  return e.allDay || e.sDay !== e.eDay;
}
function Dr(e) {
  return e.allDay || e.e - e.s >= Se;
}
function wn(e, t) {
  const a = de(e);
  if (!a) return e;
  const r = (je(a) - t + 7) % 7;
  return ke(e, -r);
}
function Mn(e, t) {
  const a = Kt(e, t);
  return Array.from({ length: Math.max(0, a + 1) }, (r, s) => ke(e, s));
}
function Ar(e, t) {
  const a = de(e), r = tt(a.y, a.m, 1), s = tt(a.y, a.m, Le(a.y, a.m)), o = wn(r, t), l = ke(wn(s, t), 6), c = Mn(o, l), i = [];
  for (let m = 0; m < c.length; m += 7) i.push(c.slice(m, m + 7));
  return i;
}
function ma(e, t, a) {
  if (e === "month") {
    const r = Ar(t, a);
    return { from: r[0][0], to: r[r.length - 1][6] };
  }
  if (e === "agenda") {
    const r = de(t);
    return { from: tt(r.y, r.m, 1), to: tt(r.y, r.m, Le(r.y, r.m)) };
  }
  if (e === "week") {
    const r = wn(t, a);
    return { from: r, to: ke(r, 6) };
  }
  return { from: t, to: t };
}
function Wu(e, t, a, r = !1) {
  const s = de(t);
  if (!s) return t;
  if (e === "month" || e === "agenda") {
    const l = gt(s, a);
    return tt(l.y, l.m, l.d);
  }
  if (e === "week") return ke(t, 7 * a);
  let o = ke(t, a);
  for (; r && un(o); ) o = ke(o, a);
  return o;
}
function Hu(e, t, a, r) {
  if (!de(t)) return "";
  if (e === "month" || e === "agenda") return r.ym(`${t.slice(0, 7)}-01`);
  if (e === "day") return r.dayTitle(t);
  const { from: s, to: o } = ma("week", t, a);
  return r.year(s) !== r.year(o) ? `${r.ymd(s)} – ${r.ymd(o)}` : s.slice(5, 7) !== o.slice(5, 7) ? `${r.ymd(s)} – ${r.md(o)}` : `${r.ymd(s)} – ${r.d(o)}`;
}
function Cr(e, t) {
  const a = [], r = [];
  for (const s of e) {
    let o = -1, l = -1;
    for (let i = 0; i < t.length; i++)
      t[i] >= s.sDay && t[i] <= s.eDay && (o < 0 && (o = i), l = i);
    if (o < 0) continue;
    let c = r.findIndex((i) => i < o);
    c < 0 ? (c = r.length, r.push(l)) : r[c] = l, a.push({ item: s, col: o, span: l - o + 1, lane: c, contL: s.sDay < t[o], contR: s.eDay > t[l] });
  }
  return a;
}
function Ku(e, t, a) {
  const r = new Array(t).fill(0);
  for (const c of e) for (let i = c.col; i < c.col + c.span; i++) r[i]++;
  const s = Math.max(1, a), o = e.filter((c) => {
    if (c.lane < s - 1) return !0;
    if (c.lane > s - 1) return !1;
    for (let i = c.col; i < c.col + c.span; i++) if (r[i] > s) return !1;
    return !0;
  }), l = new Array(t).fill(0);
  for (const c of o) for (let i = c.col; i < c.col + c.span; i++) l[i]++;
  return { shown: o, more: r.map((c, i) => c - l[i]) };
}
const Uu = 20;
function Gu(e, t) {
  const a = ye(t), r = a + Se, s = e.filter((m) => !Dr(m) && m.s < r && m.e > a).map((m) => ({
    item: m,
    top: Math.max(m.s, a) - a,
    bottom: Math.min(m.e, r) - a,
    col: 0,
    cols: 1,
    contTop: m.s < a,
    contBottom: m.e > r
  })).sort((m, u) => m.top - u.top || u.bottom - m.bottom);
  let o = [], l = [], c = -1;
  const i = () => {
    for (const m of o) m.cols = l.length;
    o = [], l = [];
  };
  for (const m of s) {
    m.top >= c && i();
    const u = Math.max(m.bottom, m.top + Uu);
    let f = l.findIndex((y) => y <= m.top);
    f < 0 ? (f = l.length, l.push(u)) : l[f] = u, m.col = f, o.push(m), c = Math.max(c, u);
  }
  return i(), s;
}
function Aa(e, t) {
  return Math.round(e / t) * t;
}
function Zn(e, t) {
  if (e.allDay) {
    const a = Math.round(t / Se);
    return { start: ke(e.sDay, a), end: ke(e.eDay, a) };
  }
  return { start: an(e.s + t), end: an(e.e + t) };
}
function da(e, t = "종일") {
  if (e.allDay) {
    if (e.sDay === e.eDay) return t;
    const l = de(e.sDay), c = de(e.eDay);
    return `${l.m}/${l.d} – ${c.m}/${c.d}`;
  }
  const a = ye(e.sDay), r = Ze(e.s - a);
  if (e.sDay === e.eDay) return `${r} – ${e.e - a === Se ? "24:00" : Ze(e.e - a)}`;
  const s = de(e.sDay), o = de(qt(e.e));
  return `${s.m}/${s.d} ${r} – ${o.m}/${o.d} ${Ze(e.e - ye(qt(e.e)))}`;
}
const Ae = (e) => {
  const t = de(e);
  return { ...t, w: je(t) };
};
function Ca(e, t, a, r, s) {
  const o = `${+e.slice(0, 4)}${a}`;
  if (t === "gregorian") return o;
  const l = Pu(e, { eras: r, gannen: s });
  return l ? t === "era" ? l : `${o}(${l})` : o;
}
function Yu(e = "ko", t = {}) {
  var i, m;
  const a = (i = t.year) != null ? i : e === "ja" ? "era" : "gregorian", r = (m = t.eras) != null ? m : $r, s = t.gannen !== !1;
  if (e === "ja") {
    const u = ["日", "月", "火", "水", "木", "金", "土"], f = (_) => Ca(_, a, "年", r, s), y = { month: "月", week: "週", day: "日", agenda: "月" };
    return {
      weekdays: u,
      views: { month: "月", week: "週", day: "日", agenda: "一覧" },
      today: "今日",
      prev: (_) => `前の${y[_]} (P)`,
      next: (_) => `次の${y[_]} (N)`,
      hideWeekends: "週末を隠す",
      prevMonth: "前月",
      nextMonth: "翌月",
      prevYear: "前年",
      nextYear: "翌年",
      pickMonth: "月を選択",
      viewTabs: "表示",
      region: "スケジュール",
      loading: "読み込み中",
      close: "閉じる",
      allDay: "終日",
      empty: "この期間の予定はありません。",
      more: (_) => `他${_}件`,
      eventCount: (_) => `予定${_}件`,
      dayOfSpan: (_, p) => `${_}/${p}日目`,
      openDay: (_) => {
        const p = Ae(_);
        return `${p.m}月${p.d}日を日表示`;
      },
      year: f,
      ym: (_) => `${f(_)}${Ae(_).m}月`,
      ymd: (_) => {
        const p = Ae(_);
        return `${f(_)}${p.m}月${p.d}日`;
      },
      md: (_) => {
        const p = Ae(_);
        return `${p.m}月${p.d}日`;
      },
      d: (_) => `${Ae(_).d}日`,
      m: (_) => `${Ae(_).m}月`,
      dayTitle: (_) => {
        const p = Ae(_);
        return `${f(_)}${p.m}月${p.d}日(${u[p.w]})`;
      },
      dayAria: (_) => {
        const p = Ae(_);
        return `${p.m}月${p.d}日 ${u[p.w]}曜日`;
      }
    };
  }
  const o = ["일", "월", "화", "수", "목", "금", "토"], l = (u) => Ca(u, a, "년", r, s), c = { month: "달", week: "주", day: "날", agenda: "달" };
  return {
    weekdays: o,
    views: { month: "월", week: "주", day: "일", agenda: "목록" },
    today: "오늘",
    prev: (u) => `이전 ${c[u]} (P)`,
    next: (u) => `다음 ${c[u]} (N)`,
    hideWeekends: "주말 숨김",
    prevMonth: "이전 달",
    nextMonth: "다음 달",
    prevYear: "이전 해",
    nextYear: "다음 해",
    pickMonth: "월 선택",
    viewTabs: "보기",
    region: "일정 달력",
    loading: "일정 불러오는 중",
    close: "닫기",
    allDay: "종일",
    empty: "이 기간에 일정이 없습니다.",
    more: (u) => `+${u}개`,
    eventCount: (u) => `일정 ${u}건`,
    dayOfSpan: (u, f) => `${u}/${f}일째`,
    openDay: (u) => {
      const f = Ae(u);
      return `${f.m}월 ${f.d}일 일 보기`;
    },
    year: l,
    ym: (u) => `${l(u)} ${Ae(u).m}월`,
    ymd: (u) => {
      const f = Ae(u);
      return `${l(u)} ${f.m}월 ${f.d}일`;
    },
    md: (u) => {
      const f = Ae(u);
      return `${f.m}월 ${f.d}일`;
    },
    d: (u) => `${Ae(u).d}일`,
    m: (u) => `${Ae(u).m}월`,
    dayTitle: (u) => {
      const f = Ae(u);
      return `${l(u)} ${f.m}월 ${f.d}일 (${o[f.w]})`;
    },
    dayAria: (u) => {
      const f = Ae(u);
      return `${f.m}월 ${f.d}일 ${o[f.w]}요일`;
    }
  };
}
const Sr = Yu("ko"), Vu = "_cal_38qtm_2", Qu = "_toolbar_38qtm_20", Ju = "_navBtns_38qtm_28", Zu = "_title_38qtm_29", em = "_toolRight_38qtm_36", tm = "_toggle_38qtm_37", nm = "_body_38qtm_58", am = "_busy_38qtm_59", rm = "_sun_38qtm_71", sm = "_sat_38qtm_72", om = "_tAccent_38qtm_75", lm = "_tOk_38qtm_76", cm = "_tWarn_38qtm_77", im = "_tDanger_38qtm_78", um = "_tViolet_38qtm_79", mm = "_tGray_38qtm_80", dm = "_month_38qtm_83", fm = "_mHead_38qtm_84", _m = "_wdName_38qtm_85", pm = "_mBody_38qtm_91", ym = "_mWeek_38qtm_92", bm = "_mCells_38qtm_94", Em = "_cell_38qtm_96", hm = "_out_38qtm_104", gm = "_dayNum_38qtm_105", vm = "_creatable_38qtm_106", km = "_selDay_38qtm_109", wm = "_cellHead_38qtm_111", Nm = "_isToday_38qtm_124", $m = "_holiday_38qtm_125", xm = "_addHint_38qtm_130", Dm = "_barLayer_38qtm_138", Am = "_chip_38qtm_139", Cm = "_more_38qtm_139", Sm = "_tEv_38qtm_155", Mm = "_aRow_38qtm_155", Tm = "_popItem_38qtm_155", qm = "_bar_38qtm_138", Bm = "_contL_38qtm_165", Lm = "_contR_38qtm_166", jm = "_dotChip_38qtm_167", Rm = "_dot_38qtm_167", Im = "_chipTime_38qtm_170", Om = "_chipTitle_38qtm_171", Pm = "_movable_38qtm_173", Xm = "_ghost_38qtm_176", zm = "_time_38qtm_189", Fm = "_tHead_38qtm_190", Wm = "_tAllDay_38qtm_190", Hm = "_gutter_38qtm_193", Km = "_tHeadDays_38qtm_197", Um = "_tAllDayCells_38qtm_197", Gm = "_tDay_38qtm_198", Ym = "_tDayBtn_38qtm_202", Vm = "_tWd_38qtm_206", Qm = "_tDayNum_38qtm_208", Jm = "_tAllDayRow_38qtm_216", Zm = "_allDayCell_38qtm_218", ed = "_tBody_38qtm_222", td = "_tGrid_38qtm_223", nd = "_tGutter_38qtm_224", ad = "_tCols_38qtm_230", rd = "_tCol_38qtm_230", sd = "_tSel_38qtm_238", od = "_tEvTitle_38qtm_258", ld = "_tEvTime_38qtm_259", cd = "_tEvShort_38qtm_261", id = "_contTop_38qtm_263", ud = "_contBottom_38qtm_264", md = "_resize_38qtm_265", dd = "_now_38qtm_268", fd = "_agenda_38qtm_272", _d = "_aDay_38qtm_273", pd = "_aDate_38qtm_275", yd = "_aDateBtn_38qtm_276", bd = "_aDayNum_38qtm_280", Ed = "_aDayWd_38qtm_286", hd = "_aList_38qtm_288", gd = "_aTime_38qtm_295", vd = "_aTitle_38qtm_296", kd = "_aSpan_38qtm_297", wd = "_aLoc_38qtm_298", Nd = "_empty_38qtm_303", $d = "_pop_38qtm_155", xd = "_popHead_38qtm_321", Dd = "_popDay_38qtm_322", Ad = "_popClose_38qtm_329", Cd = "_popList_38qtm_334", Sd = "_tAllDayOnly_38qtm_348", S = {
  cal: Vu,
  toolbar: Qu,
  navBtns: Ju,
  title: Zu,
  toolRight: em,
  toggle: tm,
  body: nm,
  busy: am,
  sun: rm,
  sat: sm,
  tAccent: om,
  tOk: lm,
  tWarn: cm,
  tDanger: im,
  tViolet: um,
  tGray: mm,
  month: dm,
  mHead: fm,
  wdName: _m,
  mBody: pm,
  mWeek: ym,
  mCells: bm,
  cell: Em,
  out: hm,
  dayNum: gm,
  creatable: vm,
  selDay: km,
  cellHead: wm,
  isToday: Nm,
  holiday: $m,
  addHint: xm,
  barLayer: Dm,
  chip: Am,
  more: Cm,
  tEv: Sm,
  aRow: Mm,
  popItem: Tm,
  bar: qm,
  contL: Bm,
  contR: Lm,
  dotChip: jm,
  dot: Rm,
  chipTime: Im,
  chipTitle: Om,
  movable: Pm,
  ghost: Xm,
  time: zm,
  tHead: Fm,
  tAllDay: Wm,
  gutter: Hm,
  tHeadDays: Km,
  tAllDayCells: Um,
  tDay: Gm,
  tDayBtn: Ym,
  tWd: Vm,
  tDayNum: Qm,
  tAllDayRow: Jm,
  allDayCell: Zm,
  tBody: ed,
  tGrid: td,
  tGutter: nd,
  tCols: ad,
  tCol: rd,
  tSel: sd,
  tEvTitle: od,
  tEvTime: ld,
  tEvShort: cd,
  contTop: id,
  contBottom: ud,
  resize: md,
  now: dd,
  agenda: fd,
  aDay: _d,
  aDate: pd,
  aDateBtn: yd,
  aDayNum: bd,
  aDayWd: Ed,
  aList: hd,
  aTime: gd,
  aTitle: vd,
  aSpan: kd,
  aLoc: wd,
  empty: Nd,
  pop: $d,
  popHead: xd,
  popDay: Dd,
  popClose: Ad,
  popList: Cd,
  tAllDayOnly: Sd
}, mn = 22, Md = {
  accent: S.tAccent,
  ok: S.tOk,
  warn: S.tWarn,
  danger: S.tDanger,
  violet: S.tViolet,
  gray: S.tGray
};
function Tn(e) {
  var t;
  return e.color ? "" : Md[(t = e.tone) != null ? t : "accent"];
}
function qn(e) {
  if (e.color)
    return { "--ev": e.color };
}
function Mr(e, t) {
  return [e.ev.title, da(e, t.allDay), e.ev.location].filter(Boolean).join(", ");
}
const rn = (e, t) => !!e.onEventChange && !t.locked;
function hn(e, t, a) {
  var r;
  for (const s of document.elementsFromPoint(e, t)) {
    const o = (r = s.closest) == null ? void 0 : r.call(s, `[${a}]`);
    if (o) return o;
  }
  return null;
}
function Nn(e, t) {
  const a = e.clientX, r = e.clientY;
  let s = !1;
  const o = (u) => {
    !s && Math.hypot(u.clientX - a, u.clientY - r) < 4 || (s = !0, t.move(u));
  }, l = () => {
    window.removeEventListener("pointermove", o), window.removeEventListener("pointerup", c), window.removeEventListener("pointercancel", i), window.removeEventListener("keydown", m, !0);
  }, c = (u) => {
    l(), t.end(u, s);
  }, i = () => {
    l(), t.cancel();
  }, m = (u) => {
    u.key === "Escape" && (u.preventDefault(), u.stopPropagation(), i());
  };
  window.addEventListener("pointermove", o), window.addEventListener("pointerup", c), window.addEventListener("pointercancel", i), window.addEventListener("keydown", m, !0);
}
function Tr(e) {
  const [t, a] = D(null), [r, s] = D(null), o = L(!1);
  return { preview: t, items: (f, y) => Sn(e.events, f, y, t), onItemDown: (f, y) => {
    var d;
    if (f.button !== 0 || !rn(e, y.ev)) return;
    const _ = (d = hn(f.clientX, f.clientY, "data-cal-day")) == null ? void 0 : d.dataset.calDay;
    if (!_) return;
    o.current = !1;
    let p = 0;
    Nn(f, {
      move: (b) => {
        var w;
        o.current = !0;
        const N = (w = hn(b.clientX, b.clientY, "data-cal-day")) == null ? void 0 : w.dataset.calDay;
        N && (p = Kt(_, N), a({ id: y.ev.id, ...Zn(y, p * Se) }));
      },
      end: (b, N) => {
        var w;
        a(null), N && p && ((w = e.onEventChange) == null || w.call(e, y.ev, Zn(y, p * Se)));
      },
      cancel: () => a(null)
    });
  }, onCellDown: (f, y) => {
    if (f.button !== 0 || !e.onCreate) return;
    f.preventDefault();
    let _ = y;
    s({ a: y, b: y }), Nn(f, {
      move: (p) => {
        var b;
        const d = (b = hn(p.clientX, p.clientY, "data-cal-day")) == null ? void 0 : b.dataset.calDay;
        d && (_ = d, s({ a: y, b: d }));
      },
      end: () => {
        var b;
        s(null);
        const [p, d] = y <= _ ? [y, _] : [_, y];
        (b = e.onCreate) == null || b.call(e, { start: p, end: d, allDay: !0 });
      },
      cancel: () => s(null)
    });
  }, clickItem: (f, y) => {
    var _;
    if (o.current) {
      o.current = !1;
      return;
    }
    (_ = e.onEventClick) == null || _.call(e, y, f);
  }, inSel: (f) => !!r && f >= (r.a < r.b ? r.a : r.b) && f <= (r.a < r.b ? r.b : r.a) };
}
function qr({
  segs: e,
  cols: t,
  top: a,
  ctx: r,
  drag: s
}) {
  return /* @__PURE__ */ n.createElement("div", { className: S.barLayer }, e.map((o) => {
    var f;
    const l = o.item, c = l.ev, i = Fu(l), m = Ze(l.s - ye(l.sDay)), u = [
      S.chip,
      i ? S.bar : S.dotChip,
      Tn(c),
      o.contL ? S.contL : "",
      o.contR ? S.contR : "",
      ((f = s.preview) == null ? void 0 : f.id) === c.id ? S.ghost : "",
      rn(r, c) ? S.movable : ""
    ].filter(Boolean).join(" ");
    return /* @__PURE__ */ n.createElement(
      "button",
      {
        key: `${c.id}:${o.col}`,
        type: "button",
        className: u,
        style: {
          left: `calc(${o.col / t * 100}% + 2px)`,
          width: `calc(${o.span / t * 100}% - 4px)`,
          top: a + o.lane * mn,
          ...qn(c)
        },
        "aria-label": Mr(l, r.L),
        onPointerDown: (y) => s.onItemDown(y, l),
        onClick: (y) => s.clickItem(y.currentTarget, c)
      },
      i ? /* @__PURE__ */ n.createElement("span", { className: S.chipTitle }, !l.allDay && !o.contL && /* @__PURE__ */ n.createElement("span", { className: S.chipTime }, m), c.title) : /* @__PURE__ */ n.createElement(n.Fragment, null, /* @__PURE__ */ n.createElement("i", { className: S.dot, "aria-hidden": !0 }), /* @__PURE__ */ n.createElement("span", { className: S.chipTime }, m), /* @__PURE__ */ n.createElement("span", { className: S.chipTitle }, c.title))
    );
  }));
}
const Pn = 26;
function Td({ ctx: e }) {
  const { L: t, cursor: a, today: r, weekStartsOn: s, showWeekends: o, holidays: l } = e, c = a.slice(0, 7), i = we(
    () => Ar(a, s).map((x) => o ? x : x.filter((E) => !un(E))),
    [a, s, o]
  ), m = i[0].length, u = Tr(e), f = u.items(i[0][0], i[i.length - 1][m - 1]), y = L(null), [_, p] = D(0);
  Be(() => {
    const x = y.current;
    if (!x) return;
    const E = () => p(x.clientHeight / i.length);
    if (E(), typeof ResizeObserver == "undefined") return;
    const h = new ResizeObserver(E);
    return h.observe(x), () => h.disconnect();
  }, [i.length]);
  const d = _ ? Math.max(1, Math.floor((_ - Pn - 4) / mn)) : 3, b = L(!1), N = L(null);
  Z(() => {
    var x, E;
    b.current && (b.current = !1, (E = (x = N.current) == null ? void 0 : x.querySelector(`[data-cal-day="${a}"]`)) == null || E.focus());
  }, [a, c]);
  const w = (x, E) => {
    let h = ke(x, E);
    for (; !o && un(h); ) h = ke(h, E > 0 ? 1 : -1);
    return h;
  }, k = (x, E, h) => {
    let g = null;
    if (x.key === "ArrowLeft") g = w(E, -1);
    else if (x.key === "ArrowRight") g = w(E, 1);
    else if (x.key === "ArrowUp") g = w(E, -7);
    else if (x.key === "ArrowDown") g = w(E, 7);
    else if (x.key === "Home") g = h[0];
    else if (x.key === "End") g = h[h.length - 1];
    else if (x.key === "Enter" || x.key === " ") {
      x.preventDefault(), e.goto("day", E);
      return;
    }
    g && (x.preventDefault(), b.current = !0, e.setCursor(g));
  };
  return /* @__PURE__ */ n.createElement("div", { className: S.month, role: "grid", "aria-label": t.ym(`${c}-01`), ref: N }, /* @__PURE__ */ n.createElement("div", { className: S.mHead, role: "row" }, i[0].map((x) => {
    const E = je(de(x));
    return /* @__PURE__ */ n.createElement("div", { key: x, role: "columnheader", className: [S.wdName, E === 0 ? S.sun : "", E === 6 ? S.sat : ""].join(" ") }, t.weekdays[E]);
  })), /* @__PURE__ */ n.createElement("div", { className: S.mBody, ref: y }, i.map((x) => {
    const { shown: E, more: h } = Ku(Cr(f, x), m, d);
    return /* @__PURE__ */ n.createElement("div", { key: x[0], className: S.mWeek, role: "row" }, /* @__PURE__ */ n.createElement("div", { className: S.mCells, style: { gridTemplateColumns: `repeat(${m}, minmax(0, 1fr))` } }, x.map((g) => {
      const $ = de(g), A = je($), M = l[g], T = f.filter((q) => q.sDay <= g && q.eDay >= g).length, I = [
        S.cell,
        g.slice(0, 7) !== c ? S.out : "",
        A === 0 || M ? S.sun : A === 6 ? S.sat : "",
        g === r ? S.isToday : "",
        u.inSel(g) ? S.selDay : "",
        e.onCreate ? S.creatable : ""
      ].filter(Boolean).join(" ");
      return /* @__PURE__ */ n.createElement(
        "div",
        {
          key: g,
          role: "gridcell",
          "data-cal-day": g,
          tabIndex: g === a ? 0 : -1,
          "aria-selected": g === a,
          "aria-current": g === r ? "date" : void 0,
          "aria-label": `${t.dayAria(g)}${M ? ` ${M}` : ""}, ${t.eventCount(T)}`,
          className: I,
          onPointerDown: (q) => u.onCellDown(q, g),
          onKeyDown: (q) => k(q, g, x)
        },
        /* @__PURE__ */ n.createElement("div", { className: S.cellHead }, /* @__PURE__ */ n.createElement(
          "button",
          {
            type: "button",
            tabIndex: -1,
            className: S.dayNum,
            "aria-label": t.openDay(g),
            onPointerDown: (q) => q.stopPropagation(),
            onClick: () => e.goto("day", g)
          },
          $.d === 1 ? t.md(g) : $.d
        ), M && /* @__PURE__ */ n.createElement("span", { className: S.holiday, title: M }, M), e.onCreate && /* @__PURE__ */ n.createElement("span", { className: S.addHint, "aria-hidden": !0 }, "+"))
      );
    })), /* @__PURE__ */ n.createElement(qr, { segs: E, cols: m, top: Pn, ctx: e, drag: u }), h.map((g, $) => g > 0 ? /* @__PURE__ */ n.createElement(
      "button",
      {
        key: x[$],
        type: "button",
        className: S.more,
        style: {
          left: `calc(${$ / m * 100}% + 2px)`,
          width: `calc(${100 / m}% - 4px)`,
          top: Pn + (d - 1) * mn
        },
        onClick: (A) => e.openMore(x[$], A.currentTarget)
      },
      t.more(g)
    ) : null));
  })));
}
const Qe = 44, qd = Array.from({ length: 23 }, (e, t) => t + 1);
function Sa() {
  const e = /* @__PURE__ */ new Date();
  return Date.UTC(e.getFullYear(), e.getMonth(), e.getDate(), e.getHours(), e.getMinutes()) / 6e4;
}
function Xn(e, t) {
  const a = t.getBoundingClientRect();
  return Math.max(0, Math.min(Se, (e - a.top) / Qe * 60));
}
function Ma({ ctx: e, days: t }) {
  const a = t.length, r = e.slotMinutes, s = Tr(e), [o, l] = D(null), [c, i] = D(null), m = L(!1), u = Sn(e.events, t[0], t[a - 1], o != null ? o : s.preview), f = Cr(e.timeGrid ? u.filter(Dr) : u, t), y = f.reduce((E, h) => Math.max(E, h.lane + 1), 0), _ = { gridTemplateColumns: `repeat(${a}, minmax(0, 1fr))` }, [p, d] = D(Sa);
  Z(() => {
    const E = window.setInterval(() => d(Sa()), 6e4);
    return () => window.clearInterval(E);
  }, []);
  const b = L(null), N = t.includes(e.today);
  Be(() => {
    const E = b.current;
    if (!E) return;
    const h = N ? Math.max(0, Math.floor((p - ye(e.today)) / 60) - 1) : e.scrollToHour;
    E.scrollTop = h * Qe;
  }, [t[0], a]);
  const w = (E, h) => {
    if (E.button !== 0 || !e.onCreate) return;
    E.preventDefault();
    const g = E.currentTarget, $ = Math.min(Se - r, Math.floor(Xn(E.clientY, g) / r) * r);
    let A = $;
    i({ day: h, a: $, b: $ + r }), Nn(E, {
      move: (M) => {
        A = Math.min(Se - r, Math.floor(Xn(M.clientY, g) / r) * r), i({ day: h, a: Math.min($, A), b: Math.max($, A) + r });
      },
      end: (M, T) => {
        var G;
        i(null);
        const I = ye(h), q = T ? Math.min($, A) : $, P = T ? Math.max($, A) + r : Math.min($ + 60, Se);
        (G = e.onCreate) == null || G.call(e, { start: an(I + q), end: an(I + P), allDay: !1 });
      },
      cancel: () => i(null)
    });
  }, k = (E, h, g) => {
    if (E.stopPropagation(), E.button !== 0 || !rn(e, h.ev)) return;
    const $ = (T, I) => {
      const q = hn(T, I, "data-cal-col");
      return q ? ye(q.dataset.calCol) + Xn(I, q) : null;
    }, A = $(E.clientX, E.clientY);
    if (A == null) return;
    m.current = !1;
    let M = null;
    Nn(E, {
      move: (T) => {
        m.current = !0;
        const I = $(T.clientX, T.clientY);
        if (I != null) {
          if (g === "move") {
            const q = Aa(I - A, r);
            M = q ? Zn(h, q) : null;
          } else {
            const q = Math.max(h.s + r, Aa(I, r));
            M = q !== h.e ? { start: h.ev.start, end: an(q) } : null;
          }
          l(M ? { id: h.ev.id, ...M } : null);
        }
      },
      end: (T, I) => {
        var q;
        l(null), I && M && ((q = e.onEventChange) == null || q.call(e, h.ev, M));
      },
      cancel: () => l(null)
    });
  }, x = (E, h) => {
    var g;
    if (m.current) {
      m.current = !1;
      return;
    }
    (g = e.onEventClick) == null || g.call(e, h, E);
  };
  return /* @__PURE__ */ n.createElement("div", { className: S.time }, /* @__PURE__ */ n.createElement("div", { className: S.tHead }, /* @__PURE__ */ n.createElement("div", { className: S.gutter }), /* @__PURE__ */ n.createElement("div", { className: S.tHeadDays, style: _ }, t.map((E) => {
    const h = de(E), g = je(h), $ = e.holidays[E];
    return /* @__PURE__ */ n.createElement(
      "div",
      {
        key: E,
        className: [S.tDay, E === e.today ? S.isToday : "", g === 0 || $ ? S.sun : g === 6 ? S.sat : ""].join(" ")
      },
      /* @__PURE__ */ n.createElement("button", { type: "button", className: S.tDayBtn, onClick: () => e.goto("day", E), "aria-label": e.L.openDay(E) }, /* @__PURE__ */ n.createElement("span", { className: S.tWd }, e.L.weekdays[g]), /* @__PURE__ */ n.createElement("span", { className: S.tDayNum }, h.d)),
      $ && /* @__PURE__ */ n.createElement("span", { className: S.holiday, title: $ }, $)
    );
  }))), /* @__PURE__ */ n.createElement("div", { className: [S.tAllDay, e.timeGrid ? "" : S.tAllDayOnly].filter(Boolean).join(" ") }, /* @__PURE__ */ n.createElement("div", { className: S.gutter }, e.timeGrid ? e.L.allDay : ""), /* @__PURE__ */ n.createElement(
    "div",
    {
      className: S.tAllDayRow,
      style: e.timeGrid ? { height: Math.max(1, y) * mn + 6 } : { minHeight: Math.max(1, y) * mn + 6 }
    },
    /* @__PURE__ */ n.createElement("div", { className: S.tAllDayCells, style: _ }, t.map((E) => /* @__PURE__ */ n.createElement(
      "div",
      {
        key: E,
        "data-cal-day": E,
        className: [S.allDayCell, s.inSel(E) ? S.selDay : "", e.onCreate ? S.creatable : ""].join(" "),
        onPointerDown: (h) => s.onCellDown(h, E)
      }
    ))),
    /* @__PURE__ */ n.createElement(qr, { segs: f, cols: a, top: 3, ctx: e, drag: s })
  )), e.timeGrid && /* @__PURE__ */ n.createElement("div", { className: S.tBody, ref: b }, /* @__PURE__ */ n.createElement("div", { className: S.tGrid, style: { height: 24 * Qe } }, /* @__PURE__ */ n.createElement("div", { className: S.tGutter, "aria-hidden": !0 }, qd.map((E) => /* @__PURE__ */ n.createElement("span", { key: E, style: { top: E * Qe } }, Ze(E * 60)))), /* @__PURE__ */ n.createElement("div", { className: S.tCols, style: { ..._, backgroundSize: `100% ${Qe}px` } }, t.map((E) => {
    const h = Gu(u, E);
    return /* @__PURE__ */ n.createElement(
      "div",
      {
        key: E,
        "data-cal-col": E,
        className: [S.tCol, E === e.today ? S.isToday : "", e.onCreate ? S.creatable : ""].join(" "),
        onPointerDown: (g) => w(g, E)
      },
      (c == null ? void 0 : c.day) === E && /* @__PURE__ */ n.createElement("div", { className: S.tSel, style: { top: c.a / 60 * Qe, height: (c.b - c.a) / 60 * Qe } }, Ze(c.a), " – ", c.b === Se ? "24:00" : Ze(c.b)),
      h.map((g) => {
        const $ = g.item.ev, A = (g.bottom - g.top) / 60 * Qe, M = [
          S.tEv,
          Tn($),
          A < 34 ? S.tEvShort : "",
          g.contTop ? S.contTop : "",
          g.contBottom ? S.contBottom : "",
          (o == null ? void 0 : o.id) === $.id ? S.ghost : "",
          rn(e, $) ? S.movable : ""
        ].filter(Boolean).join(" ");
        return /* @__PURE__ */ n.createElement(
          "button",
          {
            key: $.id,
            type: "button",
            className: M,
            style: {
              top: g.top / 60 * Qe,
              height: Math.max(18, A - 1),
              left: `calc(${g.col / g.cols * 100}% + 1px)`,
              width: `calc(${100 / g.cols}% - 4px)`,
              ...qn($)
            },
            "aria-label": Mr(g.item, e.L),
            onPointerDown: (T) => k(T, g.item, "move"),
            onClick: (T) => x(T.currentTarget, $)
          },
          /* @__PURE__ */ n.createElement("span", { className: S.tEvTitle }, $.title),
          /* @__PURE__ */ n.createElement("span", { className: S.tEvTime }, da(g.item, e.L.allDay)),
          rn(e, $) && !g.contBottom && /* @__PURE__ */ n.createElement("span", { className: S.resize, "aria-hidden": !0, onPointerDown: (T) => k(T, g.item, "resize") })
        );
      }),
      E === e.today && /* @__PURE__ */ n.createElement("div", { className: S.now, style: { top: (p - ye(E)) / 60 * Qe }, "aria-hidden": !0 })
    );
  })))));
}
function Ta(e, t, a) {
  return e.sDay === e.eDay ? da(e, a) : e.allDay ? a : t === e.sDay ? `${Ze(e.s - ye(t))} ~` : t === e.eDay ? `~ ${Ze(e.e - ye(t))}` : a;
}
function Bd({ ctx: e }) {
  const { L: t } = e, { from: a, to: r } = ma("agenda", e.cursor, e.weekStartsOn), s = Sn(e.events, a, r), o = Mn(a, r).filter((l) => e.showWeekends || !un(l)).map((l) => {
    const c = ye(l), i = (u) => Ta(u, l, "") === "" ? -1 : Math.max(u.s, c), m = s.filter((u) => u.sDay <= l && u.eDay >= l);
    return { day: l, list: m.sort((u, f) => i(u) - i(f)) };
  }).filter((l) => l.list.length > 0);
  return o.length ? /* @__PURE__ */ n.createElement("div", { className: S.agenda }, o.map(({ day: l, list: c }) => {
    const i = de(l), m = e.holidays[l], u = je(i), f = t.weekdays[u];
    return /* @__PURE__ */ n.createElement("section", { key: l, className: [S.aDay, l === e.today ? S.isToday : ""].join(" "), "aria-label": t.dayAria(l) }, /* @__PURE__ */ n.createElement("div", { className: [S.aDate, u === 0 || m ? S.sun : u === 6 ? S.sat : ""].join(" ") }, /* @__PURE__ */ n.createElement("button", { type: "button", className: S.aDateBtn, onClick: () => e.goto("day", l) }, /* @__PURE__ */ n.createElement("span", { className: S.aDayNum }, i.d), /* @__PURE__ */ n.createElement("span", { className: S.aDayWd }, t.m(l), " · ", f)), m && /* @__PURE__ */ n.createElement("span", { className: S.holiday }, m)), /* @__PURE__ */ n.createElement("ul", { className: S.aList }, c.map((y) => {
      const _ = y.ev, p = Kt(y.sDay, y.eDay) + 1;
      return /* @__PURE__ */ n.createElement("li", { key: _.id }, /* @__PURE__ */ n.createElement(
        "button",
        {
          type: "button",
          className: [S.aRow, Tn(_)].join(" "),
          style: qn(_),
          onClick: (d) => {
            var b;
            return (b = e.onEventClick) == null ? void 0 : b.call(e, _, d.currentTarget);
          }
        },
        /* @__PURE__ */ n.createElement("i", { className: S.dot, "aria-hidden": !0 }),
        /* @__PURE__ */ n.createElement("span", { className: S.aTime }, Ta(y, l, t.allDay)),
        /* @__PURE__ */ n.createElement("span", { className: S.aTitle }, _.title, p > 1 && /* @__PURE__ */ n.createElement("em", { className: S.aSpan }, t.dayOfSpan(Kt(y.sDay, l) + 1, p))),
        _.location && /* @__PURE__ */ n.createElement("span", { className: S.aLoc }, _.location)
      ));
    })));
  })) : /* @__PURE__ */ n.createElement("div", { className: S.empty }, t.empty);
}
const zn = { KeyM: "month", KeyW: "week", KeyD: "day", KeyA: "agenda" };
function qa(e, t, a) {
  const [r, s] = D(t), o = e !== void 0 ? e : r;
  return [o, (c) => {
    e === void 0 && s(c), c !== o && (a == null || a(c));
  }];
}
const Ba = ({ dir: e }) => /* @__PURE__ */ n.createElement("svg", { width: "15", height: "15", viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round", "aria-hidden": !0 }, /* @__PURE__ */ n.createElement("path", { d: e === "l" ? "M15 5l-7 7 7 7" : "M9 5l7 7-7 7" }));
function Cv({
  events: e,
  view: t,
  defaultView: a,
  onViewChange: r,
  date: s,
  defaultDate: o,
  onDateChange: l,
  views: c = ["month", "week", "day", "agenda"],
  weekStartsOn: i = 0,
  defaultShowWeekends: m = !0,
  weekendToggle: u = !0,
  holidays: f,
  slotMinutes: y = 30,
  scrollToHour: _ = 8,
  timeGrid: p = !0,
  onRangeChange: d,
  onEventClick: b,
  onCreate: N,
  onEventChange: w,
  locale: k = Sr,
  loading: x,
  headerExtra: E,
  className: h = "",
  style: g,
  "aria-label": $
}) {
  var Y;
  const A = Nr(), [M, T] = qa(t, (Y = a != null ? a : c[0]) != null ? Y : "month", r), [I, q] = qa(s, o != null ? o : A, l), P = de(I) ? I : A, [G, K] = D(m), [j, te] = D(null), ne = L(null), v = L(!1);
  Z(() => {
    var H;
    if (!v.current) return;
    v.current = !1;
    const X = ne.current;
    !X || X.contains(document.activeElement) || ((H = X.querySelector('[data-cal-day][tabindex="0"]')) != null ? H : X).focus();
  });
  const { from: O, to: V } = ma(M, P, i), Q = L(d);
  Q.current = d, Z(() => {
    var X;
    (X = Q.current) == null || X.call(Q, { from: O, to: V, view: M });
  }, [O, V, M]);
  const se = (X, H) => {
    q(H), c.includes(X) && T(X);
  }, B = {
    events: e,
    L: k,
    cursor: P,
    today: A,
    weekStartsOn: i,
    showWeekends: G,
    holidays: f != null ? f : {},
    slotMinutes: y,
    scrollToHour: _,
    timeGrid: p,
    setCursor: q,
    goto: se,
    openMore: (X, H) => te({ day: X, anchor: H }),
    onEventClick: b,
    onCreate: N,
    onEventChange: w
  }, J = (X) => q(Wu(M, P, X, M === "day" && !G)), R = (X) => {
    if (X.defaultPrevented || X.ctrlKey || X.metaKey || X.altKey || X.target.closest('input, textarea, select, [contenteditable="true"]')) return;
    const H = X.nativeEvent.code;
    if (H === "KeyT") q(A);
    else if (H === "KeyN" || H === "KeyJ" || X.key === "PageDown") J(1);
    else if (H === "KeyP" || H === "KeyK" || X.key === "PageUp") J(-1);
    else if (zn[H] && c.includes(zn[H])) T(zn[H]);
    else if (H === "KeyC" && N)
      N(M === "month" || M === "agenda" ? { start: P, end: P, allDay: !0 } : { start: `${P}T09:00`, end: `${P}T10:00`, allDay: !1 });
    else return;
    X.preventDefault(), v.current = !0;
  }, z = we(
    () => Mn(O, V).filter((X) => G || !un(X)),
    [O, V, G]
  );
  return /* @__PURE__ */ n.createElement(
    "div",
    {
      className: [S.cal, h].filter(Boolean).join(" "),
      style: g,
      role: "region",
      "aria-label": $ != null ? $ : k.region,
      "aria-busy": x || void 0,
      "aria-keyshortcuts": "T N P M W D A C",
      onKeyDown: R,
      ref: ne,
      tabIndex: -1
    },
    /* @__PURE__ */ n.createElement("div", { className: S.toolbar }, /* @__PURE__ */ n.createElement(mt, { onClick: () => q(A), title: `${k.today} (T)` }, k.today), /* @__PURE__ */ n.createElement("span", { className: S.navBtns }, /* @__PURE__ */ n.createElement(Vn, { label: k.prev(M), onClick: () => J(-1) }, /* @__PURE__ */ n.createElement(Ba, { dir: "l" })), /* @__PURE__ */ n.createElement(Vn, { label: k.next(M), onClick: () => J(1) }, /* @__PURE__ */ n.createElement(Ba, { dir: "r" }))), /* @__PURE__ */ n.createElement("h2", { className: S.title, "aria-live": "polite" }, Hu(M, P, i, k)), /* @__PURE__ */ n.createElement("span", { className: S.toolRight }, E, u && M !== "day" && /* @__PURE__ */ n.createElement(
      "button",
      {
        type: "button",
        className: S.toggle,
        "aria-pressed": !G,
        onClick: () => K((X) => !X)
      },
      k.hideWeekends
    ), c.length > 1 && /* @__PURE__ */ n.createElement(
      fr,
      {
        variant: "segmented",
        "aria-label": k.viewTabs,
        items: c.map((X) => ({ key: X, label: k.views[X] })),
        value: M,
        onChange: (X) => T(X)
      }
    ))),
    /* @__PURE__ */ n.createElement("div", { className: S.body }, x && /* @__PURE__ */ n.createElement("div", { className: S.busy, role: "progressbar", "aria-label": k.loading }), M === "month" && /* @__PURE__ */ n.createElement(Td, { ctx: B }), M === "week" && /* @__PURE__ */ n.createElement(Ma, { ctx: B, days: z }), M === "day" && /* @__PURE__ */ n.createElement(Ma, { ctx: B, days: [P] }), M === "agenda" && /* @__PURE__ */ n.createElement(Bd, { ctx: B })),
    j && /* @__PURE__ */ n.createElement(Ld, { ctx: B, day: j.day, anchor: j.anchor, onClose: () => te(null) })
  );
}
function Ld({ ctx: e, day: t, anchor: a, onClose: r }) {
  const s = L(null), [o, l] = D({ top: -9999, left: -9999 }), c = de(t), i = Sn(e.events, t, t);
  return Be(() => {
    var _;
    const m = s.current;
    if (!m) return;
    const u = a.getBoundingClientRect(), f = m.offsetWidth, y = m.offsetHeight;
    l({
      left: Math.max(8, Math.min(u.left + u.width / 2 - f / 2, window.innerWidth - f - 8)),
      top: Math.max(8, Math.min(u.top - 60, window.innerHeight - y - 8))
    }), (_ = m.querySelector("[data-cal-pop-item]")) == null || _.focus();
  }, [a]), Z(() => {
    const m = () => {
      r(), a.isConnected && a.focus();
    }, u = (y) => {
      var _;
      (_ = s.current) != null && _.contains(y.target) || r();
    }, f = (y) => {
      y.key !== "Escape" || y.isComposing || (y.preventDefault(), y.stopPropagation(), m());
    };
    return document.addEventListener("mousedown", u), document.addEventListener("keydown", f, !0), () => {
      document.removeEventListener("mousedown", u), document.removeEventListener("keydown", f, !0);
    };
  }, [a, r]), /* @__PURE__ */ n.createElement(Gt, null, /* @__PURE__ */ n.createElement("div", { ref: s, className: S.pop, style: o, role: "dialog", "aria-label": `${e.L.md(t)} ${e.L.eventCount(i.length)}` }, /* @__PURE__ */ n.createElement("div", { className: S.popHead }, /* @__PURE__ */ n.createElement("button", { type: "button", className: S.popDay, onClick: () => {
    r(), e.goto("day", t);
  } }, /* @__PURE__ */ n.createElement("span", null, e.L.weekdays[je(c)]), /* @__PURE__ */ n.createElement("b", null, c.d)), /* @__PURE__ */ n.createElement("button", { type: "button", className: S.popClose, "aria-label": e.L.close, onClick: r }, "✕")), /* @__PURE__ */ n.createElement("ul", { className: S.popList }, i.map((m) => {
    const u = m.ev, f = m.allDay || m.sDay !== m.eDay;
    return /* @__PURE__ */ n.createElement("li", { key: u.id }, /* @__PURE__ */ n.createElement(
      "button",
      {
        type: "button",
        "data-cal-pop-item": !0,
        className: [S.popItem, f ? S.bar : S.dotChip, Tn(u)].join(" "),
        style: qn(u),
        onClick: () => {
          var y;
          r(), (y = e.onEventClick) == null || y.call(e, u, a);
        }
      },
      !f && /* @__PURE__ */ n.createElement("i", { className: S.dot, "aria-hidden": !0 }),
      !m.allDay && /* @__PURE__ */ n.createElement("span", { className: S.chipTime }, Ze(Math.max(m.s, ye(t)) - ye(t))),
      /* @__PURE__ */ n.createElement("span", { className: S.chipTitle }, u.title)
    ));
  }))));
}
const jd = "_mini_q7p5n_3", Rd = "_nav_q7p5n_5", Id = "_navBtn_q7p5n_6", Od = "_todayBtn_q7p5n_6", Pd = "_title_q7p5n_6", Xd = "_day_q7p5n_25", zd = "_mon_q7p5n_25", Fd = "_grid_q7p5n_29", Wd = "_wdRow_q7p5n_30", Hd = "_row_q7p5n_30", Kd = "_sun_q7p5n_35", Ud = "_sat_q7p5n_36", Gd = "_num_q7p5n_45", Yd = "_sel_q7p5n_46", Vd = "_out_q7p5n_50", Qd = "_isToday_q7p5n_52", Jd = "_dots_q7p5n_55", Zd = "_months_q7p5n_59", le = {
  mini: jd,
  nav: Rd,
  navBtn: Id,
  todayBtn: Od,
  title: Pd,
  day: Xd,
  mon: zd,
  grid: Fd,
  wdRow: Wd,
  row: Hd,
  sun: Kd,
  sat: Ud,
  num: Gd,
  sel: Yd,
  out: Vd,
  isToday: Qd,
  dots: Jd,
  months: Zd
}, La = (e, t) => `${String(e).padStart(4, "0")}-${String(t).padStart(2, "0")}`;
function Sv({
  month: e,
  onMonthChange: t,
  value: a,
  onPick: r,
  marks: s = {},
  markLabel: o,
  holidays: l = {},
  weekStartsOn: c = 0,
  locale: i = Sr,
  today: m,
  children: u,
  className: f = "",
  "aria-label": y
}) {
  const _ = m != null ? m : Nr(), p = /^\d{4}-\d{2}$/.test(e) ? `${e}-01` : `${_.slice(0, 7)}-01`, d = de(p), b = wn(p, c), N = Mn(b, ke(b, 41)), w = o != null ? o : i.eventCount, [k, x] = D("day"), [E, h] = D(d.y), g = (K) => !!K && K.slice(0, 7) === p.slice(0, 7), [$, A] = D(() => g(a) ? a : g(_) ? _ : p);
  Z(() => {
    g($) || A(g(a) ? a : g(_) ? _ : p);
  }, [p]);
  const M = L(!1), T = L(null);
  Z(() => {
    var K, j;
    M.current && (M.current = !1, (j = (K = T.current) == null ? void 0 : K.querySelector(`[data-day="${$}"]`)) == null || j.focus());
  }, [$, p]);
  const I = (K) => {
    M.current = !0, A(K), g(K) || t(K.slice(0, 7));
  }, q = (K) => {
    const j = gt(d, K);
    t(La(j.y, j.m));
  }, P = (K, j) => {
    const te = de(j), ne = (je(te) - c + 7) % 7;
    let v = null;
    if (K.key === "ArrowLeft") v = ke(j, -1);
    else if (K.key === "ArrowRight") v = ke(j, 1);
    else if (K.key === "ArrowUp") v = ke(j, -7);
    else if (K.key === "ArrowDown") v = ke(j, 7);
    else if (K.key === "Home") v = ke(j, -ne);
    else if (K.key === "End") v = ke(j, 6 - ne);
    else if (K.key === "PageUp" || K.key === "PageDown") {
      const O = gt(te, K.key === "PageUp" ? -1 : 1);
      v = tt(O.y, O.m, O.d);
    }
    v && (K.preventDefault(), I(v));
  }, G = () => {
    h(d.y), x("month");
  };
  return /* @__PURE__ */ n.createElement("div", { className: [le.mini, f].filter(Boolean).join(" "), role: y ? "group" : void 0, "aria-label": y }, k === "day" ? /* @__PURE__ */ n.createElement("div", { className: le.nav }, /* @__PURE__ */ n.createElement("button", { type: "button", className: le.navBtn, "aria-label": i.prevMonth, onClick: () => q(-1) }, "‹"), /* @__PURE__ */ n.createElement("button", { type: "button", className: le.title, "aria-label": `${i.ym(p)}, ${i.pickMonth}`, "aria-live": "polite", onClick: G }, i.ym(p)), /* @__PURE__ */ n.createElement("button", { type: "button", className: le.navBtn, "aria-label": i.nextMonth, onClick: () => q(1) }, "›"), /* @__PURE__ */ n.createElement(
    "button",
    {
      type: "button",
      className: le.todayBtn,
      disabled: g(_),
      onClick: () => {
        t(_.slice(0, 7)), I(_);
      }
    },
    i.today
  )) : /* @__PURE__ */ n.createElement("div", { className: le.nav }, /* @__PURE__ */ n.createElement("button", { type: "button", className: le.navBtn, "aria-label": i.prevYear, onClick: () => h((K) => K - 1) }, "‹"), /* @__PURE__ */ n.createElement("span", { className: le.title, "aria-live": "polite" }, i.year(`${E}-12-31`)), /* @__PURE__ */ n.createElement("button", { type: "button", className: le.navBtn, "aria-label": i.nextYear, onClick: () => h((K) => K + 1) }, "›"), /* @__PURE__ */ n.createElement("button", { type: "button", className: le.todayBtn, onClick: () => x("day"), "aria-label": i.close }, "✕")), k === "month" ? /* @__PURE__ */ n.createElement("div", { className: le.months, onKeyDown: (K) => {
    K.key === "Escape" && (K.preventDefault(), x("day"));
  } }, Array.from({ length: 12 }, (K, j) => {
    const te = La(E, j + 1), ne = te === p.slice(0, 7);
    return /* @__PURE__ */ n.createElement(
      "button",
      {
        key: te,
        type: "button",
        className: [le.mon, ne ? le.sel : "", te === _.slice(0, 7) ? le.isToday : ""].filter(Boolean).join(" "),
        "aria-pressed": ne,
        autoFocus: ne,
        onClick: () => {
          t(te), x("day");
        }
      },
      i.m(`${te}-01`)
    );
  })) : /* @__PURE__ */ n.createElement("div", { className: le.grid, role: "grid", "aria-label": i.ym(p), ref: T }, /* @__PURE__ */ n.createElement("div", { className: le.wdRow, role: "row" }, N.slice(0, 7).map((K) => {
    const j = je(de(K));
    return /* @__PURE__ */ n.createElement("span", { key: K, role: "columnheader", className: j === 0 ? le.sun : j === 6 ? le.sat : "" }, i.weekdays[j]);
  })), [0, 1, 2, 3, 4, 5].map((K) => /* @__PURE__ */ n.createElement("div", { key: K, className: le.row, role: "row" }, N.slice(K * 7, K * 7 + 7).map((j) => {
    var V;
    const te = je(de(j)), ne = l[j], v = (V = s[j]) != null ? V : 0, O = [
      le.day,
      g(j) ? "" : le.out,
      te === 0 || ne ? le.sun : te === 6 ? le.sat : "",
      j === _ ? le.isToday : "",
      j === a ? le.sel : ""
    ].filter(Boolean).join(" ");
    return /* @__PURE__ */ n.createElement(
      "button",
      {
        key: j,
        type: "button",
        role: "gridcell",
        "data-day": j,
        className: O,
        tabIndex: j === $ ? 0 : -1,
        "aria-selected": j === a,
        "aria-current": j === _ ? "date" : void 0,
        "aria-label": [i.dayAria(j), ne, v ? w(v) : ""].filter(Boolean).join(", "),
        onKeyDown: (Q) => P(Q, j),
        onFocus: () => A(j),
        onClick: () => r(j)
      },
      /* @__PURE__ */ n.createElement("span", { className: le.num }, +j.slice(8)),
      /* @__PURE__ */ n.createElement("span", { className: le.dots, "aria-hidden": !0 }, Array.from({ length: Math.min(v, 3) }, (Q, se) => /* @__PURE__ */ n.createElement("i", { key: se })))
    );
  })))), u);
}
function ef(e) {
  const t = e.match(/\d/g);
  return t ? t.length : 0;
}
function Mv({
  value: e,
  onChangeAm: t,
  allowNegative: a = !0,
  onReject: r,
  unit: s,
  className: o,
  ...l
}) {
  const c = L(null), i = L(null), [m, u] = D(!1), f = e == null || e === "";
  Be(() => {
    const _ = c.current, p = i.current;
    if (i.current = null, !_ || p === null) return;
    let d = 0, b = 0;
    for (; d < _.value.length && b < p; )
      /\d/.test(_.value[d]) && (b += 1), d += 1;
    d === 0 && _.value[0] === "-" && (d = 1), _.setSelectionRange(d, d);
  });
  const y = /* @__PURE__ */ n.createElement(
    "input",
    {
      ...l,
      ref: c,
      type: "text",
      inputMode: "numeric",
      className: o,
      value: m && f ? "-" : ts(e),
      onChange: (_) => {
        var b;
        const p = _.target;
        i.current = ef(p.value.slice(0, (b = p.selectionStart) != null ? b : p.value.length));
        const d = Zr(p.value, a);
        if (r) {
          const N = ir(p.value);
          !a && /^\s*-/.test(N) ? r("sign") : (/\.\d/.test(N.replace(/^\s*-/, "")) || /\.$/.test(N)) && r("decimal");
        }
        u(d === "-"), t({ text: d, num: es(d) });
      }
    }
  );
  return s ? /* @__PURE__ */ n.createElement(n.Fragment, null, y, /* @__PURE__ */ n.createElement("span", { className: "axe-money-unit", style: { marginLeft: 6, fontSize: 12, color: "#334155", whiteSpace: "nowrap" } }, s)) : y;
}
function ea(e) {
  const t = ir(e).replace(/,/g, "").trim();
  if (t === "") return null;
  const a = Number(t);
  return Number.isFinite(a) ? a : null;
}
function ja(e, t) {
  const a = ea(e), r = ea(t);
  return a == null || r == null ? null : Math.round(a * r);
}
function Tv(e, t) {
  var o, l;
  const a = ja(e.qty, e.unitAm), r = ja((o = t.qty) != null ? o : e.qty, (l = t.unitAm) != null ? l : e.unitAm);
  if (r == null) return t;
  const s = ea(e.lineAm);
  return s == null || s === a ? { ...t, lineAm: String(r) } : t;
}
const tf = "_box_qzg36_3", nf = "_banner_qzg36_9", af = "_verify_qzg36_10", rf = "_t_info_qzg36_15", sf = "_t_warn_qzg36_16", of = "_t_danger_qzg36_17", lf = "_error_qzg36_22", cf = "_note_qzg36_30", uf = "_noteI_qzg36_42", mf = "_noteBody_qzg36_43", df = "_badge_qzg36_49", ff = "_b_muted_qzg36_53", _f = "_b_ok_qzg36_54", pf = "_b_warn_qzg36_55", yf = "_b_info_qzg36_56", bf = "_b_off_qzg36_57", Fe = {
  box: tf,
  banner: nf,
  verify: af,
  t_info: rf,
  t_warn: sf,
  t_danger: of,
  error: lf,
  note: cf,
  noteI: uf,
  noteBody: mf,
  badge: df,
  b_muted: ff,
  b_ok: _f,
  b_warn: pf,
  b_info: yf,
  b_off: bf
};
function Ef({ tone: e = "warn", className: t = "", children: a }) {
  return /* @__PURE__ */ n.createElement("div", { className: [Fe.box, Fe.banner, Fe[`t_${e}`], t].filter(Boolean).join(" ") }, a);
}
function qv({ tone: e = "ok", className: t = "", children: a }) {
  const r = e === "ok" ? "info" : e === "bad" ? "danger" : "warn";
  return /* @__PURE__ */ n.createElement("div", { className: [Fe.box, Fe.verify, Fe[`t_${r}`], t].filter(Boolean).join(" ") }, a);
}
function Br({ className: e = "", children: t }) {
  return t == null || t === !1 || t === "" ? null : /* @__PURE__ */ n.createElement("p", { className: [Fe.error, e].filter(Boolean).join(" "), role: "alert" }, typeof t == "string" ? /* @__PURE__ */ n.createElement(hf, { text: t }) : t);
}
function Bv({ label: e = "안내", className: t = "", children: a }) {
  return /* @__PURE__ */ n.createElement("details", { className: [Fe.note, t].filter(Boolean).join(" ") }, /* @__PURE__ */ n.createElement("summary", null, /* @__PURE__ */ n.createElement("span", { className: Fe.noteI, "aria-hidden": "true" }, "ⓘ"), e), /* @__PURE__ */ n.createElement("div", { className: Fe.noteBody }, a));
}
function Ra({ tone: e = "muted", className: t = "", children: a }) {
  return /* @__PURE__ */ n.createElement("span", { className: ["axe-badge", Fe.badge, Fe[`b_${e}`], t].filter(Boolean).join(" ") }, a);
}
function hf({ text: e }) {
  return e ? /* @__PURE__ */ n.createElement(n.Fragment, null, e.split(/\*\*(.+?)\*\*/g).map((t, a) => a % 2 ? /* @__PURE__ */ n.createElement("b", { key: a }, t) : /* @__PURE__ */ n.createElement(Qr, { key: a }, t))) : null;
}
const gf = "저장하지 않은 변경이 있습니다. 버리고 이동할까요?";
function vf(e, t = gf) {
  const a = L(e);
  return a.current = e, Z(() => {
    if (!e) return;
    const r = (s) => {
      s.preventDefault(), s.returnValue = "";
    };
    return window.addEventListener("beforeunload", r), () => window.removeEventListener("beforeunload", r);
  }, [e]), oe(() => !a.current || window.confirm(t), [t]);
}
const kf = "_overlay_1qt6w_2", wf = "_modal_1qt6w_8", Nf = "_wide_1qt6w_15", $f = "_head_1qt6w_16", xf = "_title_1qt6w_20", Df = "_close_1qt6w_21", Af = "_body_1qt6w_25", Cf = "_flush_1qt6w_26", Sf = "_error_1qt6w_27", Mf = "_foot_1qt6w_29", Ye = {
  overlay: kf,
  modal: wf,
  wide: Nf,
  head: $f,
  title: xf,
  close: Df,
  body: Af,
  flush: Cf,
  error: Sf,
  foot: Mf
}, Tt = [];
function Ia(e) {
  const t = Tt[Tt.length - 1];
  e.key !== "Escape" || e.defaultPrevented || e.isComposing || !t || !t.esc || (e.preventDefault(), t.close());
}
const Tf = 'a[href],button:not(:disabled),input:not(:disabled):not([type=hidden]),select:not(:disabled),textarea:not(:disabled),[tabindex]:not([tabindex="-1"])';
function Oa(e) {
  return Array.from(e.querySelectorAll(Tf)).filter((t) => t.getClientRects().length > 0 && getComputedStyle(t).visibility !== "hidden");
}
let Pa = 0, Xa = "";
function Bn({
  title: e,
  onClose: t,
  children: a,
  wide: r,
  footer: s,
  headerExtra: o,
  flush: l,
  closeOnBackdrop: c = !0,
  closeOnEsc: i = !1,
  error: m,
  confirmDiscard: u = !0
}) {
  const [f, y] = D(!1), _ = u ? () => {
    f || y(!0);
  } : void 0, p = vf(u && f, "입력한 내용을 저장하지 않고 닫을까요?"), d = () => {
    p() && t();
  }, b = L(d);
  b.current = d;
  const N = L({ close: () => b.current(), esc: i });
  N.current.esc = i, Z(() => {
    const h = N.current;
    return Tt.push(h), Tt.length === 1 && window.addEventListener("keydown", Ia), () => {
      const g = Tt.lastIndexOf(h);
      g >= 0 && Tt.splice(g, 1), Tt.length === 0 && window.removeEventListener("keydown", Ia);
    };
  }, []);
  const w = L(null), k = L(null), x = L(void 0);
  x.current === void 0 && (x.current = typeof document == "undefined" ? null : document.activeElement), Z(() => {
    var $;
    const h = w.current, g = ($ = x.current) != null ? $ : null;
    return h && !h.contains(document.activeElement) && (k.current && Oa(k.current)[0] || null || h).focus(), Pa++ === 0 && (Xa = document.body.style.overflow, document.body.style.overflow = "hidden"), () => {
      --Pa === 0 && (document.body.style.overflow = Xa), g && g.isConnected && typeof g.focus == "function" && g.focus();
    };
  }, []);
  const E = (h) => {
    const g = w.current;
    if (h.key !== "Tab" || !g || !g.contains(h.target)) return;
    const $ = Oa(g);
    if ($.length === 0) {
      h.preventDefault(), g.focus();
      return;
    }
    const A = $[0], M = $[$.length - 1], T = document.activeElement;
    h.shiftKey && (T === A || T === g) ? (h.preventDefault(), M.focus()) : !h.shiftKey && T === M && (h.preventDefault(), A.focus());
  };
  return /* @__PURE__ */ n.createElement("div", { className: Ye.overlay, onClick: c ? d : void 0 }, /* @__PURE__ */ n.createElement(
    "div",
    {
      ref: w,
      tabIndex: -1,
      className: [Ye.modal, r ? Ye.wide : ""].filter(Boolean).join(" "),
      role: "dialog",
      "aria-modal": "true",
      "aria-label": e,
      onClick: (h) => h.stopPropagation(),
      onKeyDown: E
    },
    /* @__PURE__ */ n.createElement("header", { className: Ye.head }, /* @__PURE__ */ n.createElement("strong", { className: Ye.title }, e), o, /* @__PURE__ */ n.createElement("button", { type: "button", className: Ye.close, onClick: d, "aria-label": "닫기" }, "✕")),
    /* @__PURE__ */ n.createElement(
      "div",
      {
        ref: k,
        className: [Ye.body, l ? Ye.flush : ""].filter(Boolean).join(" "),
        onInputCapture: _,
        onChangeCapture: _
      },
      a
    ),
    m != null && m !== !1 && m !== "" && /* @__PURE__ */ n.createElement("div", { className: Ye.error }, /* @__PURE__ */ n.createElement(Br, null, m)),
    s && /* @__PURE__ */ n.createElement("footer", { className: Ye.foot }, s)
  ));
}
function Lv(e = 4e3) {
  const [t, a] = D(""), [r, s] = D(!1), o = L(void 0), l = oe((m) => {
    window.clearTimeout(o.current), s(!1), a(m), o.current = window.setTimeout(() => a(""), e);
  }, [e]), c = oe((m) => {
    window.clearTimeout(o.current), s(!0), a(m);
  }, []), i = oe(() => {
    window.clearTimeout(o.current), s(!1), a("");
  }, []);
  return [t, l, c, r, i];
}
const qf = "_message_psco6_1", Bf = "_details_psco6_2", Lf = "_warn_psco6_7", jf = "_field_psco6_8", pn = {
  message: qf,
  details: Bf,
  warn: Lf,
  field: jf
};
function jv() {
  var _, p;
  const [e, t] = D(null), [a, r] = D(""), s = L(null), o = L(null), l = L(null), c = oe((d) => new Promise((b) => {
    t({ kind: "confirm", opts: d, resolve: b });
  }), []), i = oe((d) => new Promise((b) => {
    var N, w, k, x;
    r((x = (k = d.defaultValue) != null ? k : (w = (N = d.choices) == null ? void 0 : N[0]) == null ? void 0 : w.value) != null ? x : ""), t({ kind: "prompt", opts: d, resolve: b });
  }), []);
  Z(() => {
    var d, b, N;
    e && (e.kind === "prompt" ? (d = l.current) == null || d.focus() : e.opts.danger || e.opts.focusCancel ? (b = o.current) == null || b.focus() : (N = s.current) == null || N.focus());
  }, [e]);
  const m = (d) => {
    e && (e.kind === "confirm" ? e.resolve(d) : e.resolve(d ? a : null), t(null));
  }, u = e == null ? void 0 : e.opts, f = (e == null ? void 0 : e.kind) === "prompt" && !!e.opts.required && !a.trim(), y = e && u ? /* @__PURE__ */ n.createElement(
    Bn,
    {
      title: u.title,
      onClose: () => m(!1),
      closeOnBackdrop: !1,
      closeOnEsc: !0,
      confirmDiscard: !1,
      footer: /* @__PURE__ */ n.createElement(n.Fragment, null, /* @__PURE__ */ n.createElement(mt, { ref: o, onClick: () => m(!1) }, (_ = u.cancelLabel) != null ? _ : "취소"), /* @__PURE__ */ n.createElement(
        mt,
        {
          ref: s,
          variant: u.danger ? "danger" : "primary",
          disabled: f,
          onClick: () => m(!0)
        },
        (p = u.confirmLabel) != null ? p : "확인"
      ))
    },
    u.message && /* @__PURE__ */ n.createElement("div", { className: pn.message }, u.message),
    u.details && u.details.length > 0 && /* @__PURE__ */ n.createElement("ul", { className: pn.details }, u.details.map((d, b) => /* @__PURE__ */ n.createElement("li", { key: b }, d))),
    u.irreversible && /* @__PURE__ */ n.createElement("p", { className: pn.warn }, "이 작업은 되돌릴 수 없습니다."),
    e.kind === "prompt" && /* @__PURE__ */ n.createElement("label", { className: pn.field }, /* @__PURE__ */ n.createElement("span", null, e.opts.label), e.opts.choices ? /* @__PURE__ */ n.createElement("select", { ref: l, value: a, onChange: (d) => r(d.target.value) }, e.opts.choices.map((d) => /* @__PURE__ */ n.createElement("option", { key: d.value, value: d.value }, d.label))) : /* @__PURE__ */ n.createElement(
      "input",
      {
        ref: l,
        value: a,
        placeholder: e.opts.placeholder,
        maxLength: e.opts.maxLength,
        onChange: (d) => r(d.target.value),
        onKeyDown: (d) => {
          d.key === "Enter" && !f && (d.preventDefault(), m(!0));
        }
      }
    ))
  ) : null;
  return { confirm: c, prompt: i, dialog: y };
}
function Rv(e, t) {
  return (t ? `${t}에 실패했습니다 — ` : "") + Rf(e);
}
function Rf(e) {
  return e === 0 ? "일시적인 문제로 처리하지 못했습니다. 잠시 후 다시 시도하세요" : e === 400 || e === 422 ? "입력 내용을 처리할 수 없습니다. 입력값을 확인한 뒤 다시 시도하세요" : e === 401 ? "로그인이 만료되었습니다. 다시 로그인하세요" : e === 403 ? "이 작업을 할 권한이 없습니다" : e === 404 ? "대상을 찾을 수 없습니다" : e === 409 ? "다른 사용자가 먼저 수정했습니다. 다시 조회한 뒤 수정하세요" : e === 413 ? "보낸 자료가 너무 큽니다. 크기를 줄여 다시 시도하세요" : e === 429 ? "요청이 너무 많습니다. 잠시 후 다시 시도하세요" : e >= 500 ? "일시적인 문제로 처리하지 못했습니다. 잠시 후 다시 시도하세요" : "요청을 처리하지 못했습니다. 다시 시도하세요";
}
function Iv() {
  const [e, t] = D(!1), a = L(!1), r = oe(async (s) => {
    if (!a.current) {
      a.current = !0, t(!0);
      try {
        return await s();
      } finally {
        a.current = !1, t(!1);
      }
    }
  }, []);
  return [e, r];
}
function Ov(e, t, a, r) {
  const [s, o] = D(null), [l, c] = D(a), [i, m] = D(null), [u, f] = D(!1), [y, _] = D(0), p = L(0), d = L(r);
  d.current = r;
  const b = oe(() => _((N) => N + 1), []);
  return Z(() => {
    if (!a) return;
    const N = ++p.current;
    return c(!0), e().then((w) => {
      N === p.current && (o(w), m(null), f(!1));
    }).catch((w) => {
      var k, x, E;
      N === p.current && (m(d.current.errorText(w)), f((E = (x = (k = d.current).isUnavailable) == null ? void 0 : x.call(k, w)) != null ? E : !1));
    }).finally(() => {
      N === p.current && c(!1);
    }), () => {
      p.current++;
    };
  }, [a, y, ...t]), { data: s, loading: l, error: i, unavailable: u, reload: b };
}
function Pv(e) {
  const [t, a] = D(null), [r, s] = D(null), [o, l] = D(!1), [c, i] = D(1), m = L(0), u = L(e);
  u.current = e;
  const f = oe(async (_, p) => {
    const d = ++m.current;
    l(!0), s(null);
    try {
      const b = await p(_);
      if (d !== m.current) return;
      a(b), i(_);
    } catch (b) {
      if (d !== m.current) return;
      a(null), s(u.current.errorText(b));
    } finally {
      d === m.current && l(!1);
    }
  }, []), y = oe(() => {
    m.current++, a(null), s(null), l(!1);
  }, []);
  return { data: t, err: r, loading: o, page: c, load: f, clear: y };
}
const If = "_section_dyrr7_3", Of = "_row_dyrr7_10", Pf = "_label_dyrr7_15", Xf = "_value_dyrr7_21", zf = "_invalid_dyrr7_43", Ff = "_help_dyrr7_45", Wf = "_err_dyrr7_45", Hf = "_req_dyrr7_49", Kf = "_opt_dyrr7_50", Uf = "_sr_dyrr7_51", Gf = "_ro_dyrr7_10", Yf = "_readonly_dyrr7_58", Vf = "_hint_dyrr7_65", Qf = "_toggle_dyrr7_73", Jf = "_table_dyrr7_80", Zf = "_isReq_dyrr7_95", Ce = {
  section: If,
  row: Of,
  label: Pf,
  value: Xf,
  invalid: zf,
  help: Ff,
  err: Wf,
  req: Hf,
  opt: Kf,
  sr: Uf,
  ro: Gf,
  readonly: Yf,
  hint: Vf,
  toggle: Qf,
  table: Jf,
  isReq: Zf
};
let e_ = 0;
const t_ = /* @__PURE__ */ new Set(["input", "select", "textarea"]);
function Xv({
  label: e,
  children: t,
  hint: a,
  ro: r,
  htmlFor: s,
  required: o,
  optional: l,
  help: c,
  error: i,
  className: m = ""
}) {
  var E, h, g, $;
  const u = L(`axe-fr${++e_}`).current, f = `${u}-lbl`, y = L(null), _ = c ? `${u}-help` : void 0, p = i ? `${u}-err` : void 0, d = [_, p].filter(Boolean).join(" ") || void 0, b = a && a.replace(/\*\*(.+?)\*\*/g, "$1");
  let N = t;
  const w = Yn.count(t) === 1 ? Yn.toArray(t)[0] : null, k = ln(w) && typeof w.type != "string" && !!w.type.axeFormControl;
  if (ln(w) && (typeof w.type == "string" && t_.has(w.type) || k)) {
    const A = w, M = A.props;
    N = oa(A, {
      id: (E = M.id) != null ? E : s,
      "aria-describedby": (h = M["aria-describedby"]) != null ? h : d,
      "aria-invalid": (g = M["aria-invalid"]) != null ? g : i ? !0 : void 0,
      "aria-required": ($ = M["aria-required"]) != null ? $ : o ? !0 : void 0
    });
  }
  Be(() => {
    var I;
    const A = (I = y.current) == null ? void 0 : I.querySelector("input:not([type=hidden]):not([type=checkbox]):not([type=radio]), select, textarea");
    if (!A) return;
    const M = (q, P) => {
      const G = `data-fr-${q}`;
      if (P == null) {
        A.hasAttribute(G) && (A.removeAttribute(q), A.removeAttribute(G));
        return;
      }
      A.hasAttribute(q) && !A.hasAttribute(G) || (A.getAttribute(q) !== P && A.setAttribute(q, P), A.setAttribute(G, ""));
    }, T = !!(A.id && document.querySelector(`label[for="${CSS.escape(A.id)}"]`));
    M("aria-labelledby", T ? null : f), M("aria-invalid", i ? "true" : null), M("aria-required", o ? "true" : null), M("aria-describedby", d != null ? d : null);
  });
  const x = /* @__PURE__ */ n.createElement(n.Fragment, null, e, o && /* @__PURE__ */ n.createElement(n.Fragment, null, /* @__PURE__ */ n.createElement("span", { className: Ce.req, "aria-hidden": "true" }, "*"), /* @__PURE__ */ n.createElement("span", { className: Ce.sr }, "필수")), l && /* @__PURE__ */ n.createElement("span", { className: Ce.opt }, "(선택)"));
  return /* @__PURE__ */ n.createElement("div", { className: ["axe-form-row", Ce.row, r ? Ce.ro : "", i ? Ce.invalid : "", o ? Ce.isReq : "", m].filter(Boolean).join(" ") }, /* @__PURE__ */ n.createElement("span", { className: `axe-form-label ${Ce.label}` }, s ? /* @__PURE__ */ n.createElement("label", { htmlFor: s, id: f }, x) : /* @__PURE__ */ n.createElement("span", { id: f }, x), a && /* @__PURE__ */ n.createElement(jt, { content: b, describe: !1 }, /* @__PURE__ */ n.createElement("span", { className: `axe-form-hint ${Ce.hint}`, role: "img", "aria-label": `도움말: ${b}`, tabIndex: 0 }, "?"))), /* @__PURE__ */ n.createElement("span", { ref: y, className: `axe-form-value ${Ce.value}` }, N, c && /* @__PURE__ */ n.createElement("span", { id: _, className: Ce.help }, c), i && /* @__PURE__ */ n.createElement("span", { id: p, className: Ce.err }, i)));
}
function zv({ title: e, children: t, className: a = "", variant: r = "stack" }) {
  return /* @__PURE__ */ n.createElement("section", { className: ["axe-form-section", r === "table" ? `axe-form-table ${Ce.table}` : "", Ce.section, a].filter(Boolean).join(" ") }, /* @__PURE__ */ n.createElement("h3", null, e), t);
}
function Fv({ children: e }) {
  return /* @__PURE__ */ n.createElement("span", { className: Ce.readonly }, e);
}
function Wv({ checked: e, onChange: t, disabled: a, label: r, className: s = "" }) {
  return /* @__PURE__ */ n.createElement("label", { className: [Ce.toggle, s].filter(Boolean).join(" ") }, /* @__PURE__ */ n.createElement("input", { type: "checkbox", checked: e, disabled: a, onChange: (o) => t(o.target.checked) }), /* @__PURE__ */ n.createElement("span", null, r));
}
const n_ = "_mono_6omzf_2", a_ = "_invalid_6omzf_3", r_ = "_qty_6omzf_6", s_ = "_qtyInput_6omzf_7", o_ = "_unit_6omzf_8", l_ = "_note_6omzf_9", c_ = "_qtyErr_6omzf_10", Et = {
  mono: n_,
  invalid: a_,
  qty: r_,
  qtyInput: s_,
  unit: o_,
  note: l_,
  qtyErr: c_
};
function i_({
  value: e,
  onChange: t,
  disabled: a,
  maxLength: r,
  placeholder: s,
  mono: o,
  invalid: l,
  multiline: c,
  rows: i = 4,
  label: m,
  id: u,
  "aria-describedby": f,
  "aria-invalid": y,
  "aria-required": _,
  className: p = ""
}) {
  const d = [o ? Et.mono : "", l ? Et.invalid : "", p].filter(Boolean).join(" ") || void 0, b = {
    id: u,
    className: d,
    value: e != null ? e : "",
    maxLength: r,
    placeholder: s,
    disabled: a,
    "aria-label": m,
    "aria-describedby": f,
    "aria-invalid": y != null ? y : l || void 0,
    "aria-required": _,
    onChange: (N) => t(N.target.value === "" ? null : N.target.value)
  };
  return c ? /* @__PURE__ */ n.createElement("textarea", { ...b, rows: i }) : /* @__PURE__ */ n.createElement("input", { type: "text", ...b });
}
i_.axeFormControl = !0;
function u_(e) {
  const {
    value: t,
    options: a,
    allLabel: r,
    disabled: s,
    label: o,
    id: l,
    "aria-describedby": c,
    "aria-invalid": i,
    "aria-required": m,
    className: u
  } = e, f = (_) => {
    e.codeType === "string" ? e.onChange(_ === "" ? null : _) : e.onChange(_ === "" ? null : Number(_));
  }, y = Array.isArray(a) ? a : Object.entries(a);
  return /* @__PURE__ */ n.createElement(
    "select",
    {
      id: l,
      className: u,
      value: t == null ? "" : String(t),
      disabled: s,
      "aria-label": o,
      "aria-describedby": c,
      "aria-invalid": i,
      "aria-required": m,
      onChange: (_) => f(_.target.value)
    },
    r != null && /* @__PURE__ */ n.createElement("option", { value: "" }, r),
    y.map(([_, p]) => /* @__PURE__ */ n.createElement("option", { key: _, value: String(_) }, p))
  );
}
u_.axeFormControl = !0;
function m_(e) {
  return e.replace(/[０-９]/g, (t) => String.fromCharCode(t.charCodeAt(0) - 65248)).replace(/[．。]/g, ".").replace(/[－−ー]/g, "-").replace(/[，、]/g, ",");
}
const d_ = /^-?(\d+\.?\d*|\.\d+)$/;
function Zt(e) {
  const t = m_(e).trim().replace(/,/g, "");
  if (t === "") return { kind: "empty" };
  if (t === "-" || t === "." || t === "-.") return { kind: "partial" };
  if (!d_.test(t)) return { kind: "bad" };
  const a = Number(t);
  return Number.isFinite(a) ? { kind: "num", value: a === 0 ? 0 : a } : { kind: "bad" };
}
function $n(e) {
  if (!Number.isFinite(e)) return 0;
  const t = Math.abs(e).toString(), a = t.indexOf("e-");
  if (a >= 0) {
    const s = t.slice(0, a), o = s.indexOf(".");
    return (o >= 0 ? s.length - o - 1 : 0) + Number(t.slice(a + 2));
  }
  const r = t.indexOf(".");
  return r >= 0 ? t.length - r - 1 : 0;
}
function Lr(e, t) {
  if (!Number.isFinite(e)) return e;
  const a = Math.max(0, Math.floor(t));
  if ($n(e) <= a) return e;
  const r = e < 0 ? -1 : 1, s = Math.abs(e).toFixed(Math.min(20, $n(e))), o = Math.round(+`${s}e${a}`), l = r * +`${o}e-${a}`;
  return l === 0 ? 0 : l;
}
function Pt(e) {
  return e == null || !Number.isFinite(e) ? "" : String(Number(e.toPrecision(12)));
}
function f_(e, t, a) {
  return t != null && e < t || a != null && e > a;
}
function __(e, t, a, r, s, o) {
  let l = e == null ? s != null ? s : 0 : Lr(e + a * t, Math.max(r, $n(t)));
  return s != null && l < s && (l = s), o != null && l > o && (l = o), l;
}
const p_ = 2500;
function y_({
  value: e,
  onChange: t,
  decimals: a = 1,
  min: r,
  max: s,
  step: o,
  unit: l,
  disabled: c,
  label: i,
  id: m,
  "aria-describedby": u,
  "aria-invalid": f,
  "aria-required": y,
  width: _,
  onEnter: p,
  onInvalidChange: d,
  placeholder: b,
  className: N = ""
}) {
  const [w, k] = D(() => Pt(e)), [x, E] = D(!1), [h, g] = D(null), [$, A] = D(!1), M = L(null), T = L(w);
  T.current = w, Z(() => {
    const v = Zt(T.current), O = v.kind === "num" ? v.value : v.kind === "empty" ? null : void 0;
    O !== void 0 && O === (e != null ? e : null) || k(Pt(e));
  }, [e]), Z(() => () => {
    M.current && clearTimeout(M.current);
  }, []);
  const I = Zt(w), q = I.kind === "bad" || I.kind === "partial";
  Z(() => {
    q || A(!1);
  }, [q]);
  const P = L(d);
  P.current = d, Z(() => {
    var v;
    (v = P.current) == null || v.call(P, q);
  }, [q]), Z(() => () => {
    var v;
    (v = P.current) == null || v.call(P, !1);
  }, []);
  const G = (v) => {
    M.current && clearTimeout(M.current), g(v), M.current = setTimeout(() => g(null), p_);
  }, K = (v) => {
    k(v);
    const O = Zt(v);
    O.kind === "empty" ? t(null) : O.kind === "num" && t(O.value);
  }, j = () => {
    const v = Zt(w);
    if (v.kind !== "num") return;
    if ($n(v.value) > a) {
      const V = Lr(v.value, a);
      k(Pt(V)), t(V), G(`반올림했습니다 → ${Pt(V)}`);
      return;
    }
    const O = Pt(v.value);
    O !== w && k(O);
  }, te = (v) => {
    if (!v.nativeEvent.isComposing) {
      if (v.key === "Enter") {
        if (q) {
          A(!0);
          return;
        }
        j(), p == null || p();
        return;
      }
      if (o && (v.key === "ArrowUp" || v.key === "ArrowDown")) {
        v.preventDefault();
        const O = Zt(w), V = O.kind === "num" ? O.value : O.kind === "empty" ? null : e, Q = __(V, o, v.key === "ArrowUp" ? 1 : -1, a, r, s);
        k(Pt(Q)), t(Q);
      }
    }
  }, ne = I.kind === "bad" || I.kind === "partial" && (!x || $) || I.kind === "num" && f_(I.value, r, s);
  return /* @__PURE__ */ n.createElement("span", { className: [Et.qty, N].filter(Boolean).join(" ") }, /* @__PURE__ */ n.createElement(
    "input",
    {
      type: "text",
      inputMode: "decimal",
      id: m,
      className: [Et.qtyInput, ne ? Et.invalid : ""].filter(Boolean).join(" "),
      style: _ != null ? { width: _, maxWidth: "none" } : void 0,
      value: w,
      placeholder: b,
      disabled: c,
      "aria-label": i,
      "aria-describedby": u,
      "aria-invalid": f != null ? f : ne || void 0,
      "aria-required": y,
      onChange: (v) => K(v.target.value),
      onFocus: () => E(!0),
      onBlur: () => {
        E(!1), j();
      },
      onKeyDown: te
    }
  ), l && /* @__PURE__ */ n.createElement("span", { className: Et.unit }, l), (I.kind === "bad" || I.kind === "partial" && (!x || $)) && /* @__PURE__ */ n.createElement("span", { className: Et.qtyErr, role: "alert" }, "숫자로 입력하세요"), /* @__PURE__ */ n.createElement("span", { className: Et.note, role: "status", "aria-live": "polite" }, h));
}
y_.axeFormControl = !0;
function b_(e, t) {
  if (e === t || e == null && t == null) return !0;
  if (e == null || t == null) return !1;
  if (typeof e == "object" && typeof t == "object")
    try {
      return JSON.stringify(e) === JSON.stringify(t);
    } catch {
      return !1;
    }
  return typeof e == "number" && typeof t == "number" && Number.isNaN(e) && Number.isNaN(t);
}
function E_(e, t) {
  var s;
  if (e === t) return [];
  if (e === null || t === null) return e === null && t === null ? [] : Object.keys((s = e != null ? e : t) != null ? s : {});
  const a = /* @__PURE__ */ new Set([...Object.keys(e), ...Object.keys(t)]), r = [];
  return a.forEach((o) => {
    b_(e[o], t[o]) || r.push(o);
  }), r;
}
function h_(e, t) {
  return e === null || t === null ? e === t : E_(e, t).length === 0;
}
function Hv() {
  const [e, t] = D(null), [a, r] = D(!1), [s, o] = D(null), l = we(() => a || !h_(s, e), [a, s, e]), c = oe((_) => {
    t((p) => p === null ? p : { ...p, ..._ });
  }, []), i = oe((_, p) => {
    t((d) => d === null ? d : { ...d, [_]: p });
  }, []), m = L(null), u = oe((_) => {
    m.current = _, t(_), o(_), r(!1);
  }, []), f = oe((_) => {
    m.current = _, t(_), o(_), r(!0);
  }, []), y = oe(() => t(m.current), []);
  return we(
    () => ({ draft: e, isNew: a, dirty: l, set: i, patch: c, load: u, start: f, reset: y, snapshot: s }),
    [e, a, l, i, c, u, f, y, s]
  );
}
function Kv() {
  const e = L(!1), [t, a] = D(!1), r = oe(async (s) => {
    if (!e.current) {
      e.current = !0, a(!0);
      try {
        await s();
      } finally {
        e.current = !1, a(!1);
      }
    }
  }, []);
  return [t, r];
}
const g_ = "_panel_1w7xx_2", v_ = "_band_1w7xx_7", k_ = "_chev_1w7xx_11", w_ = "_title_1w7xx_17", N_ = "_note_1w7xx_19", $_ = "_chip_1w7xx_21", x_ = "_other_1w7xx_32", D_ = "_reset_1w7xx_33", A_ = "_form_1w7xx_42", rt = {
  panel: g_,
  band: v_,
  chev: k_,
  title: w_,
  note: N_,
  chip: $_,
  other: x_,
  reset: D_,
  form: A_
};
function Uv({
  chips: e,
  onReset: t,
  open: a,
  onToggle: r,
  toggleLabel: s = "상세검색",
  title: o = "적용된 조건",
  note: l,
  children: c,
  hideWhenEmpty: i,
  ariaLabel: m = "상세검색",
  className: u = ""
}) {
  const f = L(null);
  if (i && !a && e.length === 0) return null;
  const y = (p, d = 0) => {
    var x, E, h;
    const b = (x = document.querySelector(`section[aria-label="${CSS.escape(m)}"]`)) != null ? x : f.current, N = b == null ? void 0 : b.querySelectorAll("button[data-chip-clear]"), w = (h = N && ((E = N[p]) != null ? E : N[p - 1])) != null ? h : b == null ? void 0 : b.querySelector("button[aria-expanded]"), k = !document.activeElement || document.activeElement === document.body;
    w && w !== document.activeElement && (d === 0 || k) && w.focus(), d < 4 && setTimeout(() => y(p, d + 1), 250);
  }, _ = (p) => {
    e[p].onClear(), requestAnimationFrame(() => y(p));
  };
  return /* @__PURE__ */ n.createElement("section", { className: [rt.panel, u].filter(Boolean).join(" "), "aria-label": m }, /* @__PURE__ */ n.createElement("div", { className: rt.band, ref: f }, r && /* @__PURE__ */ n.createElement("button", { type: "button", className: rt.chev, "aria-expanded": !!a, onClick: r }, /* @__PURE__ */ n.createElement("span", { "aria-hidden": "true" }, a ? "⌃" : "⌄"), " ", s), o !== null && /* @__PURE__ */ n.createElement("span", { className: rt.title, "aria-live": "polite" }, o, " ", /* @__PURE__ */ n.createElement("b", null, e.length), "개"), e.map((p, d) => {
    var b;
    return /* @__PURE__ */ n.createElement("span", { key: p.key, className: [rt.chip, p.tone === "other" ? rt.other : ""].filter(Boolean).join(" ") }, p.text, /* @__PURE__ */ n.createElement(
      "button",
      {
        type: "button",
        "data-chip-clear": !0,
        "aria-label": `${(b = p.label) != null ? b : typeof p.text == "string" ? p.text : "조건"} 해제`,
        onClick: () => _(d)
      },
      "✕"
    ));
  }), t && e.length > 0 && /* @__PURE__ */ n.createElement("button", { type: "button", className: rt.reset, onClick: () => {
    t(), requestAnimationFrame(() => y(0));
  } }, "초기화"), l && /* @__PURE__ */ n.createElement("span", { className: rt.note }, l)), a && c && /* @__PURE__ */ n.createElement("div", { className: rt.form }, c));
}
const C_ = "_zone_1y6sp_2", S_ = "_drag_1y6sp_8", M_ = "_busy_1y6sp_9", T_ = "_attached_1y6sp_10", q_ = "_left_1y6sp_12", B_ = "_icon_1y6sp_13", L_ = "_title_1y6sp_18", j_ = "_desc_1y6sp_19", R_ = "_right_1y6sp_20", I_ = "_count_1y6sp_21", O_ = "_pick_1y6sp_22", We = {
  zone: C_,
  drag: S_,
  busy: M_,
  attached: T_,
  left: q_,
  icon: B_,
  title: L_,
  desc: j_,
  right: R_,
  count: I_,
  pick: O_
};
function P_({
  onFiles: e,
  title: t = "파일 업로드",
  desc: a,
  countText: r,
  accept: s,
  multiple: o = !0,
  disabled: l,
  attached: c,
  pickLabel: i = "파일 선택",
  className: m = ""
}) {
  const u = L(null), [f, y] = D(!1), _ = (p) => {
    !p || p.length === 0 || l || e(Array.from(p));
  };
  return /* @__PURE__ */ n.createElement(
    "div",
    {
      className: [We.zone, f ? We.drag : "", l ? We.busy : "", c ? We.attached : "", m].filter(Boolean).join(" "),
      onClick: () => {
        var p;
        l || (p = u.current) == null || p.click();
      },
      onDragOver: (p) => {
        p.preventDefault(), l || y(!0);
      },
      onDragLeave: () => y(!1),
      onDrop: (p) => {
        p.preventDefault(), y(!1), _(p.dataTransfer.files);
      }
    },
    /* @__PURE__ */ n.createElement("div", { className: We.left }, /* @__PURE__ */ n.createElement("div", { className: We.icon, "aria-hidden": "true" }, /* @__PURE__ */ n.createElement("svg", { width: "22", height: "22", viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "round" }, /* @__PURE__ */ n.createElement("polyline", { points: "16 16 12 12 8 16" }), /* @__PURE__ */ n.createElement("line", { x1: "12", y1: "12", x2: "12", y2: "21" }), /* @__PURE__ */ n.createElement("path", { d: "M20.39 18.39A5 5 0 0 0 18 9h-1.26A8 8 0 1 0 3 16.3" }))), /* @__PURE__ */ n.createElement("div", null, /* @__PURE__ */ n.createElement("div", { className: We.title }, t), a && /* @__PURE__ */ n.createElement("div", { className: We.desc }, a))),
    /* @__PURE__ */ n.createElement("div", { className: We.right }, r && /* @__PURE__ */ n.createElement("span", { className: We.count, "aria-live": "polite" }, r), /* @__PURE__ */ n.createElement(
      "button",
      {
        type: "button",
        className: We.pick,
        disabled: l,
        onClick: (p) => {
          var d;
          p.stopPropagation(), (d = u.current) == null || d.click();
        }
      },
      i
    ), /* @__PURE__ */ n.createElement(
      "input",
      {
        ref: u,
        type: "file",
        accept: s,
        multiple: o,
        hidden: !0,
        onChange: (p) => {
          _(p.target.files), p.target.value = "";
        }
      }
    ))
  );
}
function X_(e, t) {
  var o, l;
  const a = (o = e.headers.get("Content-Disposition")) != null ? o : "", r = /filename\*=UTF-8''([^;]+)/i.exec(a);
  if (r)
    try {
      return decodeURIComponent(r[1]);
    } catch {
    }
  const s = /filename="?([^";]+)"?/i.exec(a);
  return (l = s == null ? void 0 : s[1]) != null ? l : t;
}
function jr(e, t) {
  const a = URL.createObjectURL(e), r = document.createElement("a");
  r.href = a, r.download = t, document.body.appendChild(r), r.click(), r.remove(), setTimeout(() => URL.revokeObjectURL(a), 1e3);
}
async function Gv(e, t, a) {
  jr(await e.blob(), a != null ? a : X_(e, t));
}
const z_ = /^([△▲\-−]?)\s*[¥￥]?\s*(\d{1,3}(?:,\d{3})+|\d+)(\.\d+)?$/, F_ = /^\(\s*[¥￥]?\s*(\d{1,3}(?:,\d{3})+|\d+)(\.\d+)?\s*\)$/;
function Rr(e, t = {}) {
  var s, o;
  const a = e.trim();
  if (t.parenNegative) {
    const l = F_.exec(a);
    if (l) return `-${l[1].replace(/,/g, "")}${(s = l[2]) != null ? s : ""}`;
  }
  const r = z_.exec(a);
  return r ? (r[1] ? "-" : "") + r[2].replace(/,/g, "") + ((o = r[3]) != null ? o : "") : null;
}
function Wt(e) {
  return e === "-" || e === "+" ? e : /^[=+\-@\t\r]/.test(e) ? `'${e}` : e;
}
function W_(e, t = {}) {
  const a = [];
  t.meta && t.meta.length && (t.meta.forEach((l) => a.push(l.map((c) => bn(Wt(String(c != null ? c : "")))).join(","))), a.push(""));
  const r = a.length;
  let s = null;
  const o = (l) => {
    var i;
    const c = H_(l, e);
    !c || c === s || (s = c, a.length > r && a.push(""), a.push(bn(Wt((i = c.getAttribute("data-csv-title")) != null ? i : ""))));
  };
  return e.querySelectorAll("table, [data-csv-kv]").forEach((l) => {
    var _;
    if (l.tagName !== "TABLE") {
      if ((_ = l.parentElement) != null && _.closest("table") && e.contains(l.parentElement.closest("table"))) return;
      const p = K_(l, t);
      if (!p) return;
      o(l), a.push(p.map(bn).join(","));
      return;
    }
    const c = l;
    o(c);
    const i = c.querySelector("[data-tree-depth]"), m = i ? i.closest("td, th") : null, u = m ? m.cellIndex : -1, f = u >= 0 && !!c.querySelector("[data-csv-path]"), y = [];
    Array.from(c.rows).forEach((p) => {
      if (p.hasAttribute("data-state") || p.getAttribute("aria-hidden") === "true") return;
      const d = [];
      let b = 0;
      const N = () => {
        for (; y[b] && y[b].n > 0; )
          y[b].n -= 1, y[b].skip || d.push(""), b += 1;
      };
      Array.from(p.cells).forEach((w) => {
        var g, $;
        N();
        const k = G_(w), x = k ? "" : Y_(w, t), E = Math.max(1, w.colSpan || 1), h = Math.max(1, w.rowSpan || 1);
        for (let A = 0; A < E; A += 1)
          k || d.push(A === 0 ? x : ""), y[b] = { n: h - 1, skip: k }, b += 1;
        if (u >= 0 && w.cellIndex === u) {
          const A = w.querySelector("[data-tree-depth]");
          A ? (d.push(String(Number(A.getAttribute("data-tree-depth")) + 1)), f && d.push(Wt((g = A.getAttribute("data-csv-path")) != null ? g : ""))) : (($ = p.parentElement) == null ? void 0 : $.tagName) === "THEAD" ? (d.push("단계"), f && d.push("상위 경로")) : (d.push(""), f && d.push(""));
        }
      }), N(), d.some((w) => w !== "") && a.push(d.map(bn).join(","));
    });
  }), a.join(`\r
`);
}
function H_(e, t) {
  let a = e.parentElement;
  for (; a; ) {
    if (a.hasAttribute("data-csv-title") && a.getAttribute("data-csv-title")) return a;
    if (a === t) return null;
    a = a.parentElement;
  }
  return null;
}
function K_(e, t) {
  var m, u;
  const a = e.querySelector("[data-csv-k]"), r = e.querySelector("[data-csv-v]"), s = e.querySelector("[data-csv-unit]"), o = s ? yn(s) : "";
  let c = ((m = e.getAttribute("data-csv-kv")) != null ? m : "") || (a ? yn(a) : "");
  if (!c) return null;
  o && (c = `${c} (${o})`);
  let i;
  if (r) {
    const f = r.cloneNode(!0);
    f.querySelectorAll("[data-csv-unit], [data-csv-skip]").forEach((y) => y.remove()), i = yn(f);
  } else {
    const f = e.cloneNode(!0);
    f.querySelectorAll("[data-csv-k], [data-csv-unit], [data-csv-skip]").forEach((y) => y.remove()), i = yn(f);
  }
  return (i === "—" || i === "-" || i === "–") && (i = ""), [Wt(c), (u = Rr(i, t)) != null ? u : Wt(i)];
}
function yn(e) {
  var t, a;
  return ((a = (t = e.innerText) != null ? t : e.textContent) != null ? a : "").replace(/\s+/g, " ").trim();
}
function U_(e, t) {
  const a = t.toLowerCase().endsWith(".csv") ? t : `${t}.csv`;
  jr(new Blob(["\uFEFF", e], { type: "text/csv;charset=utf-8" }), a);
}
function G_(e) {
  var t;
  return ((t = e.textContent) != null ? t : "").trim() !== "" ? !1 : !!e.querySelector("input[type=checkbox], input[type=radio]");
}
function Y_(e, t) {
  var s, o, l;
  let a = e;
  e.querySelector("[data-csv-skip], [data-csv-sep]") && (a = e.cloneNode(!0), a.querySelectorAll("[data-csv-skip]").forEach((c) => c.remove()), a.querySelectorAll("[data-csv-sep]").forEach((c) => c.after(" ")));
  let r = ((o = (s = a.innerText) != null ? s : a.textContent) != null ? o : "").replace(/\s+/g, " ").trim();
  if (!r && a.textContent && (r = a.textContent.replace(/\s+/g, " ").trim()), !r) {
    const c = e.querySelector("input:not([type=checkbox]):not([type=radio]), select, textarea");
    c && (r = c.value.trim());
  }
  return r === "—" || r === "-" || r === "–" ? "" : (l = Rr(r, t)) != null ? l : Wt(r);
}
function bn(e) {
  return /[",\r\n]/.test(e) ? `"${e.replace(/"/g, '""')}"` : e;
}
const V_ = () => new Promise((e) => requestAnimationFrame(() => requestAnimationFrame(() => e())));
function Yv({ target: e, fileName: t, label: a = "CSV 내려받기", disabled: r, parenNegative: s, prepare: o, meta: l }) {
  return /* @__PURE__ */ n.createElement(
    Vn,
    {
      label: a,
      disabled: r,
      style: { width: "auto", padding: "0 9px", gap: 4, border: "1px solid var(--axe-border, #d5dde9)", fontSize: 11, fontWeight: 700 },
      onClick: async () => {
        let c;
        o && (c = await o(), await V_());
        try {
          const i = e.current;
          if (!i) return;
          U_(W_(i, { parenNegative: s, meta: l == null ? void 0 : l() }), typeof t == "function" ? t() : t);
        } finally {
          typeof c == "function" && c();
        }
      }
    },
    /* @__PURE__ */ n.createElement(gn, { name: "download", size: 14 }),
    "CSV"
  );
}
const Q_ = "_root_kpw7f_1", J_ = "_guide_kpw7f_2", Z_ = "_tpl_kpw7f_3", Fn = {
  root: Q_,
  guide: J_,
  tpl: Z_
};
function Vv({
  guide: e,
  onTemplate: t,
  templateLabel: a = "빈 양식 받기",
  file: r,
  onFile: s,
  maxBytes: o,
  onTooBig: l,
  fileInfo: c,
  accept: i = ".csv,text/csv",
  label: m = "CSV 파일",
  pickLabel: u = "파일 선택",
  busyReason: f,
  className: y = ""
}) {
  const _ = (d) => {
    var N;
    const b = (N = d[0]) != null ? N : null;
    if (b && o !== void 0 && b.size > o) {
      l == null || l(b);
      return;
    }
    s(b);
  }, p = r ? `${r.name}${c != null ? c : r.size !== void 0 ? ` · ${(r.size / 1024).toFixed(1)}KB` : ""}` : void 0;
  return /* @__PURE__ */ n.createElement("div", { className: [Fn.root, y].filter(Boolean).join(" ") }, /* @__PURE__ */ n.createElement(Ef, { tone: "info" }, /* @__PURE__ */ n.createElement("div", { className: Fn.guide }, e), t && /* @__PURE__ */ n.createElement("div", { className: Fn.tpl }, /* @__PURE__ */ n.createElement(mt, { size: "sm", onClick: t }, a))), /* @__PURE__ */ n.createElement(
    P_,
    {
      title: m,
      desc: r ? void 0 : "선택된 파일 없음",
      countText: p,
      accept: i,
      multiple: !1,
      disabled: !!f,
      pickLabel: u,
      onFiles: _
    }
  ));
}
const ep = { info: "info", ok: "ok", warn: "warn", danger: "off", muted: "muted", off: "off" };
function Qv({ map: e, value: t, empty: a = "-" }) {
  if (t == null) return /* @__PURE__ */ n.createElement(n.Fragment, null, a);
  const r = e[t];
  return r ? /* @__PURE__ */ n.createElement(Ra, { tone: ep[r.tone] }, r.label) : /* @__PURE__ */ n.createElement(Ra, null, String(t));
}
const za = "axerp-form-modal";
function Jv({
  title: e,
  onClose: t,
  onSubmit: a,
  busy: r = !1,
  error: s,
  submitLabel: o,
  submitBlocked: l,
  wide: c,
  labels: i,
  formClassName: m,
  children: u
}) {
  var y, _, p;
  const f = (d) => {
    d.preventDefault(), !r && !l && a();
  };
  return /* @__PURE__ */ n.createElement(
    Bn,
    {
      title: e,
      onClose: t,
      wide: c,
      closeOnBackdrop: !1,
      error: s,
      footer: /* @__PURE__ */ n.createElement(n.Fragment, null, /* @__PURE__ */ n.createElement(mt, { onClick: t, disabled: r }, (y = i == null ? void 0 : i.cancel) != null ? y : "취소"), /* @__PURE__ */ n.createElement(mt, { type: "submit", form: za, variant: "primary", blockedReason: r ? (_ = i == null ? void 0 : i.saving) != null ? _ : "저장 중입니다" : l }, (p = o != null ? o : i == null ? void 0 : i.save) != null ? p : "저장"))
    },
    /* @__PURE__ */ n.createElement("form", { id: za, className: m, onSubmit: f, noValidate: !0 }, u)
  );
}
const tp = { left: "axe-l", center: "axe-c", right: "axe-r" };
function Fa(e) {
  const t = e.currentTarget;
  t.scrollWidth > t.clientWidth + 1 && t.textContent ? t.title = t.textContent : t.removeAttribute("title");
}
const Wa = (e) => {
  var t;
  return tp[(t = e.align) != null ? t : e.num ? "right" : "left"];
};
function Zv({
  columns: e,
  rows: t,
  rowKey: a,
  loading: r = !1,
  error: s = null,
  emptyText: o = "표시할 행이 없습니다",
  selectedKey: l,
  onRowClick: c,
  rowClassName: i,
  title: m,
  grow: u = !1,
  growClassName: f,
  pagination: y
}) {
  const _ = t != null ? t : [];
  return /* @__PURE__ */ n.createElement(ac, { grow: u, className: u ? f : void 0, cols: e.map((p) => p.width), busy: r, title: m, pagination: y }, /* @__PURE__ */ n.createElement("thead", null, /* @__PURE__ */ n.createElement("tr", null, e.map((p) => /* @__PURE__ */ n.createElement("th", { key: p.key, className: Wa(p) === "axe-r" ? "axe-r" : "axe-c", onMouseEnter: Fa }, p.header)))), /* @__PURE__ */ n.createElement("tbody", null, /* @__PURE__ */ n.createElement(
    Ec,
    {
      colSpan: e.length,
      loading: r,
      error: s,
      count: t ? _.length : null,
      empty: o,
      idle: null
    }
  ), _.map((p, d) => {
    var w;
    const b = a(p), N = [c ? "axe-clickable" : "", l === b ? "axe-sel" : "", (w = i == null ? void 0 : i(p)) != null ? w : ""].filter(Boolean).join(" ");
    return /* @__PURE__ */ n.createElement(
      "tr",
      {
        key: b,
        className: N || void 0,
        onClick: c ? () => c(p) : void 0,
        ...c ? hc(() => c(p), l === void 0 ? void 0 : l === b) : {}
      },
      e.map((k) => /* @__PURE__ */ n.createElement("td", { key: k.key, className: Wa(k), onMouseEnter: Fa }, k.render(p, d)))
    );
  })));
}
function e0({ title: e, info: t, badge: a, notice: r, actions: s, minWidth: o, bodyClassName: l, children: c }) {
  return /* @__PURE__ */ n.createElement(ls, { style: { height: "100%" }, minWidth: o }, /* @__PURE__ */ n.createElement(Cs, { title: e, info: t, badge: a, notice: r }, s), /* @__PURE__ */ n.createElement("div", { className: l }, c));
}
const np = "_card_1adld_1", ap = "_sub_1adld_2", rp = "_state_1adld_3", sp = "_list_1adld_7", op = "_row_1adld_8", lp = "_warn_1adld_20", cp = "_danger_1adld_21", xt = {
  card: np,
  sub: ap,
  state: rp,
  list: sp,
  row: op,
  warn: lp,
  danger: cp
};
function t0({
  title: e,
  sub: t,
  trailing: a,
  state: r = "ready",
  error: s,
  onRetry: o,
  loadingText: l = "불러오는 중…",
  rows: c,
  className: i = ""
}) {
  return /* @__PURE__ */ n.createElement(
    vr,
    {
      flush: !0,
      className: [xt.card, i].filter(Boolean).join(" "),
      title: /* @__PURE__ */ n.createElement(n.Fragment, null, e, t ? /* @__PURE__ */ n.createElement("small", { className: xt.sub }, t) : null),
      trailing: a
    },
    r === "loading" && /* @__PURE__ */ n.createElement("div", { className: xt.state }, l),
    r === "error" && /* @__PURE__ */ n.createElement("div", { className: xt.state }, /* @__PURE__ */ n.createElement(Br, null, s != null ? s : "불러오지 못했습니다"), o && /* @__PURE__ */ n.createElement(la, { onClick: o }, "다시 시도")),
    r === "ready" && /* @__PURE__ */ n.createElement("div", { className: xt.list }, c.map((m, u) => {
      var _, p;
      const f = [xt.row, m.tone ? xt[m.tone] : ""].filter(Boolean).join(" "), y = /* @__PURE__ */ n.createElement(n.Fragment, null, /* @__PURE__ */ n.createElement("span", null, m.label), /* @__PURE__ */ n.createElement("strong", null, m.value, m.unit ? /* @__PURE__ */ n.createElement("small", null, m.unit) : null));
      return m.onClick ? /* @__PURE__ */ n.createElement("button", { type: "button", key: (_ = m.key) != null ? _ : u, className: f, onClick: m.onClick }, y) : /* @__PURE__ */ n.createElement("div", { key: (p = m.key) != null ? p : u, className: f }, y);
    }))
  );
}
function ip(e, t, a, r, s) {
  const o = Math.max(0, Math.floor(e));
  if (o === 0) return 1;
  const l = Math.max(1, Math.min(o, s != null && s > 0 ? Math.floor(s) : o)), c = Math.max(1, Math.min(l, Math.floor((t + r) / (a + r)))), i = Math.ceil(o / c);
  return Math.ceil(o / i);
}
const up = "_group_16rha_1", mp = "_tile_16rha_2", dp = "_click_16rha_9", fp = "_ok_16rha_12", _p = "_warn_16rha_13", pp = "_danger_16rha_14", yp = "_info_16rha_15", bp = "_accent_16rha_16", Ep = "_muted_16rha_17", hp = "_label_16rha_18", gp = "_value_16rha_20", vp = "_desc_16rha_25", At = {
  group: up,
  tile: mp,
  click: dp,
  ok: fp,
  warn: _p,
  danger: pp,
  info: yp,
  accent: bp,
  muted: Ep,
  label: hp,
  value: gp,
  desc: vp
};
function n0({
  label: e,
  value: t,
  unit: a,
  desc: r,
  tone: s = "info",
  onClick: o,
  className: l = ""
}) {
  const c = [At.tile, At[s], o ? At.click : "", l].filter(Boolean).join(" "), i = /* @__PURE__ */ n.createElement(n.Fragment, null, /* @__PURE__ */ n.createElement("span", { className: At.label, "data-csv-k": "" }, /* @__PURE__ */ n.createElement("i", { "aria-hidden": "true" }), e), /* @__PURE__ */ n.createElement("span", { className: At.value, "data-csv-v": "" }, t, a ? /* @__PURE__ */ n.createElement("small", { "data-csv-unit": "" }, a) : null), r ? /* @__PURE__ */ n.createElement("span", { className: At.desc, title: typeof r == "string" ? r : void 0 }, r) : null);
  return o ? /* @__PURE__ */ n.createElement("button", { type: "button", className: c, onClick: o, "data-csv-kv": "" }, i) : /* @__PURE__ */ n.createElement("div", { className: c, "data-csv-kv": "" }, i);
}
const kp = 150, wp = 12, Np = 8;
function a0({ children: e, columns: t, className: a = "" }) {
  const r = L(null), s = Yn.toArray(e).filter(ln).length, o = t != null || s <= Np, [l, c] = D(null);
  Be(() => {
    const u = r.current;
    if (!o || !u || (c(u.clientWidth), typeof ResizeObserver == "undefined")) return;
    const f = new ResizeObserver(() => c(u.clientWidth));
    return f.observe(u), () => f.disconnect();
  }, [o]);
  const i = o ? ip(s, l != null ? l : Number.MAX_SAFE_INTEGER, kp, wp, t) : 0, m = o ? { gridTemplateColumns: `repeat(${i}, minmax(0, 1fr))` } : void 0;
  return /* @__PURE__ */ n.createElement("div", { ref: r, className: [At.group, a].filter(Boolean).join(" "), style: m }, e);
}
const $p = "_card_1lav2_1", xp = "_n_1lav2_2", Dp = "_list_1lav2_7", Ap = "_row_1lav2_8", Cp = "_go_1lav2_15", Sp = "_name_1lav2_16", Mp = "_empty_1lav2_17", Tp = "_star_1lav2_18", qp = "_clear_1lav2_27", Ve = {
  card: $p,
  n: xp,
  list: Dp,
  row: Ap,
  go: Cp,
  name: Sp,
  empty: Mp,
  star: Tp,
  clear: qp
};
function r0({
  mine: e,
  recent: t,
  onOpen: a,
  onClearRecent: r,
  mineHint: s = "메뉴 목록에서 ☆ 를 누르면 여기에 담깁니다",
  className: o = ""
}) {
  const [l, c] = D("mine"), i = l === "mine" ? e : t;
  return /* @__PURE__ */ n.createElement(
    vr,
    {
      flush: !0,
      className: [Ve.card, o].filter(Boolean).join(" "),
      title: /* @__PURE__ */ n.createElement(
        fr,
        {
          variant: "segmented",
          "aria-label": "빠른 메뉴",
          value: l,
          onChange: (m) => c(m),
          items: [
            { key: "mine", label: /* @__PURE__ */ n.createElement(n.Fragment, null, "마이메뉴", e.length > 0 && /* @__PURE__ */ n.createElement("em", { className: Ve.n }, e.length)) },
            { key: "recent", label: /* @__PURE__ */ n.createElement(n.Fragment, null, "최근 사용", t.length > 0 && /* @__PURE__ */ n.createElement("em", { className: Ve.n }, t.length)) }
          ]
        }
      ),
      trailing: l === "recent" && t.length > 0 && r ? /* @__PURE__ */ n.createElement(la, { className: Ve.clear, onClick: r }, "목록 비우기") : void 0
    },
    i.length > 0 ? /* @__PURE__ */ n.createElement("ul", { className: Ve.list }, i.map((m) => /* @__PURE__ */ n.createElement("li", { key: m.path }, /* @__PURE__ */ n.createElement("button", { type: "button", className: Ve.row, onClick: () => a(m) }, /* @__PURE__ */ n.createElement("span", { "aria-hidden": "true", className: Ve.go }, "↗"), /* @__PURE__ */ n.createElement("span", { className: Ve.name }, m.label))))) : /* @__PURE__ */ n.createElement("div", { className: Ve.empty }, /* @__PURE__ */ n.createElement("span", { "aria-hidden": "true", className: Ve.star }, "★"), /* @__PURE__ */ n.createElement("strong", null, l === "mine" ? "아직 추가한 메뉴가 없습니다" : "최근 사용한 메뉴가 없습니다"), /* @__PURE__ */ n.createElement("p", null, l === "mine" ? s : "메뉴를 실행하면 최근 사용 목록에 표시됩니다"))
  );
}
function Ha(e) {
  var t;
  try {
    const a = JSON.parse((t = window.localStorage.getItem(e)) != null ? t : "[]");
    return Array.isArray(a) ? a.filter((r) => r && typeof r.path == "string" && typeof r.label == "string") : [];
  } catch {
    return [];
  }
}
function Wn(e, t) {
  try {
    window.localStorage.setItem(e, JSON.stringify(t));
  } catch {
  }
}
function s0({ mineKey: e, recentKey: t, recentMax: a = 6 }) {
  const [r, s] = D(() => Ha(e)), [o, l] = D(() => Ha(t)), c = oe((f) => r.some((y) => y.path === f), [r]), i = oe((f) => s((y) => {
    const _ = y.some((p) => p.path === f.path) ? y.filter((p) => p.path !== f.path) : [...y, f];
    return Wn(e, _), _;
  }), [e]), m = oe((f) => l((y) => {
    const _ = [f, ...y.filter((p) => p.path !== f.path)].slice(0, a);
    return Wn(t, _), _;
  }), [t, a]), u = oe(() => {
    l([]), Wn(t, []);
  }, [t]);
  return { mine: r, recent: o, isMine: c, toggleMine: i, remember: m, clearRecent: u };
}
const Bp = "_banner_7tqhk_2", Lp = "_heading_7tqhk_7", jp = "_sparkleBox_7tqhk_8", Rp = "_eyebrow_7tqhk_12", Ip = "_headline_7tqhk_13", Op = "_desc_7tqhk_15", Pp = "_err_7tqhk_16", Xp = "_chips_7tqhk_18", zp = "_footer_7tqhk_28", Fp = "_kicker_7tqhk_35", Wp = "_list_7tqhk_36", Hp = "_row_7tqhk_37", Kp = "_icon_7tqhk_39", Up = "_text_7tqhk_40", Gp = "_cap_7tqhk_41", Yp = "_body_7tqhk_43", Vp = "_reason_7tqhk_44", Qp = "_empty_7tqhk_45", be = {
  banner: Bp,
  heading: Lp,
  sparkleBox: jp,
  eyebrow: Rp,
  headline: Ip,
  desc: Op,
  err: Pp,
  chips: Xp,
  footer: zp,
  kicker: Fp,
  list: Wp,
  row: Hp,
  icon: Kp,
  text: Up,
  cap: Gp,
  body: Yp,
  reason: Vp,
  empty: Qp
};
function Ka({ size: e = 18 }) {
  return /* @__PURE__ */ n.createElement("svg", { width: e, height: e, viewBox: "0 0 24 24", fill: "none", "aria-hidden": "true" }, /* @__PURE__ */ n.createElement("path", { d: "M12 2.8c.72 5.16 2.85 7.3 8.02 8.02-5.17.72-7.3 2.86-8.02 8.02-.72-5.16-2.85-7.3-8.02-8.02C9.15 10.1 11.28 7.96 12 2.8Z", fill: "currentColor" }));
}
function o0({
  eyebrow: e,
  headline: t,
  desc: a,
  error: r,
  groups: s,
  maxChips: o = 4,
  onOpen: l,
  note: c,
  noteError: i,
  allLabel: m = "전체 업무 제안 보기",
  allDisabled: u,
  className: f = ""
}) {
  const y = s.slice(0, o), _ = s.length - y.length;
  return /* @__PURE__ */ n.createElement("section", { className: [be.banner, f].filter(Boolean).join(" ") }, /* @__PURE__ */ n.createElement("div", { className: be.heading }, /* @__PURE__ */ n.createElement("span", { className: be.sparkleBox }, /* @__PURE__ */ n.createElement(Ka, { size: 22 })), /* @__PURE__ */ n.createElement("div", null, /* @__PURE__ */ n.createElement("div", { className: be.eyebrow }, /* @__PURE__ */ n.createElement(Ka, { size: 11 }), " ", e), /* @__PURE__ */ n.createElement("h2", { className: be.headline }, t), a ? /* @__PURE__ */ n.createElement("p", { className: [be.desc, r ? be.err : ""].filter(Boolean).join(" ") }, a) : null)), s.length > 0 && /* @__PURE__ */ n.createElement("div", { className: be.chips }, y.map((p) => /* @__PURE__ */ n.createElement("button", { type: "button", key: p.key, title: p.label, onClick: () => l(p.key) }, /* @__PURE__ */ n.createElement("i", { style: p.color ? { background: p.color } : void 0, "aria-hidden": "true" }), p.label, " ", /* @__PURE__ */ n.createElement("strong", { style: p.color ? { color: p.color } : void 0 }, p.count, "건"))), _ > 0 && /* @__PURE__ */ n.createElement("button", { type: "button", onClick: () => l(null) }, "+", _, "종류 더")), /* @__PURE__ */ n.createElement("div", { className: be.footer }, /* @__PURE__ */ n.createElement(
    "span",
    {
      className: i ? be.err : void 0,
      role: i ? "alert" : void 0
    },
    c
  ), /* @__PURE__ */ n.createElement(la, { onClick: () => l(null), disabled: u }, m, " ", /* @__PURE__ */ n.createElement("span", { "aria-hidden": "true" }, "→"))));
}
function Jp({ items: e, onRun: t, onSkip: a, busy: r, emptyText: s = "남은 제안이 없습니다." }) {
  return e.length === 0 ? /* @__PURE__ */ n.createElement("div", { className: be.empty }, s) : /* @__PURE__ */ n.createElement("ul", { className: be.list }, e.map((o) => {
    var l, c;
    return /* @__PURE__ */ n.createElement("li", { key: o.id, className: be.row }, /* @__PURE__ */ n.createElement("span", { className: be.icon, "aria-hidden": "true" }, (l = o.icon) != null ? l : "💡"), /* @__PURE__ */ n.createElement("div", { className: be.text }, /* @__PURE__ */ n.createElement("div", { className: be.cap }, o.title, o.meta ? /* @__PURE__ */ n.createElement("small", null, " · ", o.meta) : null), /* @__PURE__ */ n.createElement("div", { className: be.body }, o.body), o.reason ? /* @__PURE__ */ n.createElement("div", { className: be.reason }, o.reason) : null), /* @__PURE__ */ n.createElement(mt, { variant: "primary", disabled: r, onClick: () => t(o) }, (c = o.actionLabel) != null ? c : "실행"), /* @__PURE__ */ n.createElement(mt, { disabled: r, onClick: () => a(o) }, "무시"));
  }));
}
function l0({ title: e, kicker: t = "ProActive AI 업무 제안", items: a, onClose: r, onRun: s, onSkip: o }) {
  const l = L(!1), [c, i] = D(!1), [m, u] = D(""), f = async (y) => {
    if (!l.current) {
      l.current = !0, i(!0), u("");
      try {
        await y();
      } catch {
        u("처리하지 못했습니다. 잠시 후 다시 시도하세요.");
      } finally {
        l.current = !1, i(!1);
      }
    }
  };
  return /* @__PURE__ */ n.createElement(
    Bn,
    {
      title: e,
      onClose: r,
      closeOnEsc: !0,
      confirmDiscard: !1,
      headerExtra: /* @__PURE__ */ n.createElement("span", { className: be.kicker }, "✦ ", t),
      error: m,
      footer: /* @__PURE__ */ n.createElement(mt, { onClick: r }, "닫기")
    },
    /* @__PURE__ */ n.createElement(Jp, { items: a, busy: c, onRun: (y) => f(() => s(y)), onSkip: (y) => f(() => o(y)) })
  );
}
const Zp = "_wrap_1wvdc_2", ey = "_header_1wvdc_7", ty = "_iconBox_1wvdc_8", ny = "_headText_1wvdc_12", ay = "_eyebrow_1wvdc_13", ry = "_headline_1wvdc_14", sy = "_headerExtra_1wvdc_16", oy = "_grid_1wvdc_19", ly = "_card_1wvdc_20", cy = "_badge_1wvdc_29", iy = "_toneRed_1wvdc_33", uy = "_toneViolet_1wvdc_34", my = "_toneGreen_1wvdc_35", dy = "_toneBlue_1wvdc_36", fy = "_title_1wvdc_38", _y = "_summary_1wvdc_42", py = "_action_1wvdc_46", yy = "_notice_1wvdc_53", by = "_err_1wvdc_56", _e = {
  wrap: Zp,
  header: ey,
  iconBox: ty,
  headText: ny,
  eyebrow: ay,
  headline: ry,
  headerExtra: sy,
  grid: oy,
  card: ly,
  badge: cy,
  toneRed: iy,
  toneViolet: uy,
  toneGreen: my,
  toneBlue: dy,
  title: fy,
  summary: _y,
  action: py,
  notice: yy,
  err: by
};
function Ua({ size: e = 16 }) {
  return /* @__PURE__ */ n.createElement("svg", { width: e, height: e, viewBox: "0 0 24 24", fill: "none", "aria-hidden": "true" }, /* @__PURE__ */ n.createElement("path", { d: "M12 2.8c.72 5.16 2.85 7.3 8.02 8.02-5.17.72-7.3 2.86-8.02 8.02-.72-5.16-2.85-7.3-8.02-8.02C9.15 10.1 11.28 7.96 12 2.8Z", fill: "currentColor" }));
}
const Ey = {
  red: _e.toneRed,
  violet: _e.toneViolet,
  green: _e.toneGreen,
  blue: _e.toneBlue
};
function c0({
  items: e,
  onOpen: t,
  eyebrow: a = "PROACTIVE AI",
  headline: r = "지금 처리할 수 있는 업무를 발견했습니다",
  error: s,
  loading: o,
  emptyText: l = "지금은 처리할 업무 제안이 없습니다.",
  headerExtra: c,
  className: i = ""
}) {
  return /* @__PURE__ */ n.createElement("section", { className: [_e.wrap, i].filter(Boolean).join(" ") }, /* @__PURE__ */ n.createElement("div", { className: _e.header }, /* @__PURE__ */ n.createElement("span", { className: _e.iconBox }, /* @__PURE__ */ n.createElement(Ua, { size: 18 })), /* @__PURE__ */ n.createElement("div", { className: _e.headText }, /* @__PURE__ */ n.createElement("div", { className: _e.eyebrow }, a), /* @__PURE__ */ n.createElement("h2", { className: _e.headline }, r)), c ? /* @__PURE__ */ n.createElement("div", { className: _e.headerExtra }, c) : null), s ? /* @__PURE__ */ n.createElement("div", { className: _e.notice + " " + _e.err, role: "alert" }, s) : null, e.length === 0 ? s ? null : o ? /* @__PURE__ */ n.createElement("div", { className: _e.notice, role: "status" }, "업무 제안을 확인하고 있습니다.") : /* @__PURE__ */ n.createElement("div", { className: _e.notice }, l) : /* @__PURE__ */ n.createElement("div", { className: _e.grid }, e.map((m) => {
    var u, f;
    return /* @__PURE__ */ n.createElement("button", { type: "button", key: m.id, className: _e.card, onClick: () => t(m) }, /* @__PURE__ */ n.createElement("span", { className: [_e.badge, Ey[(u = m.tone) != null ? u : "violet"]].join(" ") }, /* @__PURE__ */ n.createElement(Ua, { size: 9 }), m.badge), /* @__PURE__ */ n.createElement("span", { className: _e.title }, m.title), m.summary ? /* @__PURE__ */ n.createElement("span", { className: _e.summary, title: typeof m.summary == "string" ? m.summary : void 0 }, m.summary) : null, /* @__PURE__ */ n.createElement("span", { className: _e.action }, (f = m.actionLabel) != null ? f : "상세 보기", " ", /* @__PURE__ */ n.createElement("span", { "aria-hidden": "true" }, "→")));
  })));
}
const hy = "_wrapper_wrch3_1", gy = "_searchIcon_wrch3_18", vy = "_input_wrch3_26", ky = "_clearButton_wrch3_40", wy = "_hint_wrch3_60", en = {
  wrapper: hy,
  searchIcon: gy,
  input: vy,
  clearButton: ky,
  hint: wy
}, Ny = /* @__PURE__ */ n.createElement("svg", { width: "16", height: "16", viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: "1.8", strokeLinecap: "round", strokeLinejoin: "round" }, /* @__PURE__ */ n.createElement("circle", { cx: "11", cy: "11", r: "7" }), /* @__PURE__ */ n.createElement("path", { d: "M21 21l-4.35-4.35" }));
function $y({
  value: e,
  onChange: t,
  placeholder: a,
  hint: r,
  onSubmit: s,
  onClear: o
}) {
  const l = (c) => {
    c.key === "Enter" && (s == null || s());
  };
  return /* @__PURE__ */ n.createElement("div", { className: en.wrapper }, /* @__PURE__ */ n.createElement("span", { className: en.searchIcon }, Ny), /* @__PURE__ */ n.createElement(
    "input",
    {
      type: "text",
      className: en.input,
      value: e,
      placeholder: a,
      onChange: (c) => t(c.target.value),
      onKeyDown: l
    }
  ), o && e.length > 0 && /* @__PURE__ */ n.createElement(
    "button",
    {
      type: "button",
      className: en.clearButton,
      onClick: o,
      "aria-label": "비우기"
    },
    /* @__PURE__ */ n.createElement("svg", { width: "14", height: "14", viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round" }, /* @__PURE__ */ n.createElement("path", { d: "M18 6L6 18" }), /* @__PURE__ */ n.createElement("path", { d: "M6 6l12 12" }))
  ), r && /* @__PURE__ */ n.createElement("span", { className: en.hint }, r));
}
const xy = "_screen_1bsma_1", Dy = "_shell_1bsma_8", Ay = "_command_1bsma_10", Cy = "_body_1bsma_20", Sy = "_overview_1bsma_22", My = "_areaHead_1bsma_25", zt = {
  screen: xy,
  shell: Dy,
  command: Ay,
  body: Cy,
  overview: Sy,
  areaHead: My
};
function i0({ search: e, panel: t, children: a, className: r = "" }) {
  var s;
  return /* @__PURE__ */ n.createElement("main", { className: [zt.screen, r].filter(Boolean).join(" ") }, /* @__PURE__ */ n.createElement("div", { className: zt.shell }, e && /* @__PURE__ */ n.createElement("div", { className: zt.command }, /* @__PURE__ */ n.createElement(
    $y,
    {
      value: e.value,
      onChange: e.onChange,
      onClear: e.onClear,
      onSubmit: e.onSubmit,
      placeholder: e.placeholder,
      hint: (s = e.hint) != null ? s : /* @__PURE__ */ n.createElement("kbd", null, "F10")
    }
  ), t), /* @__PURE__ */ n.createElement("div", { className: zt.body }, a)));
}
function u0({ children: e, className: t = "" }) {
  return /* @__PURE__ */ n.createElement("div", { className: [zt.overview, t].filter(Boolean).join(" ") }, e);
}
function m0({ title: e, hint: t }) {
  return /* @__PURE__ */ n.createElement("div", { className: zt.areaHead }, /* @__PURE__ */ n.createElement("h2", null, e), t && /* @__PURE__ */ n.createElement("span", null, t));
}
const Ty = "_group_oodts_1", qy = "_grid_oodts_7", By = "_row_oodts_8", Ly = "_item_oodts_9", jy = "_launch_oodts_14", Ry = "_name_oodts_17", Iy = "_desc_oodts_18", Oy = "_badge_oodts_19", Py = "_disabled_oodts_23", Xy = "_tab_oodts_25", zy = "_star_oodts_25", Fy = "_on_oodts_30", Wy = "_empty_oodts_32", Pe = {
  group: Ty,
  grid: qy,
  row: By,
  item: Ly,
  launch: jy,
  name: Ry,
  desc: Iy,
  badge: Oy,
  disabled: Py,
  tab: Xy,
  star: zy,
  on: Fy,
  empty: Wy
};
function Hy() {
  return /* @__PURE__ */ n.createElement("svg", { width: "12", height: "12", viewBox: "0 0 12 12", "aria-hidden": "true", fill: "none", stroke: "currentColor", strokeWidth: "1.4", strokeLinecap: "round", strokeLinejoin: "round" }, /* @__PURE__ */ n.createElement("path", { d: "M3 1.5h4l2.5 2.5v6a.5.5 0 0 1-.5.5H3a.5.5 0 0 1-.5-.5v-8A.5.5 0 0 1 3 1.5Z" }), /* @__PURE__ */ n.createElement("path", { d: "M7 1.5V4h2.5M4.2 6.2h3.6M4.2 8.2h3.6" }));
}
function Ky() {
  return /* @__PURE__ */ n.createElement("svg", { width: "13", height: "13", viewBox: "0 0 12 12", "aria-hidden": "true", fill: "none", stroke: "currentColor", strokeWidth: "1.4", strokeLinecap: "round", strokeLinejoin: "round" }, /* @__PURE__ */ n.createElement("path", { d: "M5 2H2.5A.5.5 0 0 0 2 2.5v7a.5.5 0 0 0 .5.5h7a.5.5 0 0 0 .5-.5V7M7.5 2H10v2.5M10 2 5.5 6.5" }));
}
function d0({ title: e, items: t, emptyText: a, className: r = "" }) {
  return /* @__PURE__ */ n.createElement("section", { className: [Pe.group, r].filter(Boolean).join(" ") }, /* @__PURE__ */ n.createElement("h3", null, e), /* @__PURE__ */ n.createElement("div", { className: Pe.grid }, t.map((s) => /* @__PURE__ */ n.createElement("div", { className: Pe.row, key: s.key }, /* @__PURE__ */ n.createElement(
    "button",
    {
      type: "button",
      className: [Pe.item, s.disabled ? Pe.disabled : ""].filter(Boolean).join(" "),
      disabled: s.disabled,
      onClick: s.onOpen
    },
    /* @__PURE__ */ n.createElement("span", { className: Pe.launch }, /* @__PURE__ */ n.createElement(Hy, null)),
    /* @__PURE__ */ n.createElement("span", { className: Pe.name }, s.label),
    s.desc && /* @__PURE__ */ n.createElement("span", { className: Pe.desc }, s.desc),
    s.badge != null && /* @__PURE__ */ n.createElement("em", { className: Pe.badge }, s.badge)
  ), s.onOpenNewTab && !s.disabled && /* @__PURE__ */ n.createElement(
    "button",
    {
      type: "button",
      className: Pe.tab,
      "aria-label": `${s.label} 새 탭으로 열기`,
      title: "새 탭으로 열기",
      onClick: s.onOpenNewTab
    },
    /* @__PURE__ */ n.createElement(Ky, null)
  ), s.onToggleStar && !s.disabled && /* @__PURE__ */ n.createElement(
    "button",
    {
      type: "button",
      className: [Pe.star, s.starred ? Pe.on : ""].filter(Boolean).join(" "),
      "aria-pressed": !!s.starred,
      "aria-label": `${s.label} ${s.starred ? "마이메뉴에서 삭제" : "마이메뉴에 추가"}`,
      onClick: s.onToggleStar
    },
    s.starred ? "★" : "☆"
  ))), t.length === 0 && a != null && /* @__PURE__ */ n.createElement("p", { className: Pe.empty }, a)));
}
const Uy = "_strip_8zhai_2", Gy = "_day_8zhai_9", Yy = "_total_8zhai_10", Vy = "_sel_8zhai_31", Qy = "_today_8zhai_35", Jy = "_md_8zhai_35", Zy = "_off_8zhai_36", eb = "_head_8zhai_45", tb = "_wd_8zhai_46", nb = "_sun_8zhai_47", ab = "_sat_8zhai_48", rb = "_lock_8zhai_50", sb = "_value_8zhai_60", ob = "_mark_8zhai_66", lb = "_warn_8zhai_67", cb = "_danger_8zhai_68", ib = "_info_8zhai_69", Ne = {
  strip: Uy,
  day: Gy,
  total: Yy,
  sel: Vy,
  today: Qy,
  md: Jy,
  off: Zy,
  head: eb,
  wd: tb,
  sun: nb,
  sat: ab,
  lock: rb,
  value: sb,
  mark: ob,
  warn: lb,
  danger: cb,
  info: ib
}, Ga = ["일", "월", "화", "수", "목", "금", "토"];
function ub(e) {
  const [t, a, r] = e.split("-").map(Number), s = new Date(t, a - 1, r).getDay();
  return { md: `${a}/${r}`, wd: s };
}
function f0({
  days: e,
  selected: t,
  today: a,
  onSelect: r,
  total: s,
  totalLabel: o = "합계",
  "aria-label": l,
  className: c
}) {
  const i = L([]), m = (y) => {
    var p;
    const _ = e.length;
    for (let d = 0; d < _; d++) {
      const b = (y + d + _) % _;
      if (!e[b].disabled) {
        (p = i.current[b]) == null || p.focus();
        return;
      }
    }
  }, u = (y, _) => {
    y.key === "ArrowRight" ? (y.preventDefault(), m(_ + 1)) : y.key === "ArrowLeft" ? (y.preventDefault(), m(_ - 1)) : y.key === "Home" ? (y.preventDefault(), m(0)) : y.key === "End" && (y.preventDefault(), m(e.length - 1));
  }, f = Math.max(0, e.findIndex((y) => y.date === t));
  return /* @__PURE__ */ n.createElement("div", { className: `${Ne.strip}${c ? ` ${c}` : ""}`, role: "group", "aria-label": l }, e.map((y, _) => {
    var w, k, x, E;
    const { md: p, wd: d } = ub(y.date), b = [
      Ne.day,
      y.off ? Ne.off : "",
      y.date === t ? Ne.sel : "",
      y.date === a ? Ne.today : "",
      d === 0 ? Ne.sun : d === 6 ? Ne.sat : ""
    ].filter(Boolean).join(" "), N = [`${p}(${Ga[d]})`, y.offLabel, y.locked ? "잠김" : null, (w = y.mark) == null ? void 0 : w.text].filter(Boolean).join(" · ");
    return /* @__PURE__ */ n.createElement(
      "button",
      {
        key: y.date,
        ref: (h) => {
          i.current[_] = h;
        },
        type: "button",
        className: b,
        disabled: y.disabled,
        tabIndex: _ === f ? 0 : -1,
        "aria-pressed": y.date === t,
        "aria-label": N,
        title: N,
        onClick: () => r == null ? void 0 : r(y.date),
        onKeyDown: (h) => u(h, _)
      },
      /* @__PURE__ */ n.createElement("span", { className: Ne.head }, /* @__PURE__ */ n.createElement("span", { className: Ne.wd }, Ga[d]), /* @__PURE__ */ n.createElement("span", { className: Ne.md }, p), y.locked && /* @__PURE__ */ n.createElement("span", { className: Ne.lock, "aria-hidden": "true" }, "잠김")),
      /* @__PURE__ */ n.createElement("span", { className: Ne.value }, y.value),
      /* @__PURE__ */ n.createElement("span", { className: `${Ne.mark}${y.mark ? ` ${Ne[y.mark.tone]}` : ""}` }, (E = (k = y.mark) == null ? void 0 : k.text) != null ? E : y.off && (x = y.offLabel) != null ? x : "")
    );
  }), s !== void 0 && /* @__PURE__ */ n.createElement("div", { className: Ne.total }, /* @__PURE__ */ n.createElement("span", { className: Ne.wd }, o), /* @__PURE__ */ n.createElement("span", { className: Ne.value }, s)));
}
const mb = "_stepper_1wbt2_1", db = "_nav_1wbt2_2", fb = "_today_1wbt2_3", _b = "_range_1wbt2_14", tn = {
  stepper: mb,
  nav: db,
  today: fb,
  range: _b
};
function pb(e) {
  const t = ua(e);
  return t === 0 ? 7 : t;
}
function yb(e, t = 1) {
  const a = (pb(e) - t + 7) % 7;
  return Cn(e, -a);
}
function Hn(e, t) {
  return Cn(e, t);
}
function _0({ value: e, onChange: t, weekStart: a = 1, today: r, disabled: s, label: o = "주" }) {
  const l = Hn(e, 6), c = yb(r, a), i = l.slice(0, 4) === e.slice(0, 4) ? l.slice(5) : l;
  return /* @__PURE__ */ n.createElement("span", { className: tn.stepper, role: "group", "aria-label": o }, /* @__PURE__ */ n.createElement(
    "button",
    {
      type: "button",
      className: tn.nav,
      onClick: () => t(Hn(e, -7)),
      disabled: s,
      "aria-label": "이전 주"
    },
    "◀"
  ), /* @__PURE__ */ n.createElement("span", { className: tn.range, "aria-live": "polite" }, e, " ~ ", i), /* @__PURE__ */ n.createElement(
    "button",
    {
      type: "button",
      className: tn.nav,
      onClick: () => t(Hn(e, 7)),
      disabled: s,
      "aria-label": "다음 주"
    },
    "▶"
  ), /* @__PURE__ */ n.createElement(
    "button",
    {
      type: "button",
      className: tn.today,
      onClick: () => t(c),
      disabled: s || e === c
    },
    "이번 주"
  ));
}
const bb = "_wrap_1dtpy_1", Eb = "_svg_1dtpy_2", hb = "_grid_1dtpy_3", gb = "_axis_1dtpy_4", vb = "_accent_1dtpy_5", kb = "_muted_1dtpy_6", wb = "_ok_1dtpy_7", Nb = "_warn_1dtpy_8", $b = "_danger_1dtpy_9", xb = "_legend_1dtpy_10", Db = "_dot_accent_1dtpy_13", Ab = "_dot_muted_1dtpy_14", Cb = "_dot_ok_1dtpy_15", Sb = "_dot_warn_1dtpy_16", Mb = "_dot_danger_1dtpy_17", yt = {
  wrap: bb,
  svg: Eb,
  grid: hb,
  axis: gb,
  accent: vb,
  muted: kb,
  ok: wb,
  warn: Nb,
  danger: $b,
  legend: xb,
  dot_accent: Db,
  dot_muted: Ab,
  dot_ok: Cb,
  dot_warn: Sb,
  dot_danger: Mb
}, Tb = 600;
function qb(e) {
  if (e <= 0) return 1;
  const t = Math.pow(10, Math.floor(Math.log10(e))), a = e / t;
  return (a <= 1 ? 1 : a <= 2 ? 2 : a <= 5 ? 5 : 10) * t;
}
const Ya = (e) => e.toLocaleString("ko-KR", { maximumFractionDigits: 1 });
function p0({ categories: e, series: t, unit: a = "", height: r = 180, label: s, labelEvery: o }) {
  const l = L(null), [c, i] = D(Tb);
  Be(() => {
    const g = l.current;
    if (!g) return;
    const $ = () => {
      const M = g.clientWidth;
      M > 0 && i((T) => T === M ? T : M);
    };
    if ($(), typeof ResizeObserver == "undefined") return;
    const A = new ResizeObserver($);
    return A.observe(g), () => A.disconnect();
  }, []);
  const m = r, u = 40, f = 22, y = 8, _ = c - u - 4, p = m - f - y, d = t.flatMap((g) => g.values.filter(($) => $ != null)), b = qb(Math.max(0, ...d)), N = Math.max(e.length, 1), w = _ / N, k = Math.min(8, w * 0.2), x = Math.max(1, (w - k) / Math.max(t.length, 1)), E = o != null ? o : Math.max(1, Math.ceil(N / 8)), h = [0, b / 2, b];
  return /* @__PURE__ */ n.createElement("div", { className: yt.wrap, ref: l }, /* @__PURE__ */ n.createElement(
    "svg",
    {
      className: yt.svg,
      viewBox: `0 0 ${c} ${m}`,
      role: "img",
      "aria-label": s,
      style: { height: r }
    },
    h.map((g) => {
      const $ = y + p - g / b * p;
      return /* @__PURE__ */ n.createElement("g", { key: g }, /* @__PURE__ */ n.createElement("line", { className: yt.grid, x1: u, x2: c - 4, y1: $, y2: $ }), /* @__PURE__ */ n.createElement("text", { className: yt.axis, x: u - 4, y: $ + 3, textAnchor: "end" }, Ya(g)));
    }),
    e.map((g, $) => /* @__PURE__ */ n.createElement("g", { key: g }, t.map((A, M) => {
      var q;
      const T = A.values[$];
      if (T == null || T <= 0) return null;
      const I = T / b * p;
      return /* @__PURE__ */ n.createElement(
        "rect",
        {
          key: A.key,
          className: yt[(q = A.tone) != null ? q : "accent"],
          x: u + $ * w + k / 2 + M * x,
          y: y + p - I,
          width: x,
          height: I
        },
        /* @__PURE__ */ n.createElement("title", null, `${g} · ${A.label} ${Ya(T)}${a}`)
      );
    }), $ % E === 0 && /* @__PURE__ */ n.createElement("text", { className: yt.axis, x: u + $ * w + w / 2, y: m - 6, textAnchor: "middle" }, g)))
  ), /* @__PURE__ */ n.createElement("ul", { className: yt.legend }, t.map((g) => {
    var $;
    return /* @__PURE__ */ n.createElement("li", { key: g.key }, /* @__PURE__ */ n.createElement("i", { className: yt[`dot_${($ = g.tone) != null ? $ : "accent"}`], "aria-hidden": "true" }), g.label, a ? ` (${a})` : "");
  })));
}
const Bb = "_wrap_85lir_1", Lb = "_track_85lir_2", jb = "_accent_85lir_3", Rb = "_muted_85lir_3", Ib = "_ok_85lir_3", Ob = "_warn_85lir_3", Pb = "_danger_85lir_3", Xb = "_center_85lir_9", zb = "_legend_85lir_10", Fb = "_name_85lir_13", Wb = "_val_85lir_14", Hb = "_pct_85lir_15", Kb = "_dot_accent_85lir_16", Ub = "_dot_muted_85lir_17", Gb = "_dot_ok_85lir_18", Yb = "_dot_warn_85lir_19", Vb = "_dot_danger_85lir_20", st = {
  wrap: Bb,
  track: Lb,
  accent: jb,
  muted: Rb,
  ok: Ib,
  warn: Ob,
  danger: Pb,
  center: Xb,
  legend: zb,
  name: Fb,
  val: Wb,
  pct: Hb,
  dot_accent: Kb,
  dot_muted: Ub,
  dot_ok: Gb,
  dot_warn: Yb,
  dot_danger: Vb
}, ta = 40, Va = 2 * Math.PI * ta;
function y0({ items: e, center: t, size: a = 120, label: r, emptyText: s = "자료 없음", unit: o = "" }) {
  const l = e.reduce((i, m) => i + Math.max(0, m.value), 0);
  let c = 0;
  return /* @__PURE__ */ n.createElement("div", { className: st.wrap }, /* @__PURE__ */ n.createElement("svg", { viewBox: "0 0 100 100", width: a, height: a, role: "img", "aria-label": r }, /* @__PURE__ */ n.createElement("circle", { className: st.track, cx: "50", cy: "50", r: ta }), l > 0 && e.map((i) => {
    var f;
    const m = Math.max(0, i.value) / l * Va, u = c;
    return c += m, m <= 0 ? null : /* @__PURE__ */ n.createElement(
      "circle",
      {
        key: i.key,
        className: st[(f = i.tone) != null ? f : "accent"],
        cx: "50",
        cy: "50",
        r: ta,
        strokeDasharray: `${m} ${Va - m}`,
        strokeDashoffset: -u,
        transform: "rotate(-90 50 50)"
      },
      /* @__PURE__ */ n.createElement("title", null, `${i.label} ${i.value.toLocaleString("ko-KR")}${o}`)
    );
  }), /* @__PURE__ */ n.createElement("text", { className: st.center, x: "50", y: "54", textAnchor: "middle" }, l > 0 ? t != null ? t : l.toLocaleString("ko-KR") : s)), /* @__PURE__ */ n.createElement("ul", { className: st.legend }, e.map((i) => {
    var m;
    return /* @__PURE__ */ n.createElement("li", { key: i.key }, /* @__PURE__ */ n.createElement("i", { className: st[`dot_${(m = i.tone) != null ? m : "accent"}`], "aria-hidden": "true" }), /* @__PURE__ */ n.createElement("span", { className: st.name }, i.label), /* @__PURE__ */ n.createElement("span", { className: st.val }, i.value.toLocaleString("ko-KR"), o), /* @__PURE__ */ n.createElement("span", { className: st.pct }, l > 0 ? `${Math.round(i.value / l * 100)}%` : "-"));
  })));
}
const Qb = "_wrap_1b8ll_1", Jb = "_track_1b8ll_2", Zb = "_compact_1b8ll_3", eE = "_fill_1b8ll_4", tE = "_accent_1b8ll_5", nE = "_muted_1b8ll_6", aE = "_ok_1b8ll_7", rE = "_warn_1b8ll_8", sE = "_danger_1b8ll_9", oE = "_num_1b8ll_10", lE = "_none_1b8ll_12", Dt = {
  wrap: Qb,
  track: Jb,
  compact: Zb,
  fill: eE,
  accent: tE,
  muted: nE,
  ok: aE,
  warn: rE,
  danger: sE,
  num: oE,
  none: lE
};
function b0({ value: e, label: t, tone: a = "accent", compact: r }) {
  if (e == null)
    return /* @__PURE__ */ n.createElement("span", { className: Dt.none, "aria-label": `${t} 해당 없음` }, "-");
  const s = Math.max(0, Math.min(100, e));
  return /* @__PURE__ */ n.createElement(
    "span",
    {
      className: [Dt.wrap, r ? Dt.compact : ""].filter(Boolean).join(" "),
      role: "progressbar",
      "aria-label": t,
      "aria-valuemin": 0,
      "aria-valuemax": 100,
      "aria-valuenow": s
    },
    /* @__PURE__ */ n.createElement("span", { className: Dt.track }, /* @__PURE__ */ n.createElement("span", { className: `${Dt.fill} ${Dt[a]}`, style: { width: `${s}%` } })),
    /* @__PURE__ */ n.createElement("span", { className: Dt.num }, s, "%")
  );
}
const cE = { day: 28, week: 10, month: 3 };
function Bt(e, t) {
  return Cn(e, t);
}
function na(e, t) {
  return ht(t) - ht(e) + 1;
}
function Ir(e) {
  return ua(e);
}
const Qa = (e) => {
  const t = Ir(e);
  return t === 0 || t === 6;
};
function Xt(e, t, a, r) {
  const s = [], o = na(e, t);
  for (let l = 0; l < o; l++) {
    const c = Bt(e, l), i = a(c), m = s[s.length - 1];
    m && m.key === i ? m.days++ : s.push({ key: i, label: r(c), offset: l, days: 1 });
  }
  return s;
}
function iE(e, t, a) {
  const r = (o) => o.slice(0, 7), s = (o) => `${o.slice(0, 4)}.${o.slice(5, 7)}`;
  if (a === "month")
    return {
      top: Xt(e, t, (o) => o.slice(0, 4), (o) => `${o.slice(0, 4)}년`),
      bottom: Xt(e, t, r, (o) => `${Number(o.slice(5, 7))}월`)
    };
  if (a === "week") {
    const o = (l) => Bt(l, -((Ir(l) + 6) % 7));
    return {
      top: Xt(e, t, r, s),
      bottom: Xt(e, t, o, (l) => {
        const c = o(l);
        return `${Number(c.slice(5, 7))}/${Number(c.slice(8, 10))}`;
      })
    };
  }
  return {
    top: Xt(e, t, r, s),
    bottom: Xt(e, t, (o) => o, (o) => String(Number(o.slice(8, 10))))
  };
}
function Kn(e, t, a, r) {
  if (a === "move") return { start: Bt(e, r), end: Bt(t, r) };
  if (a === "start") {
    const o = Bt(e, r);
    return { start: o > t ? t : o, end: t };
  }
  const s = Bt(t, r);
  return { start: e, end: s < e ? e : s };
}
const uE = "_gantt_1smka_3", mE = "_scroll_1smka_15", dE = "_canvas_1smka_21", fE = "_head_1smka_24", _E = "_headLabel_1smka_32", pE = "_headTrack_1smka_43", yE = "_band_1smka_44", bE = "_seg_1smka_46", EE = "_tick_1smka_59", hE = "_tickOff_1smka_60", gE = "_body_1smka_62", vE = "_overlay_1smka_65", kE = "_weekend_1smka_66", wE = "_holiday_1smka_66", NE = "_today_1smka_68", $E = "_row_1smka_70", xE = "_label_1smka_76", DE = "_sel_1smka_77", AE = "_track_1smka_77", CE = "_dim_1smka_78", SE = "_labelText_1smka_95", ME = "_dot_1smka_96", TE = "_warn_1smka_97", qE = "_err_1smka_98", BE = "_bar_1smka_113", LE = "_can_1smka_21", jE = "_dragging_1smka_126", RE = "_fill_1smka_127", IE = "_late_1smka_128", OE = "_summary_1smka_130", PE = "_handle_1smka_133", XE = "_hL_1smka_134", zE = "_hR_1smka_135", FE = "_mark_1smka_137", WE = "_barText_1smka_138", HE = "_empty_1smka_147", KE = "_srOnly_1smka_150", ee = {
  gantt: uE,
  scroll: mE,
  canvas: dE,
  head: fE,
  headLabel: _E,
  headTrack: pE,
  band: yE,
  seg: bE,
  tick: EE,
  tickOff: hE,
  body: gE,
  overlay: vE,
  weekend: kE,
  holiday: wE,
  today: NE,
  row: $E,
  label: xE,
  sel: DE,
  track: AE,
  dim: CE,
  labelText: SE,
  dot: ME,
  warn: TE,
  err: qE,
  bar: BE,
  can: LE,
  dragging: jE,
  fill: RE,
  late: IE,
  summary: OE,
  handle: PE,
  hL: XE,
  hR: zE,
  mark: FE,
  barText: WE,
  empty: HE,
  srOnly: KE
}, Ja = 28, Za = "키보드: ←→ 옮기기 · Shift+←→ 끝 조절 · Alt+←→ 시작 조절 · Enter 열기";
let UE = 0;
function E0({
  rows: e,
  from: t,
  to: a,
  scale: r = "day",
  holidays: s = {},
  today: o,
  scrollToToday: l = !0,
  onChange: c,
  onRowClick: i,
  selectedId: m,
  labelWidth: u = 280,
  labelHeader: f,
  lockedReason: y,
  scrollMemory: _,
  className: p = "",
  style: d,
  "aria-label": b
}) {
  const N = L("");
  N.current || (N.current = `axe-gantt-keys-${++UE}`);
  const w = cE[r], k = Math.max(na(t, a), 1), x = ht(t), E = k * w, h = we(() => iE(t, a, r), [t, a, r]), g = we(() => {
    const v = [];
    for (let O = 0; O < k; O++) {
      const V = Bt(t, O), Q = V in s;
      if (!Q && !Qa(V)) continue;
      const se = v[v.length - 1];
      se && se.offset + se.days === O && se.holiday === Q ? se.days++ : v.push({ offset: O, days: 1, holiday: Q });
    }
    return v;
  }, [t, k, s]), [$, A] = D(null), M = L(null), T = (v) => !!c && !v.locked && !v.summary && !!v.start && !!v.end, I = (v, O, V) => {
    if (!T(O) || v.button !== 0) return;
    v.stopPropagation(), v.currentTarget.setPointerCapture(v.pointerId);
    const Q = { id: O.id, mode: V, x: v.clientX, delta: 0, moved: !1 };
    M.current = Q, A(Q);
  }, q = (v) => {
    const O = M.current;
    if (!O) return;
    const V = Math.round((v.clientX - O.x) / w), Q = O.moved || Math.abs(v.clientX - O.x) > 3;
    if (V !== O.delta || Q !== O.moved) {
      const se = { ...O, delta: V, moved: Q };
      M.current = se, A(se);
    }
  }, P = (v) => {
    const O = M.current;
    if (M.current = null, A(null), !!O) {
      if (!O.moved) {
        i == null || i(v);
        return;
      }
      O.delta !== 0 && v.start && v.end && (c == null || c(v, Kn(v.start, v.end, O.mode, O.delta), O.mode));
    }
  }, G = () => {
    M.current = null, A(null);
  }, K = (v, O) => {
    if (v.key === "Escape" && M.current) {
      G();
      return;
    }
    if (v.key === "Enter") {
      i == null || i(O);
      return;
    }
    if (!T(O) || v.key !== "ArrowLeft" && v.key !== "ArrowRight") return;
    v.preventDefault();
    const V = v.key === "ArrowLeft" ? -1 : 1, Q = v.shiftKey ? "end" : v.altKey ? "start" : "move";
    c == null || c(O, Kn(O.start, O.end, Q, V), Q);
  }, j = o ? ht(o) - x : -1, te = L(null), ne = L(null);
  return Be(() => {
    const v = te.current;
    if (v && (_ != null && _.current) && ne.current === null) {
      ne.current = r, v.scrollLeft = _.current.left, v.scrollTop = _.current.top;
      return;
    }
    if (!l || !v || j < 0 || j >= k || ne.current === r) return;
    ne.current = r;
    const O = Math.max(v.clientWidth - u, 0);
    v.scrollLeft = Math.max(0, j * w + w / 2 - O / 3);
  }, [l, r, j, k, w, u]), /* @__PURE__ */ n.createElement(
    "div",
    {
      className: [ee.gantt, p].filter(Boolean).join(" "),
      style: d,
      role: "region",
      "aria-label": b != null ? b : "간트",
      onKeyDown: (v) => {
        v.key === "Escape" && M.current && G();
      }
    },
    /* @__PURE__ */ n.createElement("span", { id: N.current, className: ee.srOnly }, Za),
    /* @__PURE__ */ n.createElement(
      "div",
      {
        ref: te,
        className: ee.scroll,
        onScroll: _ ? (v) => {
          _.current = { left: v.currentTarget.scrollLeft, top: v.currentTarget.scrollTop };
        } : void 0
      },
      /* @__PURE__ */ n.createElement("div", { className: ee.canvas, style: { width: u + E } }, /* @__PURE__ */ n.createElement("div", { className: ee.head, style: { gridTemplateColumns: `${u}px ${E}px` } }, /* @__PURE__ */ n.createElement("div", { className: ee.headLabel }, f), /* @__PURE__ */ n.createElement("div", { className: ee.headTrack }, /* @__PURE__ */ n.createElement("div", { className: ee.band }, h.top.map((v) => /* @__PURE__ */ n.createElement("span", { key: v.key, className: ee.seg, style: { left: v.offset * w, width: v.days * w }, title: v.label }, v.label))), /* @__PURE__ */ n.createElement("div", { className: ee.band }, h.bottom.map((v) => {
        var V;
        const O = r === "day" && (v.key in s || Qa(v.key));
        return /* @__PURE__ */ n.createElement(
          "span",
          {
            key: v.key,
            className: [ee.seg, ee.tick, O ? ee.tickOff : ""].filter(Boolean).join(" "),
            style: { left: v.offset * w, width: v.days * w },
            title: (V = s[v.key]) != null ? V : v.key
          },
          v.days * w >= 16 ? v.label : ""
        );
      })))), /* @__PURE__ */ n.createElement("div", { className: ee.body, style: { minHeight: Ja } }, /* @__PURE__ */ n.createElement("div", { className: ee.overlay, style: { left: u, width: E }, "aria-hidden": "true" }, g.map((v) => /* @__PURE__ */ n.createElement("span", { key: v.offset, className: v.holiday ? ee.holiday : ee.weekend, style: { left: v.offset * w, width: v.days * w } })), j >= 0 && j < k && /* @__PURE__ */ n.createElement("span", { className: ee.today, style: { left: j * w + w / 2 }, title: "오늘" })), e.map((v) => {
        var X, H, ce, Ue;
        const O = !!v.start && !!v.end && v.start <= v.end, V = $ && $.id === v.id ? $ : null, Q = O && V && V.delta !== 0 ? Kn(v.start, v.end, V.mode, V.delta) : O ? { start: v.start, end: v.end } : null, se = Q ? (ht(Q.start) - x) * w : 0, B = Q ? na(Q.start, Q.end) * w : 0, J = Math.max(0, Math.min(100, (X = v.progress) != null ? X : 0)), R = m != null && m === v.id, z = T(v), Y = !z && c && Q ? y == null ? void 0 : y(v) : void 0;
        return /* @__PURE__ */ n.createElement(
          "div",
          {
            key: v.id,
            className: [ee.row, R ? ee.sel : "", v.dim ? ee.dim : ""].filter(Boolean).join(" "),
            style: { height: Ja }
          },
          /* @__PURE__ */ n.createElement(
            "div",
            {
              className: ee.label,
              style: { width: u },
              title: v.name,
              onClick: () => i == null ? void 0 : i(v)
            },
            /* @__PURE__ */ n.createElement("span", { className: ee.labelText }, v.label),
            v.marked && /* @__PURE__ */ n.createElement("span", { className: ee.dot, title: "저장 대기", "aria-label": "저장 대기" }),
            v.warn && /* @__PURE__ */ n.createElement("span", { className: ee.warn, title: v.warn, "aria-label": v.warn }, "⚠"),
            v.error && /* @__PURE__ */ n.createElement("span", { className: ee.err, title: v.error, "aria-label": v.error }, "!")
          ),
          /* @__PURE__ */ n.createElement("div", { className: ee.track, style: { width: E }, onClick: () => !V && (i == null ? void 0 : i(v)) }, Q ? /* @__PURE__ */ n.createElement(n.Fragment, null, /* @__PURE__ */ n.createElement(
            "div",
            {
              className: [ee.bar, v.summary ? ee.summary : "", v.late ? ee.late : "", z ? ee.can : "", V ? ee.dragging : ""].filter(Boolean).join(" "),
              style: { left: se, width: Math.max(B, 2) },
              role: "button",
              tabIndex: 0,
              "aria-label": `${(H = v.name) != null ? H : ""} ${Q.start} ~ ${Q.end}${v.progress != null ? ` ${J}%` : ""}${v.late ? " 지연" : ""}${Y ? ` 잠김: ${Y}` : ""}`,
              "aria-describedby": z ? N.current : void 0,
              title: `${Q.start} ~ ${Q.end}${v.progress != null ? ` · ${J}%` : ""}${v.late ? " · 지연" : ""}${z ? `
끌어 옮기기·양 끝 조절
${Za}` : ""}${Y ? `
잠김: ${Y}` : ""}`,
              onPointerDown: (Re) => I(Re, v, "move"),
              onPointerMove: q,
              onPointerUp: () => P(v),
              onPointerCancel: G,
              onClick: (Re) => Re.stopPropagation(),
              onKeyDown: (Re) => K(Re, v)
            },
            v.progress != null && /* @__PURE__ */ n.createElement("span", { className: ee.fill, style: { width: `${J}%` } }),
            z && /* @__PURE__ */ n.createElement(n.Fragment, null, /* @__PURE__ */ n.createElement("span", { className: `${ee.handle} ${ee.hL}`, onPointerDown: (Re) => I(Re, v, "start") }), /* @__PURE__ */ n.createElement("span", { className: `${ee.handle} ${ee.hR}`, onPointerDown: (Re) => I(Re, v, "end") }))
          ), v.markDate && v.markDate >= t && v.markDate <= a && /* @__PURE__ */ n.createElement("span", { className: ee.mark, style: { left: (ht(v.markDate) - x + 1) * w - 1 }, title: (ce = v.markLabel) != null ? ce : v.markDate }), v.barText && /* @__PURE__ */ n.createElement("span", { className: ee.barText, style: { left: se + Math.max(B, 2) + 4 } }, v.barText)) : /* @__PURE__ */ n.createElement("span", { className: ee.empty }, (Ue = v.emptyText) != null ? Ue : "기간 없음"))
        );
      })))
    )
  );
}
const GE = "_board_192fl_3", YE = "_col_192fl_15", VE = "_over_192fl_23", QE = "_head_192fl_25", JE = "_title_192fl_33", ZE = "_count_192fl_34", eh = "_hint_192fl_43", th = "_list_192fl_45", nh = "_empty_192fl_54", ah = "_card_192fl_56", rh = "_sel_192fl_68", sh = "_dragging_192fl_69", oh = "_hasErr_192fl_70", lh = "_dot_192fl_71", ch = "_err_192fl_72", Me = {
  board: GE,
  col: YE,
  over: VE,
  head: QE,
  title: JE,
  count: ZE,
  hint: eh,
  list: th,
  empty: nh,
  card: ah,
  sel: rh,
  dragging: sh,
  hasErr: oh,
  dot: lh,
  err: ch
}, Un = "application/x-axerp-kanban";
function h0({
  columns: e,
  cards: t,
  cardKey: a,
  columnOf: r,
  renderCard: s,
  cardLabel: o,
  onMove: l,
  onCardClick: c,
  selectedKey: i,
  marked: m,
  error: u,
  lockedReason: f,
  emptyText: y = "카드가 없습니다",
  moveHint: _,
  className: p = "",
  style: d,
  "aria-label": b
}) {
  const N = Yt("axe-kb"), [w, k] = D(null), [x, E] = D(null), h = new Map(t.map((T) => [String(a(T)), T])), g = L(null), $ = L(null);
  Z(() => {
    var q, P;
    const T = $.current;
    if (!T) return;
    if (Date.now() > T.until) {
      $.current = null;
      return;
    }
    const I = Array.from((P = (q = g.current) == null ? void 0 : q.querySelectorAll("[data-kanban-key]")) != null ? P : []).find((G) => G.dataset.kanbanKey === T.key);
    I && document.activeElement !== I && I.focus(), $.current = null;
  });
  const A = (T, I) => {
    T.preventDefault(), k(null), E(null);
    const q = T.dataTransfer.getData(Un), P = h.get(q);
    P && r(P) !== I && (l == null || l(P, I));
  }, M = (T, I) => {
    if (T.key === "Enter" || T.key === " ") {
      T.preventDefault(), c == null || c(I);
      return;
    }
    if (!l || !T.altKey || T.key !== "ArrowLeft" && T.key !== "ArrowRight" || f != null && f(I)) return;
    T.preventDefault();
    const q = e.findIndex((G) => G.key === r(I)), P = q + (T.key === "ArrowLeft" ? -1 : 1);
    q >= 0 && P >= 0 && P < e.length && ($.current = { key: String(a(I)), until: Date.now() + 1500 }, l(I, e[P].key));
  };
  return /* @__PURE__ */ n.createElement("div", { ref: g, className: [Me.board, p].filter(Boolean).join(" "), style: d, role: "region", "aria-label": b != null ? b : "보드" }, e.map((T) => {
    const I = t.filter((q) => r(q) === T.key);
    return /* @__PURE__ */ n.createElement(
      "section",
      {
        key: T.key,
        className: [Me.col, w === T.key ? Me.over : ""].filter(Boolean).join(" "),
        "aria-label": typeof T.title == "string" ? T.title : void 0,
        onDragOver: l ? (q) => {
          q.dataTransfer.types.includes(Un) && (q.preventDefault(), k(T.key));
        } : void 0,
        onDragLeave: l ? (q) => {
          q.currentTarget.contains(q.relatedTarget) || k((P) => P === T.key ? null : P);
        } : void 0,
        onDrop: l ? (q) => A(q, T.key) : void 0
      },
      /* @__PURE__ */ n.createElement("header", { className: Me.head }, /* @__PURE__ */ n.createElement("span", { className: Me.title }, T.title), /* @__PURE__ */ n.createElement("span", { className: Me.count }, I.length), T.hint && /* @__PURE__ */ n.createElement("span", { className: Me.hint }, T.hint)),
      /* @__PURE__ */ n.createElement("div", { className: Me.list }, I.length === 0 && /* @__PURE__ */ n.createElement("p", { className: Me.empty }, y), I.map((q) => {
        const P = a(q), G = f == null ? void 0 : f(q), K = u == null ? void 0 : u(q), j = !!l && !G, te = G != null ? G : j ? _ != null ? _ : "끌어 다른 열로 옮길 수 있습니다 (Alt+←→)" : void 0;
        return /* @__PURE__ */ n.createElement(
          "article",
          {
            key: P,
            className: [Me.card, i === P ? Me.sel : "", x === P ? Me.dragging : "", K ? Me.hasErr : ""].filter(Boolean).join(" "),
            tabIndex: 0,
            "data-kanban-key": String(P),
            role: "button",
            "aria-label": o == null ? void 0 : o(q),
            "aria-keyshortcuts": j ? "Alt+ArrowLeft Alt+ArrowRight" : void 0,
            title: te,
            "aria-describedby": te ? `${N}-h-${String(P)}` : void 0,
            draggable: j,
            onDragStart: j ? (ne) => {
              ne.dataTransfer.setData(Un, String(P)), ne.dataTransfer.effectAllowed = "move", E(P);
            } : void 0,
            onDragEnd: () => {
              E(null), k(null);
            },
            onClick: () => c == null ? void 0 : c(q),
            onKeyDown: (ne) => M(ne, q)
          },
          te && /* @__PURE__ */ n.createElement(kr, { id: `${N}-h-${String(P)}` }, te),
          (m == null ? void 0 : m(q)) && /* @__PURE__ */ n.createElement("span", { className: Me.dot, title: "저장 대기", "aria-label": "저장 대기" }),
          s(q),
          K && /* @__PURE__ */ n.createElement("p", { className: Me.err, role: "alert" }, K)
        );
      }))
    );
  }));
}
const ih = "_list_1aqum_2", uh = "_empty_1aqum_3", mh = "_item_1aqum_5", dh = "_row_block_1aqum_6", fh = "_row_warn_1aqum_7", _h = "_head_1aqum_9", ph = "_mark_1aqum_16", yh = "_msg_1aqum_17", bh = "_count_1aqum_18", Eh = "_aside_1aqum_19", hh = "_caret_1aqum_20", gh = "_block_1aqum_22", vh = "_warn_1aqum_23", kh = "_info_1aqum_24", wh = "_body_1aqum_29", Nh = "_actions_1aqum_30", Te = {
  list: ih,
  empty: uh,
  item: mh,
  row_block: dh,
  row_warn: fh,
  head: _h,
  mark: ph,
  msg: yh,
  count: bh,
  aside: Eh,
  caret: hh,
  block: gh,
  warn: vh,
  info: kh,
  body: wh,
  actions: Nh
}, $h = { block: "■", warn: "▲", info: "●" }, xh = { block: "차단", warn: "경고", info: "정보" };
function g0({ items: e, empty: t = "점검할 항목이 없습니다", openTones: a = ["block"], className: r = "" }) {
  const [s, o] = D({}), [l, c] = D(e);
  return l !== e && (c(e), o({})), e.length ? /* @__PURE__ */ n.createElement("ul", { className: `${Te.list} ${r}` }, e.map((i) => {
    var y;
    const m = !!i.detail || !!i.actions, u = m && ((y = s[i.key]) != null ? y : a.includes(i.tone)), f = /* @__PURE__ */ n.createElement(n.Fragment, null, /* @__PURE__ */ n.createElement("span", { className: `${Te.mark} ${Te[i.tone]}`, "aria-label": xh[i.tone], role: "img" }, $h[i.tone]), /* @__PURE__ */ n.createElement("span", { className: Te.msg }, i.message), !!i.count && /* @__PURE__ */ n.createElement("span", { className: `${Te.count} ${Te[i.tone]}` }, i.count.toLocaleString("ko-KR"), "건"), i.aside != null && /* @__PURE__ */ n.createElement("span", { className: Te.aside }, i.aside), m && /* @__PURE__ */ n.createElement("span", { className: Te.caret, "aria-hidden": "true" }, u ? "▾" : "▸"));
    return /* @__PURE__ */ n.createElement("li", { key: i.key, className: `${Te.item} ${Te[`row_${i.tone}`]}` }, m ? /* @__PURE__ */ n.createElement(
      "button",
      {
        type: "button",
        className: Te.head,
        "aria-expanded": u,
        onClick: () => o((_) => ({ ..._, [i.key]: !u }))
      },
      f
    ) : /* @__PURE__ */ n.createElement("div", { className: Te.head }, f), u && /* @__PURE__ */ n.createElement("div", { className: Te.body }, i.detail, i.actions && /* @__PURE__ */ n.createElement("div", { className: Te.actions }, i.actions)));
  })) : /* @__PURE__ */ n.createElement("p", { className: `${Te.empty} ${r}` }, t);
}
function Dh(e, t) {
  const a = Math.max(1, Math.floor(t) || 1), r = Math.min(a, Math.max(1, Math.floor(e) || 1)), s = (o, l) => Array.from({ length: l - o + 1 }, (c, i) => o + i);
  return a <= 10 ? s(1, a) : r <= 5 ? [...s(1, 7), "…", a] : r >= a - 4 ? [1, "…", ...s(a - 6, a)] : [1, "…", ...s(r - 2, r + 2), "…", a];
}
function Ah(e, t) {
  const a = parseInt(e.replace(/[^\d]/g, ""), 10);
  return Number.isFinite(a) ? Math.min(Math.max(1, t), Math.max(1, a)) : null;
}
function v0(e) {
  return e === "page" ? "쪽 합계" : "전체 합계";
}
function k0(e, t) {
  return Math.max(1, Math.ceil(Math.max(0, e) / Math.max(1, t)));
}
const Ch = "_nav_1r2z8_1", Sh = "_list_1r2z8_3", Mh = "_btn_1r2z8_4", Th = "_cur_1r2z8_13", qh = "_gap_1r2z8_15", Bh = "_total_1r2z8_16", Lh = "_jump_1r2z8_17", jh = "_go_1r2z8_20", Rh = "_size_1r2z8_22", Ih = "_more_1r2z8_24", Oh = "_moreBtn_1r2z8_25", Ph = "_moreN_1r2z8_29", ge = {
  nav: Ch,
  list: Sh,
  btn: Mh,
  cur: Th,
  gap: qh,
  total: Bh,
  jump: Lh,
  in: "_in_1r2z8_18",
  go: jh,
  size: Rh,
  more: Ih,
  moreBtn: Oh,
  moreN: Ph
};
function w0({ page: e, pageCount: t, onPageChange: a, jump: r = !1, pageSizes: s, pageSize: o, onPageSizeChange: l, total: c, className: i = "" }) {
  const m = Math.max(1, t), u = Math.min(m, Math.max(1, e)), [f, y] = D(String(u));
  Z(() => y(String(u)), [u]);
  const _ = (d) => {
    d !== u && d >= 1 && d <= m && a(d);
  }, p = () => {
    const d = Ah(f, m);
    if (d === null) {
      y(String(u));
      return;
    }
    y(String(d)), _(d);
  };
  return /* @__PURE__ */ n.createElement("nav", { className: [ge.nav, i].filter(Boolean).join(" "), "aria-label": "쪽 이동" }, c !== void 0 && /* @__PURE__ */ n.createElement("span", { className: ge.total }, "총 ", c.toLocaleString("ko-KR"), "건"), /* @__PURE__ */ n.createElement("ol", { className: ge.list }, /* @__PURE__ */ n.createElement("li", null, /* @__PURE__ */ n.createElement("button", { type: "button", className: ge.btn, onClick: () => _(1), disabled: u === 1, "aria-label": "첫 쪽" }, "«")), /* @__PURE__ */ n.createElement("li", null, /* @__PURE__ */ n.createElement("button", { type: "button", className: ge.btn, onClick: () => _(u - 1), disabled: u === 1, "aria-label": "이전 쪽" }, "‹")), Dh(u, m).map((d, b) => d === "…" ? /* @__PURE__ */ n.createElement("li", { key: `e${b}`, className: ge.gap, "aria-hidden": "true" }, "…") : /* @__PURE__ */ n.createElement("li", { key: d }, /* @__PURE__ */ n.createElement(
    "button",
    {
      type: "button",
      className: [ge.btn, d === u ? ge.cur : ""].filter(Boolean).join(" "),
      onClick: () => _(d),
      "aria-current": d === u ? "page" : void 0,
      "aria-label": `${d}쪽`
    },
    d
  ))), /* @__PURE__ */ n.createElement("li", null, /* @__PURE__ */ n.createElement("button", { type: "button", className: ge.btn, onClick: () => _(u + 1), disabled: u === m, "aria-label": "다음 쪽" }, "›")), /* @__PURE__ */ n.createElement("li", null, /* @__PURE__ */ n.createElement("button", { type: "button", className: ge.btn, onClick: () => _(m), disabled: u === m, "aria-label": "마지막 쪽" }, "»"))), /* @__PURE__ */ n.createElement("span", { className: ge.total }, "전체 ", m, "쪽"), r && /* @__PURE__ */ n.createElement("span", { className: ge.jump }, /* @__PURE__ */ n.createElement(
    "input",
    {
      className: ge.in,
      inputMode: "numeric",
      value: f,
      "aria-label": "이동할 쪽 번호",
      onChange: (d) => y(d.target.value.replace(/[^\d]/g, "")),
      onKeyDown: (d) => {
        d.key === "Enter" && (d.preventDefault(), p());
      }
    }
  ), /* @__PURE__ */ n.createElement("button", { type: "button", className: ge.go, onClick: p }, "이동")), s && o !== void 0 && l && /* @__PURE__ */ n.createElement("label", { className: ge.size }, "쪽당", /* @__PURE__ */ n.createElement("select", { value: o, onChange: (d) => l(Number(d.target.value)) }, s.map((d) => /* @__PURE__ */ n.createElement("option", { key: d, value: d }, d, "건")))));
}
function N0({ shown: e, total: t, onMore: a, busy: r = !1, className: s = "" }) {
  return e >= t ? null : /* @__PURE__ */ n.createElement("div", { className: [ge.more, s].filter(Boolean).join(" ") }, /* @__PURE__ */ n.createElement("button", { type: "button", className: ge.moreBtn, onClick: a, disabled: r, "aria-busy": r }, "더보기 ", /* @__PURE__ */ n.createElement("span", { className: ge.moreN }, "(", e.toLocaleString("ko-KR"), "/", t.toLocaleString("ko-KR"), ")")));
}
const Xh = "_ol_fbatg_1", zh = "_li_fbatg_2", Fh = "_done_fbatg_5", Wh = "_now_fbatg_5", Hh = "_item_fbatg_6", Kh = "_dot_fbatg_12", Uh = "_label_fbatg_19", Gh = "_opt_fbatg_21", Yh = "_sr_fbatg_22", ot = {
  ol: Xh,
  li: zh,
  done: Fh,
  now: Wh,
  item: Hh,
  dot: Kh,
  label: Uh,
  opt: Gh,
  sr: Yh
};
function $0({ steps: e, current: t, onStepClick: a, className: r = "" }) {
  return /* @__PURE__ */ n.createElement("ol", { className: [ot.ol, r].filter(Boolean).join(" "), "aria-label": `${e.length}단계 중 ${Math.min(t + 1, e.length)}단계` }, e.map((s, o) => {
    const l = o < t ? "done" : o === t ? "now" : "todo", c = /* @__PURE__ */ n.createElement(n.Fragment, null, /* @__PURE__ */ n.createElement("span", { className: ot.dot, "aria-hidden": "true" }, l === "done" ? "✓" : o + 1), /* @__PURE__ */ n.createElement("span", { className: ot.label }, s.label, s.optional && /* @__PURE__ */ n.createElement("span", { className: ot.opt }, " (선택)"), l === "done" && /* @__PURE__ */ n.createElement("span", { className: ot.sr }, " 완료"))), i = !!a && o <= t;
    return /* @__PURE__ */ n.createElement("li", { key: s.key, className: [ot.li, ot[l]].join(" "), "aria-current": l === "now" ? "step" : void 0 }, i ? /* @__PURE__ */ n.createElement("button", { type: "button", className: ot.item, onClick: () => a(o, s) }, c) : /* @__PURE__ */ n.createElement("span", { className: ot.item }, c));
  }));
}
const Vh = "_root_7y5bc_5", Qh = "_block_7y5bc_6", Jh = "_svg_7y5bc_7", Zh = "_sm_7y5bc_8", e1 = "_md_7y5bc_9", t1 = "_lg_7y5bc_10", n1 = "_track_7y5bc_11", a1 = "_bar_7y5bc_12", r1 = "_spin_7y5bc_13", s1 = "_txt_7y5bc_15", bt = {
  root: Vh,
  "axe-sp-in": "_axe-sp-in_7y5bc_1",
  block: Qh,
  svg: Jh,
  sm: Zh,
  md: e1,
  lg: t1,
  track: n1,
  bar: a1,
  spin: r1,
  "axe-sp-rot": "_axe-sp-rot_7y5bc_1",
  txt: s1,
  "axe-sp-blink": "_axe-sp-blink_7y5bc_1"
};
function x0({ size: e = "md", value: t, label: a = "불러오는 중", delay: r = 300, block: s = !1, className: o = "" }) {
  const l = typeof t == "number", c = l ? Math.min(100, Math.max(0, t)) : 0, i = 15.9155;
  return /* @__PURE__ */ n.createElement(
    "span",
    {
      className: [bt.root, s ? bt.block : "", o].filter(Boolean).join(" "),
      style: { "--sp-delay": `${r}ms` },
      role: "status",
      "aria-live": "polite",
      "aria-busy": "true"
    },
    /* @__PURE__ */ n.createElement("svg", { className: [bt.svg, bt[e], l ? "" : bt.spin].filter(Boolean).join(" "), viewBox: "0 0 36 36", "aria-hidden": "true", focusable: "false" }, /* @__PURE__ */ n.createElement("circle", { className: bt.track, cx: "18", cy: "18", r: i, fill: "none" }), /* @__PURE__ */ n.createElement(
      "circle",
      {
        className: bt.bar,
        cx: "18",
        cy: "18",
        r: i,
        fill: "none",
        strokeDasharray: l ? `${c} ${100 - c}` : "25 75",
        transform: "rotate(-90 18 18)"
      }
    )),
    /* @__PURE__ */ n.createElement("span", { className: bt.txt }, a, l ? ` ${Math.round(c)}%` : "")
  );
}
const o1 = "_group_xpsei_1", l1 = "_legend_xpsei_2", c1 = "_req_xpsei_3", i1 = "_opts_xpsei_4", u1 = "_inline_xpsei_5", m1 = "_all_xpsei_6", d1 = "_opt_xpsei_4", f1 = "_dis_xpsei_11", _1 = "_radio_xpsei_12", p1 = "_check_xpsei_12", y1 = "_text_xpsei_14", b1 = "_hint_xpsei_15", E1 = "_err_xpsei_16", pe = {
  group: o1,
  legend: l1,
  req: c1,
  opts: i1,
  inline: u1,
  all: m1,
  opt: d1,
  dis: f1,
  radio: _1,
  check: p1,
  text: y1,
  hint: b1,
  err: E1
};
function Or({ legend: e, required: t }) {
  return /* @__PURE__ */ n.createElement("legend", { className: pe.legend }, e, t && /* @__PURE__ */ n.createElement("span", { className: pe.req }, " (필수)"));
}
function D0({ name: e, legend: t, options: a, value: r, onChange: s, required: o, disabled: l, error: c, inline: i = !1, className: m = "" }) {
  const u = Yt("axe-rg-err");
  return /* @__PURE__ */ n.createElement(
    "fieldset",
    {
      className: [pe.group, m].filter(Boolean).join(" "),
      disabled: l,
      "aria-describedby": c ? u : void 0,
      "aria-invalid": c ? !0 : void 0
    },
    /* @__PURE__ */ n.createElement(Or, { legend: t, required: o }),
    /* @__PURE__ */ n.createElement("div", { className: [pe.opts, i ? pe.inline : ""].filter(Boolean).join(" "), role: "radiogroup" }, a.map((f) => /* @__PURE__ */ n.createElement("label", { key: f.value, className: [pe.opt, f.disabled ? pe.dis : ""].filter(Boolean).join(" ") }, /* @__PURE__ */ n.createElement(
      "input",
      {
        type: "radio",
        className: pe.radio,
        name: e,
        value: f.value,
        checked: r === f.value,
        disabled: f.disabled,
        required: o,
        onChange: () => s(f.value)
      }
    ), /* @__PURE__ */ n.createElement("span", { className: pe.text }, f.label, f.hint && /* @__PURE__ */ n.createElement("span", { className: pe.hint }, f.hint))))),
    c && /* @__PURE__ */ n.createElement("p", { id: u, className: pe.err }, c)
  );
}
function er({ checked: e, indeterminate: t = !1, onChange: a, disabled: r, children: s, className: o = "" }) {
  return /* @__PURE__ */ n.createElement("label", { className: [pe.opt, r ? pe.dis : "", o].filter(Boolean).join(" ") }, /* @__PURE__ */ n.createElement(
    "input",
    {
      type: "checkbox",
      className: pe.check,
      checked: e,
      disabled: r,
      ref: (l) => {
        l && (l.indeterminate = t && !e);
      },
      onChange: (l) => a(l.target.checked)
    }
  ), s !== void 0 && /* @__PURE__ */ n.createElement("span", { className: pe.text }, s));
}
function A0({ legend: e, options: t, value: a, onChange: r, required: s, disabled: o, error: l, inline: c = !1, selectAll: i, className: m = "" }) {
  const u = Yt("axe-cg-err"), f = t.filter((d) => !d.disabled).map((d) => d.value), y = f.length > 0 && f.every((d) => a.includes(d)), _ = f.some((d) => a.includes(d)), p = (d, b) => r(b ? [...a, d] : a.filter((N) => N !== d));
  return /* @__PURE__ */ n.createElement(
    "fieldset",
    {
      className: [pe.group, m].filter(Boolean).join(" "),
      disabled: o,
      "aria-describedby": l ? u : void 0,
      "aria-invalid": l ? !0 : void 0
    },
    /* @__PURE__ */ n.createElement(Or, { legend: e, required: s }),
    i && /* @__PURE__ */ n.createElement("div", { className: pe.all }, /* @__PURE__ */ n.createElement(
      er,
      {
        checked: y,
        indeterminate: _ && !y,
        onChange: (d) => r(d ? Array.from(/* @__PURE__ */ new Set([...a, ...f])) : a.filter((b) => !f.includes(b)))
      },
      i
    )),
    /* @__PURE__ */ n.createElement("div", { className: [pe.opts, c ? pe.inline : ""].filter(Boolean).join(" ") }, t.map((d) => /* @__PURE__ */ n.createElement(er, { key: d.value, checked: a.includes(d.value), disabled: d.disabled, onChange: (b) => p(d.value, b) }, d.label, d.hint && /* @__PURE__ */ n.createElement("span", { className: pe.hint }, d.hint)))),
    l && /* @__PURE__ */ n.createElement("p", { id: u, className: pe.err }, l)
  );
}
const h1 = "_list_13vw7_1", g1 = "_tag_13vw7_2", v1 = "_main_13vw7_3", k1 = "_x_13vw7_6", w1 = "_t_muted_13vw7_10", N1 = "_t_accent_13vw7_11", $1 = "_t_ok_13vw7_12", x1 = "_t_warn_13vw7_13", D1 = "_t_danger_13vw7_14", A1 = "_sel_13vw7_16", Ct = {
  list: h1,
  tag: g1,
  main: v1,
  x: k1,
  t_muted: w1,
  t_accent: N1,
  t_ok: $1,
  t_warn: x1,
  t_danger: D1,
  sel: A1
};
function C0({ children: e, tone: t = "muted", selected: a, onClick: r, onRemove: s, removeLabel: o, disabled: l, className: c = "" }) {
  const i = [Ct.tag, Ct[`t_${t}`], a ? Ct.sel : "", c].filter(Boolean).join(" "), m = o != null ? o : typeof e == "string" ? `${e} 삭제` : "태그 삭제";
  return /* @__PURE__ */ n.createElement("span", { className: i }, r ? /* @__PURE__ */ n.createElement("button", { type: "button", className: Ct.main, onClick: r, disabled: l, "aria-pressed": a }, a && /* @__PURE__ */ n.createElement("span", { "aria-hidden": "true" }, "✓ "), e) : /* @__PURE__ */ n.createElement("span", { className: Ct.main }, e), s && /* @__PURE__ */ n.createElement("button", { type: "button", className: Ct.x, onClick: s, disabled: l, "aria-label": m }, "✕"));
}
function S0({ label: e, children: t, className: a = "" }) {
  return /* @__PURE__ */ n.createElement("ul", { className: [Ct.list, a].filter(Boolean).join(" "), "aria-label": e }, (Array.isArray(t) ? t : [t]).filter(Boolean).map((r, s) => /* @__PURE__ */ n.createElement("li", { key: s }, r)));
}
const C1 = "_acc_1lmty_1", S1 = "_item_1lmty_2", M1 = "_h_1lmty_3", T1 = "_btn_1lmty_4", q1 = "_title_1lmty_8", B1 = "_meta_1lmty_9", L1 = "_chev_1lmty_10", j1 = "_open_1lmty_11", R1 = "_body_1lmty_12", lt = {
  acc: C1,
  item: S1,
  h: M1,
  btn: T1,
  title: q1,
  meta: B1,
  chev: L1,
  open: j1,
  body: R1
};
function M0({ items: e, single: t = !1, defaultOpen: a = [], openKeys: r, onOpenChange: s, headingLevel: o = 3, className: l = "" }) {
  const [c, i] = D(a), m = r != null ? r : c, u = Yt("axe-acc"), f = `h${o}`, y = (_) => {
    const p = m.includes(_) ? m.filter((d) => d !== _) : t ? [_] : [...m, _];
    r === void 0 && i(p), s == null || s(p);
  };
  return /* @__PURE__ */ n.createElement("div", { className: [lt.acc, l].filter(Boolean).join(" ") }, e.map((_) => {
    const p = m.includes(_.key), d = `${u}-b-${_.key}`, b = `${u}-p-${_.key}`;
    return /* @__PURE__ */ n.createElement("div", { key: _.key, className: [lt.item, p ? lt.open : ""].filter(Boolean).join(" ") }, /* @__PURE__ */ n.createElement(f, { className: lt.h }, /* @__PURE__ */ n.createElement(
      "button",
      {
        type: "button",
        id: d,
        className: lt.btn,
        "aria-expanded": p,
        "aria-controls": b,
        disabled: _.disabled,
        onClick: () => y(_.key)
      },
      /* @__PURE__ */ n.createElement("span", { className: lt.title }, _.title),
      _.meta && /* @__PURE__ */ n.createElement("span", { className: lt.meta }, _.meta),
      /* @__PURE__ */ n.createElement("span", { className: lt.chev, "aria-hidden": "true" }, "▾")
    )), /* @__PURE__ */ n.createElement("div", { id: b, role: "region", "aria-labelledby": d, hidden: !p, className: lt.body }, _.content));
  }));
}
const I1 = "_stack_1u83j_2", O1 = "_toast_1u83j_3", P1 = "_t_danger_1u83j_9", X1 = "_ico_1u83j_10", z1 = "_t_ok_1u83j_11", F1 = "_msg_1u83j_12", W1 = "_act_1u83j_13", H1 = "_x_1u83j_15", St = {
  stack: I1,
  toast: O1,
  "axe-toast-in": "_axe-toast-in_1u83j_1",
  t_danger: P1,
  ico: X1,
  t_ok: z1,
  msg: F1,
  act: W1,
  x: H1
}, Pr = An(null);
let K1 = 0;
function T0() {
  const e = Dn(Pr);
  if (!e) throw new Error("useAXErpToast 는 AXErpToastProvider 안에서만 쓴다");
  return e;
}
function U1({ item: e, onClose: t }) {
  var l, c;
  const [a, r] = D(!1), s = (l = e.duration) != null ? l : e.action ? 8e3 : 4e3;
  Z(() => {
    if (a || s === 0) return;
    const i = window.setTimeout(t, s);
    return () => window.clearTimeout(i);
  }, [a, s, t, e.message]);
  const o = (c = e.tone) != null ? c : "info";
  return /* @__PURE__ */ n.createElement(
    "div",
    {
      className: [St.toast, St[`t_${o}`]].join(" "),
      role: o === "danger" ? "alert" : void 0,
      onMouseEnter: () => r(!0),
      onMouseLeave: () => r(!1),
      onFocus: () => r(!0),
      onBlur: () => r(!1)
    },
    /* @__PURE__ */ n.createElement("span", { className: St.ico, "aria-hidden": "true" }, o === "ok" ? "✓" : o === "danger" ? "▲" : "ⓘ"),
    /* @__PURE__ */ n.createElement("span", { className: St.msg }, e.message),
    e.action && /* @__PURE__ */ n.createElement("button", { type: "button", className: St.act, onClick: () => {
      e.action.onAction(), t();
    } }, e.action.label),
    /* @__PURE__ */ n.createElement("button", { type: "button", className: St.x, onClick: t, "aria-label": "알림 닫기" }, "✕")
  );
}
function q0({ children: e }) {
  const [t, a] = D([]), r = L(t);
  r.current = t;
  const s = oe((c) => a((i) => i.filter((m) => m.id !== c)), []), o = oe((c) => {
    const i = typeof c == "string" ? { message: c } : c, m = r.current.find((f) => f.message === i.message);
    if (m)
      return a((f) => f.map((y) => y.id === m.id ? { ...y, ...i } : y)), m.id;
    const u = ++K1;
    return a((f) => [...f, { ...i, id: u }].slice(-3)), u;
  }, []), l = we(() => ({ toast: o, dismiss: s }), [o, s]);
  return /* @__PURE__ */ n.createElement(Pr.Provider, { value: l }, e, /* @__PURE__ */ n.createElement("div", { className: St.stack, role: "status", "aria-live": "polite", "aria-atomic": "false" }, t.map((c) => /* @__PURE__ */ n.createElement(U1, { key: c.id, item: c, onClose: () => s(c.id) }))));
}
const G1 = [
  {
    title: "공통",
    items: [
      { keys: ["?"], text: "단축키 도움말 열기 (입력 칸 밖에서)" },
      { keys: ["Tab", "Shift+Tab"], text: "다음·이전 입력 칸 / 버튼으로 이동" },
      { keys: ["Esc"], text: "열린 달력·메뉴·대화상자 닫기, 입력 중이던 값 취소" },
      { keys: ["Ctrl+Enter"], text: "저장 (저장 버튼 옆에 표기된 화면)" }
    ]
  },
  {
    title: "날짜 입력 칸",
    items: [
      { keys: ["숫자만"], text: "20260930 · 260930 · 0930 처럼 구분 기호 없이 입력" },
      { keys: ["↑", "↓"], text: "하루 뒤·앞 (월 입력은 한 달)" },
      { keys: ["PageUp", "PageDown"], text: "한 달 앞·뒤 (월 입력은 한 해)" },
      { keys: ["T"], text: "오늘" },
      { keys: ["F2", "F4", "Alt+↓"], text: "달력 열기" }
    ]
  },
  {
    title: "코드 입력 칸",
    items: [
      { keys: ["코드·명칭 입력"], text: "입력하는 동안 후보 표시" },
      { keys: ["↑", "↓"], text: "후보 선택" },
      { keys: ["Enter"], text: "선택한 후보 확정" },
      { keys: ["F2"], text: "전체 검색 창 열기" }
    ]
  },
  {
    title: "표 (행·칸 이동)",
    items: [
      { keys: ["←", "→", "↑", "↓"], text: "칸 이동" },
      { keys: ["Home", "End"], text: "줄의 처음·끝 칸" },
      { keys: ["Ctrl+Home", "Ctrl+End"], text: "표의 처음·끝 칸" },
      { keys: ["Enter", "Space"], text: "행 열기 (행 클릭이 되는 표)" }
    ]
  },
  {
    title: "달력 (달력에 포커스가 있을 때)",
    items: [
      { keys: ["T"], text: "오늘로" },
      { keys: ["N", "PageDown"], text: "다음 기간" },
      { keys: ["P", "PageUp"], text: "이전 기간" },
      { keys: ["M", "W", "D", "A"], text: "월 · 주 · 일 · 목록 보기" },
      { keys: ["C"], text: "일정 추가" }
    ]
  },
  {
    title: "간트 · 칸반 (막대·카드에 포커스)",
    items: [
      { keys: ["←", "→"], text: "간트: 막대 옮기기" },
      { keys: ["Shift+←", "Shift+→"], text: "간트: 끝 날짜 조절" },
      { keys: ["Alt+←", "Alt+→"], text: "간트: 시작 날짜 조절 / 칸반: 옆 열로 옮기기" },
      { keys: ["Enter"], text: "열기" }
    ]
  },
  {
    title: "메뉴",
    items: [
      { keys: ["↓"], text: "메뉴 열기 · 다음 항목" },
      { keys: ["↑", "Home", "End"], text: "이전 · 처음 · 마지막 항목" },
      { keys: ["Esc"], text: "닫고 버튼으로 돌아가기" }
    ]
  }
];
function Y1(e, t, a) {
  return a || t.ctrl || t.alt || t.meta ? !1 : e === "?";
}
const V1 = "_grid_yplhe_1", Q1 = "_group_yplhe_2", J1 = "_h_yplhe_3", Z1 = "_list_yplhe_4", eg = "_row_yplhe_5", tg = "_keys_yplhe_6", ng = "_text_yplhe_7", ag = "_or_yplhe_8", rg = "_kbd_yplhe_9", ct = {
  grid: V1,
  group: Q1,
  h: J1,
  list: Z1,
  row: eg,
  keys: tg,
  text: ng,
  or: ag,
  kbd: rg
};
function sg({ onClose: e, extra: t }) {
  const a = [...t != null ? t : [], ...G1];
  return /* @__PURE__ */ n.createElement(Bn, { title: "단축키", onClose: e, closeOnEsc: !0, confirmDiscard: !1, wide: !0 }, /* @__PURE__ */ n.createElement("div", { className: ct.grid }, a.map((r) => /* @__PURE__ */ n.createElement("section", { key: r.title, className: ct.group }, /* @__PURE__ */ n.createElement("h3", { className: ct.h }, r.title), /* @__PURE__ */ n.createElement("dl", { className: ct.list }, r.items.map((s, o) => /* @__PURE__ */ n.createElement("div", { key: o, className: ct.row }, /* @__PURE__ */ n.createElement("dt", { className: ct.keys }, s.keys.map((l, c) => /* @__PURE__ */ n.createElement("span", { key: l }, c > 0 && /* @__PURE__ */ n.createElement("span", { className: ct.or }, " 또는 "), /* @__PURE__ */ n.createElement("kbd", { className: ct.kbd }, l)))), /* @__PURE__ */ n.createElement("dd", { className: ct.text }, s.text))))))));
}
function og(e) {
  const t = e;
  return !t || typeof t.closest != "function" ? !1 : !!t.closest('input, textarea, select, [contenteditable="true"], [role="combobox"], [role="textbox"]');
}
function B0(e = {}) {
  const { enabled: t = !0, extra: a } = e, [r, s] = D(!1);
  return Z(() => {
    if (!t) return;
    const o = (l) => {
      Y1(l.key, { ctrl: l.ctrlKey, alt: l.altKey, meta: l.metaKey }, og(l.target)) && (document.querySelector('[role="dialog"][aria-modal="true"]') || (l.preventDefault(), s(!0)));
    };
    return document.addEventListener("keydown", o), () => document.removeEventListener("keydown", o);
  }, [t]), { open: () => s(!0), dialog: r ? /* @__PURE__ */ n.createElement(sg, { extra: a, onClose: () => s(!1) }) : null };
}
const tr = 30, lg = BigInt(10);
function Ut(e) {
  let t = BigInt(1);
  for (let a = 0; a < e; a += 1) t = t * lg;
  return t;
}
function dt(e, t = 0) {
  return { u: e, s: t };
}
const Xr = dt(BigInt(0));
function zr(e, t) {
  if (e.s === t.s) return [e.u, t.u, e.s];
  const a = Math.max(e.s, t.s);
  return [e.u * Ut(a - e.s), t.u * Ut(a - t.s), a];
}
function dn(e, t) {
  const [a, r, s] = zr(e, t);
  return dt(a + r, s);
}
function fa(e, t) {
  const [a, r, s] = zr(e, t);
  return dt(a - r, s);
}
function et(e, t) {
  return dt(e.u * t.u, e.s + t.s);
}
function Lt(e, t) {
  if (t.u === BigInt(0)) return null;
  const a = e.u * Ut(t.s + tr), r = t.u * Ut(e.s);
  return dt(a / r, tr);
}
function Fr(e) {
  return dt(-e.u, e.s);
}
function ft(e, t, a) {
  if (t >= e.s)
    return dt(e.u * Ut(t - e.s), t);
  const r = Ut(e.s - t), s = e.u < BigInt(0), o = s ? -e.u : e.u, l = o / r, c = o % r;
  let i;
  return c === BigInt(0) || a === "down" ? i = l : a === "up" ? i = l + BigInt(1) : i = c * BigInt(2) >= r ? l + BigInt(1) : l, dt(s ? -i : i, t);
}
function Ee(e) {
  const t = e.trim().replace(/,/g, "");
  if (!/^[+-]?(\d+(\.\d*)?|\.\d+)$/.test(t)) return null;
  const a = t.startsWith("-"), r = t.replace(/^[+-]/, ""), s = r.indexOf("."), o = s < 0 ? r : r.slice(0, s) + r.slice(s + 1), l = s < 0 ? 0 : r.length - s - 1, c = BigInt(o === "" ? "0" : o);
  return dt(a ? -c : c, l);
}
function _a(e) {
  var a;
  const t = Ee(String(e));
  return t || ((a = Ee(e.toFixed(20))) != null ? a : Xr);
}
function Ke(e, t = e.s, a = !1) {
  const r = ft(e, Math.max(t, 0), "half"), s = r.u < BigInt(0), o = (s ? -r.u : r.u).toString().padStart(t + 1, "0"), l = o.length - t;
  let c = o.slice(0, l);
  const i = o.slice(l);
  return a && (c = c.replace(/\B(?=(\d{3})+(?!\d))/g, ",")), (s ? "-" : "") + c + (t > 0 ? "." + i : "");
}
function aa(e) {
  const t = /^(\d{4})-(\d{2})-(\d{2})$/.exec(e.trim());
  if (!t) return null;
  const a = Number(t[1]), r = Number(t[2]), s = Number(t[3]);
  return r < 1 || r > 12 || s < 1 || s > Le(a, r) ? null : { y: a, m: r, d: s };
}
function Ft({ y: e, m: t, d: a }) {
  const r = Math.floor((14 - t) / 12), s = e + 4800 - r, o = t + 12 * r - 3;
  return a + Math.floor((153 * o + 2) / 5) + 365 * s + Math.floor(s / 4) - Math.floor(s / 100) + Math.floor(s / 400) - 32045;
}
function Wr(e, t) {
  const a = Ft(e) + t + 32044, r = Math.floor((4 * a + 3) / 146097), s = a - Math.floor(146097 * r / 4), o = Math.floor((4 * s + 3) / 1461), l = s - Math.floor(1461 * o / 4), c = Math.floor((5 * l + 2) / 153);
  return {
    d: l - Math.floor((153 * c + 2) / 5) + 1,
    m: c + 3 - 12 * Math.floor(c / 10),
    y: 100 * r + o - 4800 + Math.floor(c / 10)
  };
}
function Hr(e, t, a = "exclude-first") {
  const r = Ft(e) > Ft(t), s = r ? t : e, o = r ? e : t, l = a === "include-first", c = Ft(o) - Ft(s) + (l ? 1 : 0), i = l ? Wr(o, 1) : o;
  let m = i.y - s.y, u = i.m - s.m, f = i.d - s.d;
  if (f < 0) {
    u -= 1;
    const y = i.m === 1 ? 12 : i.m - 1, _ = i.m === 1 ? i.y - 1 : i.y;
    f += Le(_, y);
  }
  return u < 0 && (m -= 1, u += 12), { days: c, y: m, m: u, d: f, swapped: r };
}
function xn(e, t) {
  return Wr(e, t);
}
function nr(e, t) {
  const a = e.y * 12 + (e.m - 1) + t, r = Math.floor(a / 12), s = a % 12 + 1;
  return { y: r, m: s, d: Math.min(e.d, Le(r, s)) };
}
const cg = ["월", "화", "수", "목", "금", "토", "일"];
function ra(e) {
  return cg[Ft(e) % 7];
}
function ze(e) {
  return `${e.y}-${String(e.m).padStart(2, "0")}-${String(e.d).padStart(2, "0")}`;
}
const nn = [
  { code: "KRW", label: "원", per: 1, krw: "1" },
  { code: "JPY", label: "엔", per: 100, krw: "941.20" },
  { code: "USD", label: "달러", per: 1, krw: "1386.50" },
  { code: "EUR", label: "유로", per: 1, krw: "1501.30" },
  { code: "CNY", label: "위안", per: 1, krw: "190.40" },
  { code: "GBP", label: "파운드", per: 1, krw: "1752.80" }
], Gn = {
  원: "KRW",
  엔: "JPY",
  달러: "USD",
  불: "USD",
  유로: "EUR",
  위안: "CNY",
  파운드: "GBP"
};
function ar(e) {
  var t;
  return (t = Gn[e]) != null ? t : e in Gn ? Gn[e] : null;
}
function sa(e, t) {
  return e.find((a) => a.code === t);
}
function Kr(e) {
  return e.code === "KRW" ? "KRW 기준" : `${e.code} ${e.per} = ${e.krw}원`;
}
function Ur(e, t, a, r) {
  const s = sa(e, a), o = sa(e, r);
  if (!s || !o) return null;
  const l = Ee(s.krw), c = Ee(o.krw), i = Ee(String(s.per)), m = Ee(String(o.per));
  if (!l || !c || !i || !m) return null;
  const u = Lt(et(t, l), i);
  if (!u) return null;
  const f = Lt(et(u, m), c);
  return f ? {
    value: ft(f, 2, "half"),
    notice: `${Kr(s)} · 참고용 환율`
  } : null;
}
function ig(e, t) {
  let a = null;
  for (const s of e)
    if (s.value) {
      if (a === null) {
        a = s.sign === "-" ? Fr(s.value) : s.value;
        continue;
      }
      switch (s.sign) {
        case "+":
          a = dn(a, s.value);
          break;
        case "-":
          a = fa(a, s.value);
          break;
        case "*":
          a = et(a, s.value);
          break;
        default: {
          const o = Lt(a, s.value);
          if (!o) return { ok: !1, error: "divide-by-zero" };
          a = o;
          break;
        }
      }
    }
  const r = a != null ? a : Xr;
  return { ok: !0, value: t ? ft(r, t.digits, t.mode) : r };
}
const rr = [
  { key: "+", label: "+", hot: "A" },
  { key: "-", label: "−", hot: "S" },
  { key: "*", label: "×", hot: "D" },
  { key: "/", label: "÷", hot: "F" }
];
function sn() {
  return { sign: "+", text: "" };
}
function ug(e) {
  const t = e.replace(/[^\d.-]/g, ""), a = t.startsWith("-"), r = t.replace(/-/g, ""), s = r.indexOf("."), o = s < 0 ? r : r.slice(0, s), l = s < 0 ? "" : "." + r.slice(s + 1).replace(/\./g, "");
  return (a ? "-" : "") + o.replace(/\B(?=(\d{3})+(?!\d))/g, ",") + l;
}
function mg(e) {
  return e.map((t) => ({ sign: t.sign, value: Ee(t.text) }));
}
function dg(e) {
  const { lines: t, onLines: a, active: r, onActive: s, digits: o, onDigits: l, mode: c, onMode: i } = e, m = L([]), u = Math.min(r, t.length - 1);
  Z(() => {
    var k;
    (k = m.current[u]) == null || k.focus();
  }, [u, t.length]);
  const f = ig(mg(t), { digits: o, mode: c }), y = f.ok ? Ke(f.value, o, !0) : "0으로 나눌 수 없음", _ = (k, x) => {
    a(t.map((E, h) => h === k ? { ...E, ...x } : E));
  }, p = (k = t.length, x = "") => {
    const E = [...t];
    E.splice(k, 0, { ...sn(), text: x }), a(E), s(k);
  }, d = (k) => {
    if (t.length === 1) {
      a([sn()]);
      return;
    }
    a(t.filter((x, E) => E !== k)), s(Math.max(0, k - 1));
  }, b = () => {
    f.ok && p(t.length, Ke(f.value, o, !0));
  }, N = (k, x) => {
    const E = k.key, h = fg(E);
    if (h && !(E === "-" && t[x].text === "")) {
      k.preventDefault(), _(x, { sign: h });
      return;
    }
    if (E === "v" || E === "V") {
      k.preventDefault(), b();
      return;
    }
    E === "Enter" ? (k.preventDefault(), x === t.length - 1 ? p() : s(x + 1)) : E === "ArrowDown" ? (k.preventDefault(), s(Math.min(x + 1, t.length - 1))) : E === "ArrowUp" ? (k.preventDefault(), s(Math.max(x - 1, 0))) : E === "Insert" ? (k.preventDefault(), p(x + 1)) : E === "Delete" && t[x].text === "" ? (k.preventDefault(), d(x)) : E === "F4" && (k.preventDefault(), w());
  }, w = () => {
    a([sn()]), s(0);
  };
  return /* @__PURE__ */ n.createElement("div", { className: "bical-general" }, /* @__PURE__ */ n.createElement("div", { className: "bical-side" }, /* @__PURE__ */ n.createElement("div", { className: "bical-keys" }, /* @__PURE__ */ n.createElement("button", { type: "button", className: "bical-key", onClick: () => p(u + 1) }, "라인추가 (Ins)"), /* @__PURE__ */ n.createElement("button", { type: "button", className: "bical-key", onClick: () => d(u) }, "라인삭제 (Del)"), /* @__PURE__ */ n.createElement("button", { type: "button", className: "bical-key", onClick: b }, "현재금액추가 (V)"), /* @__PURE__ */ n.createElement("button", { type: "button", className: "bical-key", onClick: w }, "초기화 (F4)")), /* @__PURE__ */ n.createElement("div", { className: "bical-sub" }, "부호"), /* @__PURE__ */ n.createElement("div", { className: "bical-keys" }, rr.map((k) => {
    var x;
    return /* @__PURE__ */ n.createElement(
      "button",
      {
        key: k.key,
        type: "button",
        className: "bical-key",
        "aria-pressed": ((x = t[u]) == null ? void 0 : x.sign) === k.key,
        onClick: () => _(u, { sign: k.key })
      },
      k.label,
      " (",
      k.hot,
      ")"
    );
  })), /* @__PURE__ */ n.createElement("div", { className: "bical-sub" }, "결과값 자리수"), /* @__PURE__ */ n.createElement("select", { "aria-label": "결과값 자리수", className: "bical-select", value: o, onChange: (k) => l(Number(k.target.value)) }, [0, 1, 2, 3, 4].map((k) => /* @__PURE__ */ n.createElement("option", { key: k, value: k }, k))), /* @__PURE__ */ n.createElement("div", { className: "bical-sub" }, "표기방법"), /* @__PURE__ */ n.createElement("select", { "aria-label": "표기방법", className: "bical-select", value: c, onChange: (k) => i(k.target.value) }, /* @__PURE__ */ n.createElement("option", { value: "half" }, "반올림"), /* @__PURE__ */ n.createElement("option", { value: "up" }, "올림"), /* @__PURE__ */ n.createElement("option", { value: "down" }, "버림"))), /* @__PURE__ */ n.createElement("div", { style: { flex: 1 } }, /* @__PURE__ */ n.createElement("div", { className: "bical-grid" }, t.map((k, x) => {
    var E;
    return /* @__PURE__ */ n.createElement("div", { key: x, className: `bical-line${x === u ? " bical-line--active" : ""}` }, /* @__PURE__ */ n.createElement("span", { className: "bical-caret" }, x === u ? "❯" : ""), /* @__PURE__ */ n.createElement("span", { className: "bical-sign" }, (E = rr.find((h) => h.key === k.sign)) == null ? void 0 : E.label), /* @__PURE__ */ n.createElement(
      "input",
      {
        ref: (h) => {
          m.current[x] = h;
        },
        value: k.text,
        inputMode: "decimal",
        "aria-label": `${x + 1}번째 금액`,
        onFocus: () => s(x),
        onChange: (h) => _(x, { text: ug(h.target.value) }),
        onKeyDown: (h) => N(h, x)
      }
    ));
  })), /* @__PURE__ */ n.createElement("div", { className: `bical-result${f.ok ? "" : " bical-error"}` }, /* @__PURE__ */ n.createElement("div", { className: "bical-explain" }, "결과값 · 좌→우 순차 계산(연산자 우선순위 없음)"), /* @__PURE__ */ n.createElement("div", { className: "bical-value" }, y))));
}
function fg(e) {
  const t = e.toLowerCase();
  return t === "a" || e === "+" ? "+" : t === "s" || e === "-" ? "-" : t === "d" || e === "*" ? "*" : t === "f" || e === "/" ? "/" : null;
}
function _g(e) {
  const t = [];
  let a = 0;
  for (; a < e.length; ) {
    const r = e[a];
    if (r === " " || r === "	" || r === `
`)
      a += 1;
    else if (r >= "0" && r <= "9" || r === "." || r === ",") {
      let s = a;
      for (; s < e.length && (e[s] >= "0" && e[s] <= "9" || e[s] === "." || e[s] === ","); ) s += 1;
      const o = Ee(e.slice(a, s));
      if (!o) return null;
      t.push({ t: "num", v: o }), a = s;
    } else if (r === "+" || r === "-" || r === "*" || r === "/")
      t.push({ t: "op", v: r }), a += 1;
    else if (r === "(")
      t.push({ t: "(" }), a += 1;
    else if (r === ")")
      t.push({ t: ")" }), a += 1;
    else
      return null;
  }
  return t;
}
class pg {
  constructor(t) {
    this.tokens = t, this.at = 0;
  }
  parse() {
    const t = this.expr();
    return t.ok && this.at !== this.tokens.length ? { ok: !1, error: "syntax" } : t;
  }
  peek() {
    return this.tokens[this.at];
  }
  expr() {
    let t = this.term();
    if (!t.ok) return t;
    for (; ; ) {
      const a = this.peek();
      if (!a || a.t !== "op" || a.v !== "+" && a.v !== "-") return t;
      this.at += 1;
      const r = this.term();
      if (!r.ok) return r;
      t = { ok: !0, value: a.v === "+" ? dn(t.value, r.value) : fa(t.value, r.value) };
    }
  }
  term() {
    let t = this.unary();
    if (!t.ok) return t;
    for (; ; ) {
      const a = this.peek();
      if (!a || a.t !== "op" || a.v !== "*" && a.v !== "/") return t;
      this.at += 1;
      const r = this.unary();
      if (!r.ok) return r;
      if (a.v === "*")
        t = { ok: !0, value: et(t.value, r.value) };
      else {
        const s = Lt(t.value, r.value);
        if (!s) return { ok: !1, error: "divide-by-zero" };
        t = { ok: !0, value: s };
      }
    }
  }
  unary() {
    const t = this.peek();
    if (t && t.t === "op" && (t.v === "+" || t.v === "-")) {
      this.at += 1;
      const a = this.unary();
      return a.ok ? { ok: !0, value: t.v === "-" ? Fr(a.value) : a.value } : a;
    }
    return this.primary();
  }
  primary() {
    const t = this.peek();
    if (!t) return { ok: !1, error: "syntax" };
    if (t.t === "num")
      return this.at += 1, { ok: !0, value: t.v };
    if (t.t === "(") {
      this.at += 1;
      const a = this.expr();
      if (!a.ok) return a;
      const r = this.peek();
      return !r || r.t !== ")" ? { ok: !1, error: "syntax" } : (this.at += 1, a);
    }
    return { ok: !1, error: "syntax" };
  }
}
function yg(e) {
  const t = _g(e);
  return !t || t.length === 0 ? { ok: !1, error: "syntax" } : new pg(t).parse();
}
const on = [
  "산술식 — 1,200만 + 350만 × 2",
  "비율 — 3,000,000의 15%",
  "기간 — 2026-01-01부터 2026-03-31까지 며칠",
  "날짜 가감 — 2026-07-17부터 90일 후",
  "환율 — 150만엔을 원화로 (참고용 환율)"
], bg = /(\d{4})\s*[.\-/년]\s*(\d{1,2})\s*[.\-/월]\s*(\d{1,2})\s*일?/g;
function Eg(e, t) {
  return e.replace(/오늘/g, ze(t)).replace(/내일/g, ze(xn(t, 1))).replace(/어제/g, ze(xn(t, -1)));
}
function hg(e) {
  const t = [];
  for (const a of e.matchAll(bg)) {
    const r = aa(`${a[1]}-${a[2].padStart(2, "0")}-${a[3].padStart(2, "0")}`);
    r && t.push(r);
  }
  return t;
}
const gg = /부터|까지|에서|일수|며칠|기간|차이|~/;
function vg(e, t) {
  if (t.length < 2 || !gg.test(e)) return null;
  const a = /초일\s*산입|양편넣기/.test(e), r = Hr(t[0], t[1], a ? "include-first" : "exclude-first"), s = a ? "초일산입 말일산입" : "초일불산입 말일산입";
  return {
    ok: !0,
    explain: `${ze(t[0])} ~ ${ze(t[1])} 기간(${s})` + (r.swapped ? " · 역순 입력" : ""),
    value: `${r.days}일 (${r.y}년 ${r.m}개월 ${r.d}일)`
  };
}
const kg = /(\d+)\s*(일|주|개월|달|년)\s*(후|뒤|이후|전|이전)/;
function wg(e, t) {
  if (t.length !== 1) return null;
  const a = kg.exec(e);
  if (!a) return null;
  const r = Number(a[1]), s = a[3] === "전" || a[3] === "이전", o = s ? -r : r, l = t[0];
  let c;
  return a[2] === "일" ? c = xn(l, o) : a[2] === "주" ? c = xn(l, o * 7) : a[2] === "년" ? c = nr(l, o * 12) : c = nr(l, o), {
    ok: !0,
    explain: `${ze(l)} 에서 ${r}${a[2]} ${s ? "전" : "후"}`,
    value: `${ze(c)} (${ra(c)})`
  };
}
function Ng(e, t) {
  if (t.length === 0) return null;
  const a = /([\d,]+(?:\.\d+)?)\s*(억|천만|백만|십만|만|천)?\s*(엔|달러|불|유로|위안|파운드|원)/.exec(e);
  if (!a) return null;
  const r = a[2] ? Gr(a[2]) : null, s = Ee(a[1]);
  if (!s) return null;
  const o = r ? et(s, r) : s, l = ar(a[3]);
  if (!l) return null;
  const i = l !== "KRW" ? "KRW" : ar($g(e));
  if (!i || i === l) return null;
  const m = Ur(t, o, l, i);
  return m ? {
    ok: !0,
    explain: `${Ke(o, o.s, !0)} ${l} → ${i} · ${m.notice}`,
    value: `${Ke(m.value, 2, !0)} ${i}`
  } : null;
}
function $g(e) {
  const t = /(?:을|를|으로|로)\s*(엔|달러|불|유로|위안|파운드|원)/.exec(e);
  return t ? t[1] : "원";
}
const xg = {
  억: "100000000",
  천만: "10000000",
  백만: "1000000",
  십만: "100000",
  만: "10000",
  천: "1000",
  백: "100"
};
function Gr(e) {
  var t;
  return (t = Ee(xg[e])) != null ? t : _a(1);
}
const Dg = /((?:[\d,]+(?:\.\d+)?\s*(?:억|천만|백만|십만|만|천|백)\s*)+(?:[\d,]+(?:\.\d+)?)?)/g, Ag = /([\d,]+(?:\.\d+)?)\s*(억|천만|백만|십만|만|천|백)?/g;
function Cg(e) {
  return e.replace(Dg, (t) => {
    let a = Ee("0"), r = !1;
    for (const s of t.matchAll(Ag)) {
      const o = Ee(s[1]);
      o && (r = !0, a = dn(a, s[2] ? et(o, Gr(s[2])) : o));
    }
    return r ? Ke(a, a.s) : t;
  });
}
const Sg = /원화|원|엔|씩|개월|개|명|건/g;
function Mg(e) {
  return Cg(e).replace(/(\d),(?=\d)/g, "$1").replace(/[×xX]/g, "*").replace(/÷/g, "/").replace(/더하기|플러스/g, "+").replace(/빼기|마이너스/g, "-").replace(/곱하기/g, "*").replace(/나누기/g, "/").replace(Sg, "").replace(/([\d.]+)\s*의\s*([\d.]+)\s*%/g, "($1*($2/100))").replace(/([\d.]+)\s*([+-])\s*([\d.]+)\s*%/g, "(($1)*(1$2$3/100))").trim();
}
const Tg = /[+＋]?\s*(부가세|소비세|消費税)\s*(?:([\d.]+)\s*%)?\s*(가산|포함|税込|税抜)?\s*$/;
function qg(e, t, a) {
  const r = Ee("1"), s = Ke(et(t, _a(100)), 0);
  if (a === "add")
    return {
      value: ft(et(e, dn(r, t)), 0, "half"),
      explain: `消費税 ${s}% 가산(税抜 기준)`
    };
  const o = Lt(et(e, t), dn(r, t));
  return {
    value: o ? ft(o, 0, "down") : e,
    explain: `消費税 ${s}% 역산(税込 기준 · 1円 미만 切捨て)`
  };
}
function Bg(e, t) {
  var i;
  const a = e.trim();
  if (!a) return { ok: !1, supported: on };
  const r = Eg(a, t.today), s = hg(r), o = vg(r, s);
  if (o) return o;
  const l = wg(r, s);
  if (l) return l;
  const c = Ng(r, (i = t.rates) != null ? i : []);
  return c || Lg(r, t);
}
function Lg(e, t) {
  var m, u;
  const a = Tg.exec(e), r = a ? e.slice(0, a.index) : e, s = Mg(r);
  if (!s) return { ok: !1, supported: on };
  const o = yg(s);
  if (!o.ok)
    return { ok: !1, supported: on };
  if (!a)
    return { ok: !0, explain: s, value: sr(o.value), expr: s };
  const l = (u = (m = jg(a[2])) != null ? m : t.taxRate) != null ? u : null;
  if (!l)
    return {
      ok: !1,
      supported: ["소비세율을 아직 받지 못했습니다 — 세제개정 기준값을 불러오면 계산합니다", ...on]
    };
  const c = a[3] === "가산" || a[3] === "税抜" ? "add" : "extract", i = qg(o.value, l, c);
  return {
    ok: !0,
    explain: `${s} · ${i.explain}`,
    value: sr(i.value),
    expr: s
  };
}
function jg(e) {
  var a;
  if (!e) return null;
  const t = Ee(e);
  return t && (a = Lt(t, _a(100))) != null ? a : null;
}
function sr(e) {
  const t = ft(e, 2, "half"), a = ft(t, 0, "down");
  return fa(t, a).u === BigInt(0) ? Ke(t, 0, !0) : Ke(t, 2, !0);
}
const He = {
  area: {
    label: "넓이",
    base: "㎡",
    units: [
      { key: "m2", label: "㎡", factor: "1" },
      { key: "are", label: "아르", factor: "100" },
      { key: "ha", label: "헥타르", factor: "10000" },
      { key: "km2", label: "㎢", factor: "1000000" },
      { key: "pyeong", label: "평", factor: "3.305785" },
      { key: "ft2", label: "ft²", factor: "0.09290304" },
      { key: "yd2", label: "yd²", factor: "0.83612736" },
      { key: "acre", label: "에이커", factor: "4046.8564224" }
    ]
  },
  mass: {
    label: "중량·질량",
    base: "g",
    units: [
      { key: "mg", label: "mg", factor: "0.001" },
      { key: "g", label: "g", factor: "1" },
      { key: "kg", label: "kg", factor: "1000" },
      { key: "t", label: "t", factor: "1000000" },
      { key: "don", label: "돈", factor: "3.75" },
      { key: "geun", label: "근", factor: "600" },
      { key: "oz", label: "oz", factor: "28.349523125" },
      { key: "lb", label: "lb", factor: "453.59237" }
    ]
  },
  length: {
    label: "길이",
    base: "m",
    units: [
      { key: "mm", label: "mm", factor: "0.001" },
      { key: "cm", label: "cm", factor: "0.01" },
      { key: "m", label: "m", factor: "1" },
      { key: "km", label: "km", factor: "1000" },
      { key: "in", label: "in", factor: "0.0254" },
      { key: "ft", label: "ft", factor: "0.3048" },
      { key: "yd", label: "yd", factor: "0.9144" },
      { key: "mile", label: "mile", factor: "1609.344" },
      { key: "shaku", label: "자(尺)", factor: "0.30303" }
    ]
  }
};
function or(e, t) {
  const a = He[e].units.find((s) => s.key === t);
  if (!a) return null;
  const r = Ee(a.factor);
  if (!r) throw new Error("단위 변환 정보를 불러오지 못했습니다");
  return r;
}
function Rg(e, t, a, r, s = 4, o = "half") {
  const l = or(e, t), c = or(e, a);
  if (!l || !c) return null;
  const i = Lt(et(r, l), c);
  return i ? ft(i, s, o) : null;
}
const Ig = [0, 1, 2, 3, 4, 6], Og = [
  { key: "text", label: "AI 텍스트계산" },
  { key: "general", label: "일반계산" },
  { key: "date", label: "날짜계산" },
  { key: "unit", label: "단위계산" },
  { key: "fx", label: "환율계산" }
];
function Pg(e) {
  const { tab: t, onTab: a, seed: r, onClose: s, history: o, onHistory: l } = e, [c, i] = D(() => r == null ? [sn()] : [{ sign: "+", text: Ke(Ug(r), 0, !0) }]), [m, u] = D(0), [f, y] = D(0), [_, p] = D("half"), d = L(null);
  Z(() => {
    const N = (w) => {
      w.key === "Escape" && (w.preventDefault(), s());
    };
    return document.addEventListener("keydown", N), () => document.removeEventListener("keydown", N);
  }, [s]), Z(() => {
    var N, w;
    (w = (N = d.current) == null ? void 0 : N.querySelector("[data-autofocus]")) == null || w.focus();
  }, [t]);
  const b = (N) => {
    const w = [...c.filter((k) => k.text !== ""), { sign: "+", text: N }, sn()];
    i(w), u(w.length - 1), a("general");
  };
  return /* @__PURE__ */ n.createElement("div", { className: "bical-overlay", role: "presentation" }, /* @__PURE__ */ n.createElement("div", { className: "bical-modal", role: "dialog", "aria-modal": "true", "aria-label": "계산기", ref: d }, /* @__PURE__ */ n.createElement("div", { className: "bical-head" }, /* @__PURE__ */ n.createElement("span", { className: "bical-title" }, "계산기"), /* @__PURE__ */ n.createElement("span", { className: "bical-hint" }, "장부에 쓰지 않습니다 — 복사·일반계산 추가로만 내보냅니다"), /* @__PURE__ */ n.createElement("button", { type: "button", className: "bical-x", "aria-label": "닫기", onClick: s }, "✕")), /* @__PURE__ */ n.createElement("div", { className: "bical-tabs", role: "tablist" }, Og.map((N) => /* @__PURE__ */ n.createElement(
    "button",
    {
      key: N.key,
      type: "button",
      role: "tab",
      className: "bical-tab",
      "aria-selected": N.key === t,
      onClick: () => a(N.key)
    },
    N.label
  ))), /* @__PURE__ */ n.createElement("div", { className: "bical-body" }, t === "text" && /* @__PURE__ */ n.createElement(Fg, { history: o, onHistory: l, onPush: b }), t === "general" && /* @__PURE__ */ n.createElement(
    dg,
    {
      lines: c,
      onLines: i,
      active: m,
      onActive: u,
      digits: f,
      onDigits: y,
      mode: _,
      onMode: p
    }
  ), t === "date" && /* @__PURE__ */ n.createElement(Wg, null), t === "unit" && /* @__PURE__ */ n.createElement(Hg, null), t === "fx" && /* @__PURE__ */ n.createElement(Kg, null)), /* @__PURE__ */ n.createElement("div", { className: "bical-foot" }, /* @__PURE__ */ n.createElement("button", { type: "button", className: "bical-btn", onClick: s }, "닫기"))));
}
const Xg = [
  "1,200만 + 350만 × 2",
  "3,000,000의 15%",
  "2026-01-01부터 2026-03-31까지 며칠",
  "2026-07-17부터 90일 후",
  "150만엔을 원화로",
  "오늘부터 10일 후"
], zg = 20;
function Fg({ history: e, onHistory: t, onPush: a }) {
  var p;
  const [r, s] = D(""), [o, l] = D(null), [c, i] = D(!1), [m, u] = D(!1), f = L(!1), y = we(pa, []), _ = (d) => {
    s(d), u(!1);
    const b = Bg(d, { today: y, rates: nn, taxRate: null });
    l(b), d.trim() && t([d, ...e.filter((N) => N !== d)].slice(0, zg));
  };
  return /* @__PURE__ */ n.createElement("div", null, /* @__PURE__ */ n.createElement(
    "textarea",
    {
      className: "bical-textarea",
      "aria-label": "계산할 문장",
      "data-autofocus": !0,
      value: r,
      placeholder: "문장으로 물어보세요 — Enter 계산 · Shift+Enter 줄바꿈",
      onChange: (d) => s(d.target.value),
      onCompositionStart: () => {
        f.current = !0;
      },
      onCompositionEnd: () => {
        f.current = !1;
      },
      onKeyDown: (d) => {
        d.key === "Enter" && !d.shiftKey && !f.current && !d.nativeEvent.isComposing && (d.preventDefault(), _(r));
      }
    }
  ), /* @__PURE__ */ n.createElement("div", { className: "bical-chips" }, Xg.map((d) => /* @__PURE__ */ n.createElement("button", { key: d, type: "button", className: "bical-chip", onClick: () => _(d) }, d))), o && (o.ok ? /* @__PURE__ */ n.createElement("div", { className: "bical-result" }, /* @__PURE__ */ n.createElement("div", { className: "bical-explain" }, o.explain), /* @__PURE__ */ n.createElement("div", { className: "bical-value" }, o.value), /* @__PURE__ */ n.createElement("div", { className: "bical-chips" }, /* @__PURE__ */ n.createElement(
    "button",
    {
      type: "button",
      className: "bical-btn",
      onClick: () => {
        var d;
        (d = navigator.clipboard) == null || d.writeText(o.value).then(
          () => u(!0),
          () => u(!1)
        );
      }
    },
    m ? "복사함" : "결과복사"
  ), /* @__PURE__ */ n.createElement("button", { type: "button", className: "bical-btn", onClick: () => a(o.value) }, "일반계산에 추가"))) : /* @__PURE__ */ n.createElement("div", { className: "bical-result bical-notice" }, /* @__PURE__ */ n.createElement("div", { className: "bical-explain" }, "읽지 못했습니다 — 지원하는 형식입니다"), /* @__PURE__ */ n.createElement("ul", { style: { margin: "4px 0 0", paddingLeft: 16 } }, ((p = o.supported) != null ? p : on).map((d) => /* @__PURE__ */ n.createElement("li", { key: d }, d))))), e.length > 0 && /* @__PURE__ */ n.createElement("div", { className: "bical-log" }, /* @__PURE__ */ n.createElement("button", { type: "button", onClick: () => i((d) => !d) }, "기록 ", e.length, "건 ", c ? "접기" : "펼치기"), c && /* @__PURE__ */ n.createElement("ol", null, e.map((d) => /* @__PURE__ */ n.createElement("li", { key: d }, /* @__PURE__ */ n.createElement("button", { type: "button", onClick: () => _(d) }, d))))), /* @__PURE__ */ n.createElement("div", { className: "bical-sub", style: { marginTop: 8 } }, "기록은 이 세션에만 남고 저장하지 않습니다."));
}
function Wg() {
  const e = we(pa, []), [t, a] = D(ze(e)), [r, s] = D(ze(e)), [o, l] = D("exclude-first"), c = aa(t), i = aa(r), m = c && i ? Hr(c, i, o) : null;
  return /* @__PURE__ */ n.createElement("div", null, /* @__PURE__ */ n.createElement("div", { className: "bical-row" }, /* @__PURE__ */ n.createElement("span", { className: "bical-label" }, "계산 방식"), /* @__PURE__ */ n.createElement("select", { "aria-label": "계산 방식", className: "bical-select", value: o, onChange: (u) => l(u.target.value) }, /* @__PURE__ */ n.createElement("option", { value: "exclude-first" }, "초일불산입 말일산입"), /* @__PURE__ */ n.createElement("option", { value: "include-first" }, "초일산입 말일산입"))), /* @__PURE__ */ n.createElement("div", { className: "bical-row" }, /* @__PURE__ */ n.createElement("span", { className: "bical-label" }, "기간"), /* @__PURE__ */ n.createElement("input", { "aria-label": "시작일", className: "bical-input", type: "date", "data-autofocus": !0, value: t, onChange: (u) => a(u.target.value) }), /* @__PURE__ */ n.createElement("span", null, "~"), /* @__PURE__ */ n.createElement("input", { "aria-label": "종료일", className: "bical-input", type: "date", value: r, onChange: (u) => s(u.target.value) })), m ? /* @__PURE__ */ n.createElement("div", { className: "bical-result" }, /* @__PURE__ */ n.createElement("div", { className: "bical-explain" }, ze(c), "(", ra(c), ") ~ ", ze(i), "(", ra(i), ")", m.swapped ? " · 역순 입력" : ""), /* @__PURE__ */ n.createElement("div", { className: "bical-value" }, m.days.toLocaleString(), "일"), /* @__PURE__ */ n.createElement("div", { className: "bical-sub" }, "차이(년, 월, 일) — ", m.y, "년 ", m.m, "개월 ", m.d, "일")) : /* @__PURE__ */ n.createElement("div", { className: "bical-result bical-notice" }, "날짜를 두 개 모두 입력하세요."));
}
function Hg() {
  const [e, t] = D("area"), [a, r] = D(He.area.units[0].key), [s, o] = D(He.area.units[4].key), [l, c] = D(""), [i, m] = D(4), [u, f] = D("half"), y = (d) => {
    t(d), r(He[d].units[0].key), o(He[d].units[1].key), c("");
  }, _ = Ee(l), p = _ ? Rg(e, a, s, _, i, u) : null;
  return /* @__PURE__ */ n.createElement("div", null, /* @__PURE__ */ n.createElement("div", { className: "bical-row" }, /* @__PURE__ */ n.createElement("span", { className: "bical-label" }, "분류"), /* @__PURE__ */ n.createElement("select", { "aria-label": "분류", className: "bical-select", value: e, onChange: (d) => y(d.target.value) }, Object.keys(He).map((d) => /* @__PURE__ */ n.createElement("option", { key: d, value: d }, He[d].label))), /* @__PURE__ */ n.createElement("span", { className: "bical-sub" }, "기준 ", He[e].base)), /* @__PURE__ */ n.createElement("div", { className: "bical-row" }, /* @__PURE__ */ n.createElement("span", { className: "bical-label" }, "값"), /* @__PURE__ */ n.createElement(
    "input",
    {
      className: "bical-input bical-num",
      "aria-label": "값",
      "data-autofocus": !0,
      inputMode: "decimal",
      value: l,
      onChange: (d) => c(d.target.value.replace(/[^\d.-]/g, ""))
    }
  ), /* @__PURE__ */ n.createElement("select", { "aria-label": "변환 전 단위", className: "bical-select", value: a, onChange: (d) => r(d.target.value) }, He[e].units.map((d) => /* @__PURE__ */ n.createElement("option", { key: d.key, value: d.key }, d.label))), /* @__PURE__ */ n.createElement("span", null, "→"), /* @__PURE__ */ n.createElement("select", { "aria-label": "변환 후 단위", className: "bical-select", value: s, onChange: (d) => o(d.target.value) }, He[e].units.map((d) => /* @__PURE__ */ n.createElement("option", { key: d.key, value: d.key }, d.label)))), /* @__PURE__ */ n.createElement("div", { className: "bical-row" }, /* @__PURE__ */ n.createElement("span", { className: "bical-label" }, "자리수"), /* @__PURE__ */ n.createElement("select", { "aria-label": "자리수", className: "bical-select", value: i, onChange: (d) => m(Number(d.target.value)) }, Ig.map((d) => /* @__PURE__ */ n.createElement("option", { key: d, value: d }, d))), /* @__PURE__ */ n.createElement("select", { "aria-label": "표기 방법", className: "bical-select", value: u, onChange: (d) => f(d.target.value) }, /* @__PURE__ */ n.createElement("option", { value: "half" }, "반올림"), /* @__PURE__ */ n.createElement("option", { value: "up" }, "올림"), /* @__PURE__ */ n.createElement("option", { value: "down" }, "버림"))), /* @__PURE__ */ n.createElement("div", { className: "bical-result" }, /* @__PURE__ */ n.createElement("div", { className: "bical-explain" }, lr(e, a), " → ", lr(e, s), " · 기준단위 1단계 환산"), /* @__PURE__ */ n.createElement("div", { className: "bical-value" }, p ? Ke(p, i, !0) : "—")));
}
function lr(e, t) {
  var a, r;
  return (r = (a = He[e].units.find((s) => s.key === t)) == null ? void 0 : a.label) != null ? r : t;
}
function Kg() {
  const e = we(pa, []), [t, a] = D(ze(e)), [r, s] = D("JPY"), [o, l] = D("KRW"), [c, i] = D(""), m = Ee(c), u = m ? Ur(nn, m, r, o) : null, f = sa(nn, r);
  return /* @__PURE__ */ n.createElement("div", null, /* @__PURE__ */ n.createElement("div", { className: "bical-row" }, /* @__PURE__ */ n.createElement("span", { className: "bical-label" }, "기준일자"), /* @__PURE__ */ n.createElement("input", { "aria-label": "기준일자", className: "bical-input", type: "date", value: t, onChange: (y) => a(y.target.value) })), /* @__PURE__ */ n.createElement("div", { className: "bical-row" }, /* @__PURE__ */ n.createElement("span", { className: "bical-label" }, "금액"), /* @__PURE__ */ n.createElement(
    "input",
    {
      className: "bical-input bical-num",
      "aria-label": "금액",
      "data-autofocus": !0,
      inputMode: "decimal",
      value: c,
      onChange: (y) => i(y.target.value.replace(/[^\d.-]/g, ""))
    }
  ), /* @__PURE__ */ n.createElement("select", { "aria-label": "변환 전 통화", className: "bical-select", value: r, onChange: (y) => s(y.target.value) }, nn.map((y) => /* @__PURE__ */ n.createElement("option", { key: y.code, value: y.code }, y.code, " (", y.label, ")"))), /* @__PURE__ */ n.createElement("span", null, "→"), /* @__PURE__ */ n.createElement("select", { "aria-label": "변환 후 통화", className: "bical-select", value: o, onChange: (y) => l(y.target.value) }, nn.map((y) => /* @__PURE__ */ n.createElement("option", { key: y.code, value: y.code }, y.code, " (", y.label, ")")))), /* @__PURE__ */ n.createElement("div", { className: "bical-result" }, /* @__PURE__ */ n.createElement("div", { className: "bical-explain" }, f ? Kr(f) : ""), /* @__PURE__ */ n.createElement("div", { className: "bical-value" }, u ? Ke(u.value, 2, !0) : "—")), /* @__PURE__ */ n.createElement("div", { className: "bical-result bical-notice" }, /* @__PURE__ */ n.createElement("b", null, "참고용 환율입니다."), " 토·일·공휴일 데이터가 없고, 기준통화·전신환 구분(TTM/TTS/TTB)도 정해지지 않았습니다. 신고·장부 목적에 쓰지 마세요."));
}
function pa() {
  const e = /* @__PURE__ */ new Date();
  return { y: e.getFullYear(), m: e.getMonth() + 1, d: e.getDate() };
}
function Ug(e) {
  var t;
  return ft((t = Ee(String(e))) != null ? t : Ee("0"), 0, "half");
}
const Yr = An(null);
function L0({ children: e }) {
  const [t, a] = D(!1), [r, s] = D("text"), [o, l] = D(null), [c, i] = D([]), [m, u] = D(0), f = we(() => ({
    open: (y) => {
      var _, p;
      s((_ = y == null ? void 0 : y.tab) != null ? _ : "text"), l((p = y == null ? void 0 : y.seed) != null ? p : null), u((d) => d + 1), a(!0);
    },
    close: () => a(!1)
  }), []);
  return /* @__PURE__ */ n.createElement(Yr.Provider, { value: f }, e, t && /* @__PURE__ */ n.createElement(
    Pg,
    {
      key: m,
      tab: r,
      onTab: s,
      seed: o,
      onClose: f.close,
      history: c,
      onHistory: i
    }
  ));
}
function j0() {
  var e;
  return (e = Dn(Yr)) != null ? e : { open: () => {
  }, close: () => {
  } };
}
class R0 extends cr {
  constructor() {
    super(...arguments), this.rootRef = Jr(), this.resizeSensor = null;
  }
  componentDidMount() {
    this.rootRef.current && (this.resizeSensor = new _r(this.rootRef.current, this.props.onResize));
  }
  componentWillUnmount() {
    this.resizeSensor && (this.resizeSensor.detach(), this.resizeSensor = null);
  }
  render() {
    const { onResize: t, children: a, ...r } = this.props;
    return /* @__PURE__ */ n.createElement("div", { ref: this.rootRef, ...r }, a);
  }
}
export {
  e0 as $,
  M0 as A,
  zv as B,
  Pg as C,
  E0 as D,
  uv as E,
  lo as F,
  ac as G,
  Ec as H,
  iv as I,
  gn as J,
  Vn as K,
  h0 as L,
  n0 as M,
  a0 as N,
  la as O,
  N0 as P,
  i0 as Q,
  m0 as R,
  d0 as S,
  Sv as T,
  Bn as U,
  Mv as V,
  hf as W,
  Bv as X,
  u0 as Y,
  ls as Z,
  Qg as _,
  Vs as a,
  Y1 as a$,
  w0 as a0,
  cv as a1,
  b0 as a2,
  o0 as a3,
  c0 as a4,
  Jp as a5,
  l0 as a6,
  y_ as a7,
  r0 as a8,
  D0 as a9,
  jt as aA,
  yv as aB,
  qv as aC,
  mv as aD,
  kr as aE,
  _0 as aF,
  f0 as aG,
  Sr as aH,
  gf as aI,
  G1 as aJ,
  $r as aK,
  Gt as aL,
  R0 as aM,
  _r as aN,
  Hn as aO,
  yr as aP,
  Tv as aQ,
  Yu as aR,
  E_ as aS,
  Jn as aT,
  ri as aU,
  si as aV,
  Er as aW,
  Gv as aX,
  X_ as aY,
  il as aZ,
  Rv as a_,
  Fv as aa,
  lv as ab,
  ev as ac,
  ov as ad,
  u_ as ae,
  sg as af,
  tv as ag,
  av as ah,
  nv as ai,
  vv as aj,
  hv as ak,
  Ev as al,
  x0 as am,
  rv as an,
  t0 as ao,
  Ra as ap,
  $0 as aq,
  gv as ar,
  sv as as,
  fr as at,
  C0 as au,
  S0 as av,
  i_ as aw,
  Cs as ax,
  q0 as ay,
  Wv as az,
  Ef as b,
  fl as b0,
  ip as b1,
  Ys as b2,
  Jg as b3,
  dl as b4,
  pr as b5,
  k0 as b6,
  Dh as b7,
  Ah as b8,
  $n as b9,
  dv as bA,
  dc as bB,
  _v as bC,
  bc as bD,
  Nr as bE,
  Kv as bF,
  j0 as bG,
  jv as bH,
  vf as bI,
  Hv as bJ,
  Lv as bK,
  Pv as bL,
  Ov as bM,
  s0 as bN,
  bv as bO,
  Iv as bP,
  B0 as bQ,
  Zg as bR,
  T0 as bS,
  pv as bT,
  Yt as bU,
  $y as bV,
  Pt as ba,
  f_ as bb,
  Zt as bc,
  Lr as bd,
  __ as be,
  ja as bf,
  xv as bg,
  $c as bh,
  hc as bi,
  h_ as bj,
  jr as bk,
  U_ as bl,
  ml as bm,
  br as bn,
  ul as bo,
  Qs as bp,
  W_ as bq,
  v0 as br,
  yb as bs,
  Wt as bt,
  Rr as bu,
  xr as bv,
  Av as bw,
  Pu as bx,
  $v as by,
  fv as bz,
  p0 as c,
  mt as d,
  L0 as e,
  Cv as f,
  vr as g,
  A0 as h,
  g0 as i,
  er as j,
  Qv as k,
  Nv as l,
  wv as m,
  kv as n,
  Yv as o,
  Vv as p,
  Zv as q,
  Da as r,
  Dv as s,
  y0 as t,
  Br as u,
  cl as v,
  P_ as w,
  Uv as x,
  Jv as y,
  Xv as z
};
